import React, { Component } from 'react';
import axios from 'axios';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import { Toolbar, Data } from 'react-data-grid-addons';
import { debounce } from 'lodash';
import ReactPaginate from 'react-paginate';
import { Field } from 'redux-form';
import {
  Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input,
  Dropdown, MenuItem, DropdownButton,
} from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import GenericDatePicker from '../Common/GenericDatePicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import {SALES_ORDERS_URL, YING_BOL_URL, MAG_DRAYAGE_LIST,YING_CUSTOMER_FILE, EMAIL_UPDATE, EMAIL_POD, COMPLETE_OB, CHANGE_TRACKING_URL, GET_PICKUP_URL, GET_QUOTE_URL, CHANGE_OB_STATUS_URL, ADD_TRACKING_URL, RESYNC_URL, ASSIGN_BOL_URL} from '../../actions/url';
import SpinnerButton from '../Common/SpinnerButton';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import CashFormatter from '../Common/cashFormatter';
import { DatePicker } from '../Common/datePicker';
import { Selection, SelectionWithProps } from '../Common/selection';
import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import { toFromDates } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import genericRadioFilter from '../Common/genericRadioFilter';
import { numberWithCommas } from '../Common/numberWithCommas';
import dateFilterRadios from '../Common/dateFilterRadios';
import dispatchFilterRadios from '../Common/dispatchFilterRadios';
import PercentFormatter from '../Common/percentFormatter';
import checkPermission from '../Common/permissions';
import checkPermissionLocal from '../Common/permissions';
import { WeightChangeModalMulti } from '../Common/weightChangeModalMulti';
import { BOLListModal } from '../Common/bolListModal';
import { DSQPrintModal } from '../Common/dsqPrintModal';
import { WIZPODModal } from '../Common/wizPODModal';
import { GenerateBOLModal } from '../Common/generateBOLModal';
import { SplitTrackingNumberModal } from '../Common/SplitTrackingNumberModal';
import PaymentMethodModal from './PaymentMethodModal';
import AltonChildModal from '../Common/AltonChildModal';
import BolImagesTable from './components/BolImagesTable';
import salesOrderModals from "../Common/modals/salesOrder";
import Dropzone from 'react-dropzone';
import EmailContentModal from './components/EmailContentModal';
import {
  submitBolImage, podUpload, podUPloadSCM, generateSOWithExcelUSPride,
  expressMultipleSOInvoices, uploadMSO
} from '../../actions/sales_actions';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isSnapwise, isLucky88, isRivera } from "../../actions/root_url";

const {
  DriverListModal, ISAEditModal, CTNEditModal, LocationChange, InboundDateChange,
  DeliveryTimeChange, PickupTimeChange, ExcelUploadOption, LabelPrintModal,
  ShippingRateModal,
} = salesOrderModals;

const isMyuMyu =
  ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
const isCalco =
  ROOT_API_URL === "https://calco-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://calco-stage.truckxi.com/api/";
const isEcity =
  ROOT_API_URL === "https://ct-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/";
const isHMM =
  ROOT_API_URL === "https://hmm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://hmm-scm.truckxi.com/api/";
const isAFG =
  ROOT_API_URL === "https://afg-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afgstage-scm.truckxi.com/api/";
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === "https://wecom-scm.truckxi.com/api/";
const isCO = ROOT_API_URL === "https://co-scm.truckxi.com/api/";
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isSY = ROOT_API_URL === "https://admin.apoodr.com/api/";
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";
const isUSPride =
  ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" ||
  ROOT_URL === "https://uspride-scm.truckxi.com/api/";
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isGV = ROOT_API_URL === 'https://scm.gvyummyus.com/api/' || ROOT_URL === 'https://scm.gvyummyus.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isFIT = ROOT_API_URL === 'https://fit-scm.truckxi.com/api/' || ROOT_URL === 'https://fit-scm.truckxi.com/api/';
const isNBT = ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || ROOT_URL === 'https://nbt-scm.truckxi.com/api/';
const isKM = ROOT_API_URL === 'https://kingmax-scm.truckxi.com/api/' || ROOT_URL === 'https://kingmax-scm.truckxi.com/api/';
const isTQ = ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/'|| ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
const isATL = ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || ROOT_URL === 'https://alton-scm.truckxi.com/api/';
const isRS = ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isYI = ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || ROOT_URL === 'https://ying-scm.truckxi.com/api/';
const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
const isEZone = ROOT_API_URL === 'https://ezone-scm.truckxi.com/api/' || ROOT_URL === 'https://ezone-scm.truckxi.com/api/';
const isWUFS = ROOT_API_URL === 'https://wufs-scm.truckxi.com/api/' || ROOT_URL === 'https://wufs-scm.truckxi.com/api/';
const isSW = ROOT_API_URL === 'https://snapwise-scm.truckxi.com/api/' || ROOT_URL === 'https://snapwise-scm.truckxi.com/api/';
const isCS = ROOT_API_URL === 'https://coastsequoia-scm.truckxi.com/api/' || ROOT_URL === 'https://coastsequoia-scm.truckxi.com/api/';
const isLO = ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
const isAmzey = ROOT_API_URL === 'https://amzey-scm.truckxi.com/api/' || ROOT_URL === 'https://amzey-scm.truckxi.com/api/';
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';
const isAPO = ROOT_API_URL === 'https://admin.apoodr.com/api/' || ROOT_URL === 'https://admin.apoodr.com/api/';

const {
  Draggable: {
    Container: DraggableContainer,
    RowActionsCell,
    DropTargetRowContainer,
  },
  Data: { Selectors },
} = require("react-data-grid-addons");

class SalesOrder extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
      clear: true,

      salesOrders: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      salesOrderDetail: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      magSalesOrderDetail: {

      },

      shippingPdfFrameLoaded: true,
      pickingListPdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      salesOrderPdfFrameLoaded: true,
      bolIdPdfFrameLoaded: true,
      bolWithoutLogPdfFrameLoaded: true,
      bolFbaPdfFrameLoaded: true,
      bolLabelFrameLoaded: true,

      suggestValue: "",
      searchType: "invoiceNo",
      days: isABC ? "90" : isUSPride ? "2" : "7",
      FromDate: undefined,
      ToDate: undefined,
      filteredByItem: false,
      Status: "all",
      rowsCount: 0,
      total: 0,
      canceledOrders: 0,
      canceledTotal: 0,
      dispatchDays: null,
      dispatchDateGT: undefined,
      dispatchDateLT: undefined,

      checkAuthorizeOpen: false,
      action: null,
      title: "Quote",
      breadcrumbTitle: "mobile_sales_order",
      changeWeightOpen: false,
      displayTrackingOpen: false,
      changeTrackingOpen: false,

      trackingFormOpen: false,
      trackingformNum: null,
      trackingformCarrier: null,
      trackingformMethod: null,

      newTrackingNum: null,
      newTrackingNumID: null,
      BLNum: null,
      SealNum: null,
      ProNum: null,
      Carrier: null,
      changePullSheetOpen: false,
      confirmReshipOpen: false,
      confirmQuoteOpen: false,
      showDriverImageOpen: false,
      submitImageOpen: false,
      printBolOpen: false,
      finalShippingWeight: 0,
      pullSheetAmount: 0,
      pullSheetSort: "",
      scrollTopPositionIndex: null,
      trackingNumberSelected: null,
      invoiceNoSearchTerm: "",
      trackingNoSearchTerm: "",

      bolListModalVisibility: false,
      generateBOLModalVisibility: false,
      dsqPrintVisibility: false,
      wizPODVisibility: false,
      openAssignBolVisibility: false,
      isAltonChildVisible: false,
      altonSelectedProd: null,

      paymentMethodModalVisibility: false,
      voidNoteModalVisibility: false,
      voidReason: "",
      voidNote: "",

      chowbusModalVisibility: false,
      chowbusImportFile: null,

      xpoString: {},
      xpoQuoteVisibility: false,
      pickupLoading: false,

      pickupSelectionVisibility: false,
      xpoPickupDate: null,
      xpoReadyDate: null,
      xpoCloseDate: null,

      pickupString: "",
      pickupVisibility: false,
      xpoLoading: false,

      openDownloadModalVisibility: false,
      openDownloadModalUrl: null,
      openDownloadModalLoading: false,

      mag1: {
      DRYRUN: false,
      OFFHIRE: false,
      PIERPASS: false,
      AN_FEE: false,
      OTHER: false,
      HANDLING: false,
      EXTRA_STOP: false,
      EXAM: false,
      EXTRA_DELIVERY: false,
      STORAGE: false,
      BOBTAIL_FEE: false,
      CHASSIS_SPLIT: false,
      CTF: false,
      FSC: false,
      PREPULL: false,
      CONGESTION: false,
      DROPOFF: false,
      OVERWEIGHT: false,
      },

      mag2: {
        FREIGHT_HOLD: false,
        CUSTOM_HOLD: false,
        PIERPASS_HOLD: false,
        EXAM: false,
        CLOSED_AREA: false,
        },

      rows: [],
      file: [],
      bolAddressFBA: "",

      quoteSelectedCustomerId: null,
      quoteSelectedCustomerName: "",
      quoteSelectedCustomerPlaceholder: "",
      quoteCustomerOptions: [],

      excelCustomerOptions: [],

      davisPOVisibility: false,
      driverListModalVisibility: false,
      isaEditModalVisibility: false,
      ctnEditModalVisibility: false,

      drayageListOptions: [],
      warehouseOptions: [],

      limit: isABC ? 25 : null,
      limitDisplay: isABC ? '25' : 'all',
      drayageSelected: null,
      drayageListDisplay: "",
      currentPage: 0,
      searchFilter: {
        SONum: '',
        CompanyName: '',
        FBACode: '',
        CustomerBOLNo: '',
        IsaNo: '',
        ContainerNo: '',
        ShippingStatus: '',
      },

      pridePrintVisibility: false,

      assigningInboundDriver: false,
      assigningOutboundDriver: false,
      PODIframeLoaded: false,
      selectedPODFile: '',
      abcDatePickerShow: true,

      isLocationChangeModalVisible: false,

      addTrackingOpen: false,
      addTrackingNumber: null,

      isExpressShipVisibility: false,
      expressShipDate: null,


      USPrideCreateOpen: false,
      USPridePlatform: "",
      USPrideCustomer: "",
      USPrideCreateLoading: false,

      isInboundDateChangeModalVisibile: false,
      deliveryTimeSelectVisible: false,
      pickupTimeSelectVisible: false,
      isExcelUploadOptionVisible: false,
      isLabelPrintModalVisible: false,
      emailContentModalVisibility: false,
      isShipingRateVisible: false,
    };

    this.closeAssignBol = this.closeAssignBol.bind(this);
    this.openAssignBol = this.openAssignBol.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.openExpressShipVisibility = this.openExpressShipVisibility.bind(this);
    this.closeExpressShipVisibility = this.closeExpressShipVisibility.bind(this);

    this.closeChangeTracking = this.closeChangeTracking.bind(this);

    this.printForm = this.printForm.bind(this);
    this.loadsPost = this.loadsPost.bind(this);
    this.fetchSalesOrdersByDetails = this.fetchSalesOrdersByDetails.bind(this);
    this.fetchSalesOrdersByDispatch = this.fetchSalesOrdersByDispatch.bind(
      this
    );
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    this.onDrop = this.onDrop.bind(this);
    // this.renderImage = this.renderImage.bind(this);
    this.renderDriverImage = this.renderDriverImage.bind(this);
    this.closeConfirmQuote = this.closeConfirmQuote.bind(this);

    this.openGenerateBOLModal = this.openGenerateBOLModal.bind(this);
    this.closeGenerateBOLModal = this.closeGenerateBOLModal.bind(this);

    this.openDSQPrint = this.openDSQPrint.bind(this);
    this.closeDSQPrint = this.closeDSQPrint.bind(this);

    this.openWIZPOD = this.openWIZPOD.bind(this);
    this.closeWIZPOD = this.closeWIZPOD.bind(this);
  }

  componentDidMount() {
    let {warehouseOptions} = this.state;
    if (isUSPride) {
      // warehouseOptions.push({label: "All", value: 999});
      axios
      .get(
        `${ROOT_URL}v1/warehouse/`,
        {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`,},},
      )
      .then(
        (res) => {
          res.data.map(r=>{
            warehouseOptions.push({label: r.Name, value: r.Warehouse_id});
          });
          this.setState({warehouseOptions});
        },
        (err) => {
          if (err.data) {
            alert(err.data);
          } else {
            alert("Server issue detected, please contact admin.");
          }
        }
      );
      // this.props.setValue("salesOrders", "Warehouse_id", 999);
    }

    let drayageListOptions = [];
    if (isKDW) {
    axios.get(
      MAG_DRAYAGE_LIST,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      drayageListOptions = response.data;
      if  (response && response.data) {
        response.data.map(r=>{
          drayageListOptions.push({label: r.name + ": " + r.address, value: r.id})
        })
      }

      // drayageListOptions.rows.map((r, index) => {
      //   r.Idx = index++;
      // })
      this.setState({drayageListOptions});
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });

    }

    window.addEventListener("resize", this.handleResize);
    document.title = companyCodeTitle;
    if (isABC) {
      // this.grid.onToggleFilter()
    }
    const salesOrdersFilter = this.props.salesOrdersFilter;
    const route = this.context.router.routes[1].path;
    if (salesOrdersFilter && route === salesOrdersFilter.currentPage) {
      const selectedRows = salesOrdersFilter.currentRows.filter((r, idx) => {
        if (r.isSelected === true) {
          this.setState({
            scrollTopPositionIndex: idx,
          }, () => {
            if (idx !== null) {
              var top = 25 * this.state.scrollTopPositionIndex;
              var gridCanvas = this.grid
                .getDataGridDOMNode()
                .querySelector(".react-grid-Canvas");
              gridCanvas.scrollTop = top;
            }
          });
        }
        return r.isSelected === true;
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: salesOrdersFilter.currentRows,
        selectedRows,
        filters: {},
      };
      this.setState({
        salesOrders,
        Status: salesOrdersFilter.Status,
        FromDate: salesOrdersFilter.FromDate,
        ToDate: salesOrdersFilter.ToDate,
        days: salesOrdersFilter.Days,
      });
      this.props.setValue("salesOrders", "Seller", salesOrdersFilter.Seller);
      this.props.setValue("salesOrders", "ProductNum", salesOrdersFilter.ProductNum);

      let fromDate = "1900-01-01";
      if (salesOrdersFilter.FromDate) {
        fromDate = this.formatDate(salesOrdersFilter.FromDate);
      }
      let toDate = "3000-01-01";
      if (salesOrdersFilter.ToDate) {
        toDate = this.formatDate(salesOrdersFilter.ToDate);
      }
      let seller = salesOrdersFilter.Seller;
      if (salesOrdersFilter.Seller) {
        seller = salesOrdersFilter.Seller.value;
      }
      // this.props.fetchSalesOrdersByFilter(
      //   fromDate,
      //   toDate,
      //   salesOrdersFilter.Days,
      //   salesOrdersFilter.Status,
      //   seller,
      //   salesOrdersFilter.ProductNum,
      //   route,
      //   null,
      //   null,
      //   null,
      //   this.state.limit,
      //   this.state.currentPage,
      //   this.state.searchFilter,
      //   this.props.Warehouse_id,
      // );
      this.props.fetchBaseUsers();
      this.props.fetchBolAddress();
    } else {
      const fromDate = "1900-01-01";
      const toDate = "3000-01-01";
      let days = isABC ? "90" : isUSPride ? "2" : "7";
      if (isMAG) { days = "30"; }
      if (isABCFF) { days = "1"; }

      let status = "all";
      if (isRivera) { status = "open"; }

      if (route === "mobileSalesOrders") {
        if (isMyuMyu || isAFG || isWecom || isJML) {
          days = "1";
        } else if (isABC) {
          status = 'all';
        } else {
          status = "open";
        }
      }
      this.props.setDefaultDays("salesOrders");
      this.setState({ Status: status, days }, () =>
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          status,
          null,
          null,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        ),
      );
      this.props.fetchBaseUsers();
      this.props.fetchBolAddress();
    }
    if (salesOrdersFilter && route !== salesOrdersFilter.currentPage) {
      this.props.setSalesOrdersFilter(null);
    }
    this.handleBreadCrumbTitle();
    this.props.fetchCustomers();
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setSalesOrdersFilter(null);
    }
    window.removeEventListener("resize", this.handleResize);
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    const route = this.context.router.routes[1].path;
    if (
      nextProps.checkPasswordSuccess &&
      nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess
    ) {
      this.closeCheckAuthorize();
      if (this.state.action === "void") {
        if (isAFG) {
          this.openVoidNote();
        } else {
          this.voidOrder();
        }
      }
    }
    if (
      nextProps.salesOrders &&
      nextProps.salesOrders !== this.props.salesOrders
    ) {
      // Split Weight
      if (
        this.state.salesOrders.selectedRows &&
        this.state.salesOrders.selectedRows.length === 1
      ) {
        nextProps.salesOrders.Orders.map((orders) => {
          if (orders.SONum === this.state.salesOrders.selectedRows[0].SONum) {
            this.state.salesOrders.selectedRows[0].FinalShippingWeight =
              orders.FinalShippingWeight;
          }
        });
      }
      this.setState({ total: nextProps.salesOrders.Total });
      if (
        this.props.salesOrdersFilter &&
        this.props.salesOrdersFilter.currentRows &&
        this.context.router.routes[1].path ===
          this.props.salesOrdersFilter.currentPage
      ) {
        this.setState({
          salesOrders: {
            ...this.state.salesOrders,
            rows: nextProps.salesOrders.Orders,
            filters: {},
            selectedRows: [] //whenever sales order list changed, set selected row empty
          },
          salesOrderDetail:{
            ...this.state.salesOrderDetail,
            rows: []
          },
        })
        // this filter preserve logic is causing bugs

        // const salesOrders = nextProps.salesOrders.Orders;
        // let rows = salesOrders.map((order) => {
        //   if (
        //     order.InvoiceNum ===
        //       this.state.salesOrders.selectedRows[0].InvoiceNum &&
        //     order.SONum === this.state.salesOrders.selectedRows[0].SONum
        //   ) {
        //     return {
        //       ...order,
        //       isSelected: true,
        //     };
        //   } else {
        //     return {
        //       ...order,
        //       isSelected: false,
        //     };
        //   }
        // });
        // const newSalesOrders = {
        //   ...this.state.salesOrders,
        //   rows,
        //   selectedRows: this.state.salesOrders.selectedRows || [],
        // };
        // if (this.props.salesOrderDetail) {
        //   var salesOrderDetail = {
        //     ...this.state.salesOrderDetail,
        //     rows: this.props.salesOrderDetail.Sales_Order_Lines,
        //   };
        //   this.setState({ salesOrderDetail });
        // }
        // this.setState({ salesOrders: newSalesOrders });
        // this.props.setSalesOrdersFilter(null);
      } else {
        const salesOrders = {
          ...this.state.salesOrders,
          rows: nextProps.salesOrders.Orders,
          filters: {},
          selectedRows: [] //whenever sales order list changed, set selected row empty
        };
        // for (var i = 0; i < salesOrders.rows.length; i++) {
        //   if (
        //     salesOrders.selectedRows[0] &&
        //     salesOrders.rows[i].InvoiceNum ===
        //       salesOrders.selectedRows[0].InvoiceNum &&
        //     salesOrders.rows[i].SONum === salesOrders.selectedRows[0].SONum
        //   ) {
        //     salesOrders.rows[i].isSelected = true;
        //   }
        // }
        var salesOrderDetail = { ...this.state.salesOrderDetail, rows: [] };
        this.setState({ salesOrders, salesOrderDetail });
        this.props.setSalesOrdersFilter(null);
      }

      if (this.state.scrollTopPositionIndex !== null) {
        var top = 25 * this.state.scrollTopPositionIndex;
        if (this.grid) {
          var gridCanvas = this.grid
            .getDataGridDOMNode()
            .querySelector(".react-grid-Canvas");
          gridCanvas.scrollTop = top;
        }
      }
    }

    if (
      nextProps.salesOrderDetail &&
      nextProps.salesOrderDetail !== this.props.salesOrderDetail
    ) {
      var salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: nextProps.salesOrderDetail.Sales_Order_Lines,
      };

      this.state.mag1 = {};
      let mag1TempSplit = [];
      if (isMAG && nextProps.salesOrderDetail.mag_note) {
        mag1TempSplit = nextProps.salesOrderDetail.mag_note.split(',');
        mag1TempSplit.map(r=>{
          if (r === 'DRYRUN') {this.state.mag1.DRYRUN = true;}
          if (r === 'OFFHIRE') {this.state.mag1.OFFHIRE = true;}
          if (r === 'PIERPASS') {this.state.mag1.PIERPASS = true;}
          if (r === 'AN_FEE') {this.state.mag1.AN_FEE = true;}
          if (r === 'OTHER') {this.state.mag1.OTHER = true;}
          if (r === 'HANDLING') {this.state.mag1.HANDLING = true;}
          if (r === 'EXTRA_STOP') {this.state.mag1.EXTRA_STOP = true;}
          if (r === 'EXAM') {this.state.mag1.EXAM = true;}
          if (r === 'EXTRA_DELIVERY') {this.state.mag1.EXTRA_DELIVERY = true;}
          if (r === 'STORAGE') {this.state.mag1.STORAGE = true;}
          if (r === 'BOBTAIL_FEE') {this.state.mag1.BOBTAIL_FEE = true;}
          if (r === 'CHASSIS_SPLIT') {this.state.mag1.CHASSIS_SPLIT = true;}
          if (r === 'CTF') {this.state.mag1.CTF = true;}
          if (r === 'FSC') {this.state.mag1.FSC = true;}
          if (r === 'PREPULL') {this.state.mag1.PREPULL = true;}
          if (r === 'CONGESTION') {this.state.mag1.CONGESTION = true;}
          if (r === 'DROPOFF') {this.state.mag1.DROPOFF = true;}
          if (r === 'OVERWEIGHT') {this.state.mag1.OVERWEIGHT = true;}
         });
      }

      this.state.mag2 = {};
      let mag2TempSplit = [];
      if (isMAG && nextProps.salesOrderDetail.DeliveryStatus) {
        mag2TempSplit = nextProps.salesOrderDetail.DeliveryStatus.split(',');
        mag2TempSplit.map(r=>{
          if (r === 'FREIGHT_HOLD') {this.state.mag2.FREIGHT_HOLD = true;}
          if (r === 'CUSTOM_HOLD') {this.state.mag2.CUSTOM_HOLD = true;}
          if (r === 'PIERPASS_HOLD') {this.state.mag2.PIERPASS_HOLD = true;}
          if (r === 'EXAM') {this.state.mag2.EXAM = true;}
          if (r === 'CLOSED_AREA') {this.state.mag2.CLOSED_AREA = true;}
         });
      }

      this.setState({ magSalesOrderDetail: {} });
      this.setState({ salesOrderDetail, magSalesOrderDetail: nextProps.salesOrderDetail });
    }

    if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
      const salesOrdersFilter = this.props.salesOrdersFilter;
      if (!salesOrdersFilter) {
        let seller = nextProps.Seller;
        if (nextProps.Seller) {
          seller = nextProps.Seller.value;
        }
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : "1900-01-01";
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : "3000-01-01";
        const days = this.state.days;

        // if (fromDate == null) {
        //   fromDate = '1900-01-01';
        // }
        // if (toDate == null) {
        //   toDate = '3000-01-01';
        // }
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      }
    }

    if (this.props.Seller && nextProps.Seller == null) {
      const seller = nextProps.Seller;
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : "1900-01-01";
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : "3000-01-01";
      const days = this.state.days;

      // if (fromDate == null) {
      //   fromDate = '1900-01-01';
      // }
      // if (toDate == null) {
      //   toDate = '3000-01-01';
      // }
      const productNum = this.state.filterProductID;
      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        this.state.days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.props.Warehouse_id,
      );
    }





    if (nextProps.Warehouse_id && nextProps.Warehouse_id !== this.props.Warehouse_id) {
      const salesOrdersFilter = this.props.salesOrdersFilter;
      if (!salesOrdersFilter) {
        let warehouse = nextProps.Warehouse_id;
        if (nextProps.Warehouse_id) {
          warehouse = nextProps.Warehouse_id.value;
        }
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : "1900-01-01";
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : "3000-01-01";
        const days = this.state.days;
        const seller = this.props.Seller;

        // if (fromDate == null) {
        //   fromDate = '1900-01-01';
        // }
        // if (toDate == null) {
        //   toDate = '3000-01-01';
        // }
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          warehouse,
        );
      }
    }

    if (this.props.Warehouse_id && nextProps.Warehouse_id == null) {
      const warehouse = nextProps.Warehouse_id;
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : "1900-01-01";
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : "3000-01-01";
      const days = this.state.days;

      // if (fromDate == null) {
      //   fromDate = '1900-01-01';
      // }
      // if (toDate == null) {
      //   toDate = '3000-01-01';
      // }
      const productNum = this.state.filterProductID;
      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        this.state.days,
        this.state.Status,
        this.props.Seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        warehouse,
      );
    }



    if (
      nextProps.shippingListPDF &&
      nextProps.shippingListPDF !== this.props.shippingListPDF
    ) {
      this.setState({ shippingPdfFrameLoaded: false });
    }

    if (
      nextProps.pickingListPDF &&
      nextProps.pickingListPDF !== this.props.pickingListPDF
    ) {
      this.setState({ pickingListPdfFrameLoaded: false });
    }

    if (
      nextProps.packingListPDF &&
      nextProps.packingListPDF !== this.props.packingListPDF
    ) {
      this.setState({ packingListPdfFrameLoaded: false });
    }

    if (
      nextProps.salesOrderPDF &&
      nextProps.salesOrderPDF !== this.props.salesOrderPDF
    ) {
      this.setState({ salesOrderPdfFrameLoaded: false });
    }
    if (nextProps.bolIdPDF && nextProps.bolIdPDF !== this.props.bolIdPDF) {
      this.setState({ bolIdPdfFrameLoaded: false });
    }
    if (nextProps.bolWithoutLogPDF && nextProps.bolWithoutLogPDF !== this.props.bolWithoutLogPDF) {
      this.setState({ bolWithoutLogPdfFrameLoaded: false });
    }
    if (nextProps.bolLabel && nextProps.bolLabel !== this.props.bolLabel) {
      this.setState({ bolLabelFrameLoaded: false });
    }
    if (nextProps.bolFbaPDF && nextProps.bolFbaPDF !== this.props.bolFbaPDF) {
      this.setState({ bolFbaPdfFrameLoaded: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded &&
      this.state.shippingPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.pickingListPdfFrameLoaded !==
        this.state.pickingListPdfFrameLoaded &&
      this.state.pickingListPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.packingListPdfFrameLoaded !==
        this.state.packingListPdfFrameLoaded &&
      this.state.packingListPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.salesOrderPdfFrameLoaded !==
        this.state.salesOrderPdfFrameLoaded &&
      this.state.salesOrderPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolIdPdfFrameLoaded !== this.state.bolIdPdfFrameLoaded &&
      this.state.bolIdPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolWithoutLogPdfFrameLoaded !== this.state.bolWithoutLogPdfFrameLoaded &&
      this.state.bolWithoutLogPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolLabelFrameLoaded !== this.state.bolLabelFrameLoaded &&
      this.state.bolLabelFrameLoaded === false
    ) {
      return false;
    }

    if (
      nextState.bolFbaPdfFrameLoaded !== this.state.bolFbaPdfFrameLoaded &&
      this.state.bolFbaPdfFrameLoaded === false
    ) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.salesOrders !== this.state.salesOrders) {
      let canceledTotal = 0;
      const canceledOrders = this.state.salesOrders.rows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        if (match) {
          canceledTotal += row.FinalPrice;
        }
        return match;
      });
      this.setState({
        rowsCount: Data.Selectors.getRows(this.state.salesOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
      });
    }
  }

  setDriverListModalVisibility = (driverListModalVisibility = false) =>
    this.setState({ driverListModalVisibility });
  handleAssignSOToDriverSuccess = () => {
    this.setDriverListModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  };
  setISAEditModalVisibility = (isaEditModalVisibility = false) => this.setState({ isaEditModalVisibility });
  setCTNEditModalVisibility = (ctnEditModalVisibility = false) => this.setState({ ctnEditModalVisibility });

  handleISANoUpdateSuccess = () => {
    this.setISAEditModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  }

  openPridePrint = () => {
    this.setState({ pridePrintVisibility: true });
  }
  closePridePrint = () => {
    this.setState({ pridePrintVisibility: false });
  }
  onConfirmPridePrint = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    const salesOrder_id = [];
    selectedRows.forEach(({ SalesOrder_id }) => {
      salesOrder_id.push(SalesOrder_id);
    });
    this.props.printSalesOrderLabelUSPride({ salesOrder_id });
    this.closePridePrint();
  }

  handleCTNNoUpdateSuccess = () => {
    this.setCTNEditModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  }
  openDavisPO = () => {
    this.setState({ davisPOVisibility: true });
  };
  closeDavisPO = () => {
    this.setState({ davisPOVisibility: false });
  };
  onConfirmDavisPO() {
    const { salesOrders } = this.state;
    if (
      salesOrders &&
      salesOrders.selectedRows &&
      salesOrders.selectedRows[0]
    ) {
      this.props.setDavisPO(salesOrders.selectedRows[0].SalesOrder_id);
    }
    this.setState({ davisPOVisibility: false });

    // const route = this.context.router.routes[1].path;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    // const days = this.state.days;
    // const productNum = this.state.filterProductID;
    // const seller = this.props.Seller;
    // setTimeout(() => {
    //   this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route);
    // }, 1000);
  }

  setAltonChildVisibility = (isAltonChildVisible = false) => this.setState({ isAltonChildVisible });

  openChowbusModal = () => {
    this.setState({ chowbusModalVisibility: true });
  };
  closeChowbusModal = () => {
    this.setState({ chowbusModalVisibility: false, chowbusImportFile: null });
  };
  onChangeChowbusImport = (event) => {
    this.setState({ chowbusImportFile: event.target.files[0] });
  };
  onConfirmChowbusImport() {
    if (!this.state.chowbusImportFile) {
      alert("Please select a file to import");
      return;
    }
    const data = new FormData();
    data.append("file", this.state.chowbusImportFile);
    this.props.chowbusImport(data).then(
      (response) => {
        alert("Chowbus Orders Imported");
        this.closeChowbusModal();
      },
      (err) => {
        alert("Import Error:" + err.data);
      },
    );
  }

  openVoidNote = () => {
    this.setState({ voidNoteModalVisibility: true });
  };
  closeVoidNote = () => {
    this.setState({
      voidNoteModalVisibility: false,
      voidReason: "",
      voidNote: "",
    });
  };
  onVoidReasonChange = (e) => {
    this.setState({ voidReason: e.value });
  };
  onVoidNoteChange = (e) => {
    this.state.voidNote = e.target.value;
  };
  onConfirmVoidNote() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let voidString = "";
    if (this.state.voidReason) {
      voidString = this.state.voidReason + ": ";
    }
    voidString += this.state.voidNote;
    this.props.updateVoidNote(salesOrder_id, voidString);
    setTimeout(() => {
      this.voidOrder();
    }, 1000);
    this.closeVoidNote();
  }

  closePrintTrackingConfirm = () => {
    this.setState({ printTrackingConfirmOpen: false });
  };
  openPrintTrackingConfirm = () => {
    this.setState({ printTrackingConfirmOpen: true });
  };
  printTrackingConfirm = () => {
    const { trackingNumberSelected } = this.state;
    this.props.printSalesOrderLabelBatch(trackingNumberSelected);
    this.setState({ printTrackingConfirmOpen: false });
  };

  openTrackingForm() {
    this.setState({
      trackingFormOpen: true,
      trackingformNum: null,
      trackingformCarrier: null,
      trackingformMethod: null,
    });
  }
  closeTrackingForm() {
    this.setState({ trackingFormOpen: false });
  }
  onChangeFormNum = (e) => {
    this.setState({ trackingformNum: e.target.value });
  };
  onChangeFormCarrier = (e) => {
    this.setState({ trackingformCarrier: e.target.value });
  };
  onChangeFormMethod = (e) => {
    this.setState({ trackingformMethod: e.target.value });
  };
  confirmTrackingForm = () => {
    const singleSalesOrderId =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    let data = {
      tracking: this.state.trackingformNum,
      carrier: this.state.trackingformCarrier,
      ship_method: this.state.trackingformMethod,
    };

    axios.post(
      `${ROOT_URL}v2/shipping/add_tracking_num/${singleSalesOrderId}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Tracking Info Added");
      this.fetchSalesOrdersByDetails(this.state.days);
      this.closeTrackingForm();
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };


  openDisplayTracking() {
    this.setState({ displayTrackingOpen: true });
  }
  closeDisplayTracking() {
    this.setState({ displayTrackingOpen: false });
  }

  openChangeTracking(val, dep) {
    this.setState({ changeTrackingOpen: true, newTrackingNum: val, newTrackingNumID: dep.SalesOrder_id });
  }
  closeChangeTracking() {
    this.setState({ changeTrackingOpen: false });
  }
  onChangeTrackingNum = (e) => {
    this.setState({ newTrackingNum: e.target.value });
  };
  changeTrackingConfirm = () => {
    const { salesOrders } = this.state;
    let data = {delivery_tracking_num: this.state.newTrackingNum};
    if (isUSPride) {
      data = {Tracking: this.state.newTrackingNum};
    }
    // let data = null;
    // if (salesOrders && salesOrders.selectedRows) {
    //   salesOrders.selectedRows[0].delivery_tracking_num = this.state.newTrackingNum;
    //   data = salesOrders.selectedRows[0];
    // }

    // axios here
    axios.put(
      (CHANGE_TRACKING_URL + this.state.newTrackingNumID),
      // (SALES_ORDERS_URL + this.state.newTrackingNumID),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Tracking Number Changed");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
      this.setState({ changeTrackingOpen: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });

    // const route = this.context.router.routes[1].path;
    // this.props.fetchSalesOrdersByFilter(
    //   this.state.FromDate,
    //   this.state.ToDate,
    //   this.state.days,
    //   this.state.Status,
    //   null,
    //   null,
    //   route,
    //   this.state.dispatchDateLT,
    //   this.state.dispatchDateGT,
    //   null,
    //   this.state.limit,
    //   this.state.currentPage,
    //   this.state.searchFilter,
    // );
  };

  onChangeBolNumber = (e) => {
    this.setState({ BLNum: e.target.value });
  };
  onChangeSealNumber = (e) => {
    this.setState({ SealNum: e.target.value });
  };
  onChangeProNumber = (e) => {
    this.setState({ ProNum: e.target.value });
  };
  onChangeCarrierNumber = (e) => {
    this.setState({ Carrier: e.target.value });
  };
  confirmChangeBolNumber = () => {
    const { salesOrders } = this.state;
    let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let ids = salesOrderIds.join(",");

    // axios here
    axios.put(
      (ASSIGN_BOL_URL + ids),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("BOL Number Assigned");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
      this.setState({ openAssignBolVisibility: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };

  confirmGetPickup = () => {
    const { salesOrders } = this.state;
    // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let ids = salesOrderIds.join(",");
    let pickupString = "";
    this.setState({ xpoLoading: true });
    // axios here
    axios.get(
      (GET_PICKUP_URL + ids),
      // (GET_QUOTE_URL + 6),
      // data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      pickupString = JSON.stringify(response.data.data.pickupRequestInfo, null, 2);
      this.setState({ pickupVisibility: true, pickupString, xpoLoading: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
      this.setState({ xpoLoading: false });
    });
  };

  confirmGetQuote = () => {
    const { salesOrders } = this.state;
    // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let ids = salesOrderIds.join(",");
    let xpoString = {};
    this.setState({ xpoLoading: true });
    axios.get(
      (GET_QUOTE_URL + ids),
      // (GET_QUOTE_URL + 6),
      // data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      // xpoString = JSON.stringify(response.data, null, 2);
      xpoString = response.data;
      this.setState({ xpoQuoteVisibility: true, xpoString, xpoLoading: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
      this.setState({ xpoLoading: false });
    });
  };

  setPickupDate(e) {
    this.setState({ xpoPickupDate: e });
  }
  setReadyDate(e) {
    this.setState({ xpoReadyDate: e });
  }
  setCloseDate(e) {
    this.setState({ xpoCloseDate: e });
  }

  confirmPostPickup = () => {
    const { salesOrders, xpoPickupDate, xpoReadyDate, xpoCloseDate } = this.state;
    // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let ids = salesOrderIds.join(",");
    let pickupString = "";
    let data = {
      pickup: xpoPickupDate,
      ready: xpoReadyDate,
      close: xpoCloseDate,
    };
    this.setState({ xpoLoading: true, pickupLoading: true });
    axios.post(
      (GET_PICKUP_URL + ids),
      // (GET_QUOTE_URL + 6),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Pickup Created: " + JSON.stringify(response.data, null, 2));
      this.setState({ pickupSelectionVisibility: false, xpoLoading: false, pickupLoading: false });
      // pickupString = JSON.stringify(response.data, null, 2);
      // this.setState({ pickupSelectionVisibility: false, pickupVisibility: true, pickupString, xpoLoading: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data.message));
      this.setState({ xpoLoading: false, pickupLoading: false });
    });
  };

  confirmPostQuote = () => {
    const { salesOrders } = this.state;
    // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let ids = salesOrderIds.join(",");
    let xpoString = "";
    let data = null;
    this.setState({ xpoLoading: true });
    axios.post(
      (GET_QUOTE_URL + ids),
      // (GET_QUOTE_URL + 6),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Quote Created. Quote ID: " + response.data);
      this.setState({ xpoLoading: false });
      // xpoString = JSON.stringify(response.data, null, 2);
      // this.setState({ xpoQuoteVisibility: true, xpoString, xpoLoading: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
      this.setState({ xpoLoading: false });
    });
  };


  confirmCreateBOL = () => {
    const { salesOrders } = this.state;
    // let data = {DestinationAddress_id: this.state.drayageSelected, BLNum: this.state.BLNum, SealNum: this.state.SealNum, ProNum: this.state.ProNum, Carrier: this.state.Carrier};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    let data = null;
    let ids = salesOrderIds.join(",");
    axios.post(
      (YING_BOL_URL + ids),
      // (GET_QUOTE_URL + 6),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      // alert("BOL Number Assigned");
      // this.fetchSalesOrdersByDetails(
      //   this.state.days
      // );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };

  openAddTracking() {
    this.setState({
      addTrackingOpen: true,
      addTrackingNumber: null,
    });
  }

  closeAddTracking() {
    this.setState({ addTrackingOpen: false });
  }

  confirmAddTracking = () => {
    const { salesOrders } = this.state;
    let data = {addTrackingNumber: this.state.addTrackingNumber};
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let ids = salesOrderIds.join(",");
    axios.put(
      (ADD_TRACKING_URL + ids),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Added Tracking Number");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
      this.setState({ addTrackingOpen: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };


  openChangeWeight() {
    this.setState({
      changeWeightOpen: true,
      finalShippingWeight: this.state.salesOrders.selectedRows[0]
        .FinalShippingWeight,
    });
  }

  openbolListModal() {
    this.setState({ bolListModalVisibility: true });
  }
  closebolListModal() {
    this.setState({ bolListModalVisibility: false });
  }

  openDSQPrint() {
    this.setState({ dsqPrintVisibility: true });
  }
  closeDSQPrint() {
    this.setState({ dsqPrintVisibility: false });
  }

  openWIZPOD() {
    this.setState({ wizPODVisibility: true });
  }
  closeWIZPOD() {
    this.setState({ wizPODVisibility: false });
  }

  openAssignBol() {
    this.setState({ openAssignBolVisibility: true, BLNum: null, SealNum: null, ProNum: null, Carrier: null });
  }
  closeAssignBol() {
    this.setState({ openAssignBolVisibility: false });
  }

  openExpressShipVisibility() {
    this.setState({ isExpressShipVisibility: true });
  }
  closeExpressShipVisibility() {
    this.setState({ isExpressShipVisibility: false });
  }

  setExpressShipDate(e) {
    this.setState({ expressShipDate: e });
  }

  confirmExpressShip = () => {
    const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesOrder_id);
    const success = () => {
      if (isTN) {
        this.closeExpressShipVisibility();
      }
      this.refreshSOList();
    }
    if (isTN && !this.state.expressShipDate) {
      alert("Please select a ship date");
      return;
    }
    expressMultipleSOInvoices(soPKs, success, this.state.expressShipDate);
  };

  openGenerateBOLModal() {
    this.setState({ generateBOLModalVisibility: true });
  }
  closeGenerateBOLModal() {
    this.setState({ generateBOLModalVisibility: false });
  }

  openChangePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: true,
    });
  }

  closePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: false,
    });
  }

  handleSOPaymentMethodSaved = (so_id, method) => {
    this.closePaymentMethodModal();
    const salesOrderRows = [...this.state.salesOrders.rows];
    const newRows = salesOrderRows.map((row) => {
      if (row.SalesOrder_id === so_id) {
        return {
          ...row,
          PaymentType: method,
        };
      }
      return row;
    });
    this.setState({
      salesOrders: {
        ...this.state.salesOrders,
        rows: newRows,
      },
    });
    // const route = this.context.router.routes[1].path;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    // const days = this.state.days;
    // const productNum = this.state.filterProductID;
    // const seller = this.props.Seller;
    // setTimeout(() => {
    //   this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route);
    // }, 1000);
  };

  closeChangeWeight() {
    this.setState({ changeWeightOpen: false });
  }
  onChangeWeightSubmit = (splitArray) => {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.props.updateShippingWeightSplit(salesOrder_id, splitArray);
    this.setState({ changeWeightOpen: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : "1900-01-01";
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : "3000-01-01";
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;
    setTimeout(() => {
      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.props.Warehouse_id,
      );
    }, 1000);
  };
  onChangeWeightSubmitPrint = (splitArray) => {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    if (
      this.state.salesOrders.selectedRows[0].InvoiceNum === "" ||
      !this.state.salesOrders.selectedRows[0].InvoiceNum
    ) {
      alert("Cannot print without Invoice Number");
      return;
    }
    this.props.updateShippingWeightSplit(salesOrder_id, splitArray);
    this.setState({ changeWeightOpen: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : "1900-01-01";
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : "3000-01-01";
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;
    this.props.fetchSalesOrdersByFilter(
      fromDate,
      toDate,
      days,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      null,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.props.Warehouse_id,
    );
    const SalesOrder_id = [];
    SalesOrder_id.push(salesOrder_id);
    setTimeout(() => {
      this.props.printSalesOrderLabelBatch(SalesOrder_id);
    }, 1000);
  };

  onShippingWeightChange = (e) => {
    this.setState({
      finalShippingWeight: e.target.value,
    });
  };

  openConfirmReship() {
    this.setState({ confirmReshipOpen: true });
  }
  closeConfirmReship() {
    this.setState({ confirmReshipOpen: false });
  }
  onConfirmReship() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.props.reshipOrder(salesOrder_id);
    this.setState({ confirmReshipOpen: false });
  }

  // USPride create with excel modal
  openUSPrideCreate() {
    let { customers } = this.props;
    let {excelCustomerOptions } = this.state;
    if (isABCFF) {
      if (customers) {
        customers.map((r) => {
          excelCustomerOptions.push({ label: r.Name, value: r.Customer_id });
        });
      }
      this.setState({excelCustomerOptions});
    }
    this.setState({USPrideCreateOpen: true });
  }
  closeUSPrideCreate() {
    this.setState({ USPrideCreateOpen: false });
  }
  onUSPridePlatformChange = (e) => {
    if (e && e.value) {
      this.setState({ USPridePlatform: e.value });
    } else {
      this.setState({ USPridePlatform: "" });
    }
  };

  onUSPrideCustomerChange = (e) => {
    if (e && e.value) {
      this.setState({ USPrideCustomer: e.value });
    } else {
      this.setState({ USPrideCustomer: "" });
    }
  };

  sendEmailUpdate = (val) => {
    let joinedString = val.join(',');
    let data = null;
    axios.post(
      (EMAIL_UPDATE + joinedString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Email Update Sent!");
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  sendEmailPod = (val) => {
    let joinedString = val.join(',');
    let data = null;
    axios.post(
      (EMAIL_POD + joinedString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Email Update Sent!");
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  completeOB = (val) => {
    let joinedString = val.join(',');
    let data = null;
    axios.post(
      (COMPLETE_OB + joinedString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Outbound Order Completed!");
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  changeOutboundStatus = (ids, val) => {
    let joinedString = ids.join(',');
    let data = {OutboundStatus: val};
    axios.put(
      // (CHANGE_OB_STATUS_URL + joinedString),
      (ASSIGN_BOL_URL + joinedString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Outbound Status Changed!");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  resyncOrder = (ids) => {
    // let joinedString = ids.join(',');
    // let data = {OutboundStatus: val};
    let joinedString = ids;
    let data = null;
    axios.post(
      // (CHANGE_OB_STATUS_URL + joinedString),
      (RESYNC_URL + joinedString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Order Resynced!");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  openConfirmQuote() {
    const { salesOrders } = this.state;
    const { customers } = this.props;
    let quoteSelectedCustomerId = null;
    let quoteSelectedCustomerName = "";
    let quoteSelectedCustomerPlaceholder = "";
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        quoteSelectedCustomerId = salesOrder.Deliver_Customer_id;
        quoteSelectedCustomerName = salesOrder.Deliver_CustomerName;
        quoteSelectedCustomerPlaceholder = salesOrder.Deliver_CustomerName;
        // Deliver_CustomerDetail_id //Deliver_Customer_id //Deliver_CustomerName
      });
    }
    let quoteCustomerOptions = [];
    if (customers) {
      customers.map((r) => {
        quoteCustomerOptions.push({ label: r.Name, value: r.Customer_id });
      });
    }
    this.setState({
      confirmQuoteOpen: true,
      quoteSelectedCustomerId,
      quoteSelectedCustomerName,
      quoteCustomerOptions,
      quoteSelectedCustomerPlaceholder,
    });
    this.props.setValue("salesOrders", "hmmCustomer", "");
  }
  closeConfirmQuote() {
    this.setState({ confirmQuoteOpen: false });
  }
  onQuoteCustomerChange = (e) => {
    if (e) {
      this.setState({
        quoteSelectedCustomerId: e.value,
        quoteSelectedCustomerName: e.label,
      });
    } else {
      this.setState({
        quoteSelectedCustomerId: null,
        quoteSelectedCustomerName: "",
      });
    }
  };
  onConfirmQuote() {
    const { salesOrders, quoteSelectedCustomerId } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    this.props.setQuoteOrder(salesOrderIds.join(","), quoteSelectedCustomerId);
    this.setState({ confirmQuoteOpen: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : "1900-01-01";
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : "3000-01-01";
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;
    setTimeout(() => {
      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.props.Warehouse_id,
      );
    }, 1000);
  }

  setDeliveryTimeSelectModalVisibility = (deliveryTimeSelectVisible = false) => this.setState({ deliveryTimeSelectVisible });
  setPickupTimeSelectModalVisibility = (pickupTimeSelectVisible = false) => this.setState({ pickupTimeSelectVisible });

  openShowDriverImage() {
    this.setState({ showDriverImageOpen: true });
  }
  closeShowDriverImage() {
    this.setState({ showDriverImageOpen: false });
  }

  openSubmitImage() {
    this.setState({ submitImageOpen: true });
  }
  closeSubmitImage() {
    this.setState({ submitImageOpen: false });
  }
  onSubmitImage(successCallback) {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.props.submitBolImage(salesOrder_id, this.state.file);
    this.setState({ submitImageOpen: false });
  }

  openPrintBol() {
    this.setState({ printBolOpen: true });
  }
  closePrintBol() {
    this.setState({ printBolOpen: false });
  }
  onChangeBolAddress = (address) => {
    this.setState({ bolAddressFBA: address.value });
  };

  openChangePullSheet() {
    this.setState({ changePullSheetOpen: true });
  }
  closeChangePullSheet() {
    this.setState({ changePullSheetOpen: false });
  }
  onChangePullSheetSubmit() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    if (
      this.state.pullSheetAmount < 0 ||
      this.state.pullSheetAmount > salesOrders.selectedRows.length
    ) {
      alert("Invalid Value!");
      return;
    }
    this.props.printPickingListAFG(
      salesOrderIds.join(","),
      this.state.pullSheetAmount,
      this.state.pullSheetSort,
    );
    this.state.pullSheetAmount = null;
    this.setState({ changePullSheetOpen: false });
    // this.context.router.push(`/${this.context.router.routes[1].path}`);
  }
  onPullSheetChange = (e) => {
    this.state.pullSheetAmount = e.target.value;
  };

  handleResize() {
    this.setState({
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
    });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ searchType: changeEvent.target.value });
  };

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentSalesOrder(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentSalesOrderId = this.state.salesOrders.selectedRows[0]
      .SalesOrder_id;
    const salesOrders = this.state.salesOrders.rows.filter((row) => {
      const match = row.SalesOrder_id === currentSalesOrderId;
      return match;
    });

    const FromDate = this.state.FromDate;
    const ToDate = this.state.ToDate;
    this.props.resetCurrentSalesOrder();

    this.props.selectSalesOrder(salesOrders[0]);
    const currentRows = Data.Selectors.getRows(this.state.salesOrders);
    const route = this.context.router.routes[1].path;
    this.props.setSalesOrdersFilter({
      Days: this.state.days,
      FromDate,
      ToDate,
      Status: this.state.Status,
      Seller: this.props.Seller,
      ProductNum: this.props.ProductNum,
      currentRows,
      currentPage: route,
    });
    // this.context.router.push('/salesOrders/'+currentSalesOrder.SalesOrder_id);
    this.context.router.push(
      `/${this.context.router.routes[1].path}/${currentSalesOrderId}`
    );
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentSalesOrder();
    // this.context.router.push('/salesOrders/new')
    this.context.router.push(`/${this.context.router.routes[1].path}/new`);
  }

  voidOrder() {
    let newRows = this.state.salesOrders.rows;
    this.state.salesOrders.selectedRows.map((row) => {
      if (isUSPride) {
        this.props.voidSalesOrder(
          row.SalesOrder_id,
        );
      } else {
        this.props.voidSalesOrder(
          row.SalesOrder_id,
          this.context.router.routes[1].path
        );
      }
      newRows = newRows.filter((obj) => obj !== row);
      const salesOrders = { ...this.state.salesOrders, rows: newRows, selectedRows: [] };
      this.setState({ salesOrders });
    });
  }

  shouldVoidButtonDisable() {
    const { selectedRows } = this.state.salesOrders;

    // Always disable void if selected more than 1 row
    if (selectedRows.length !== 1 && !isATL && !isRS && false) {
      return true;
    } else if (selectedRows.length < 1) {
      return true;
    }

    let testing = false;
    if (selectedRows && selectedRows.length > 1) {
      selectedRows.map(r => {
        if (r.SaleStatus === "Canceled" ||
        r.SaleStatus === "Refunded" ||
        r.SaleStatus === "Partially Refunded" ||
        r.SaleStatus === "Finalized" ||
        r.SaleStatus === "Released" ||
        r.SaleStatus === "disable")
        {
          testing = true;
        }
      });
    }
    if (testing === true) {
      return true;
    }

    const status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
    const disabled =
      status === "Canceled" ||
      status === "Refunded" ||
      status === "Partially Refunded" ||
      status === "Finalized" ||
      status === "Released" ||
      status === "disable";
    return disabled;
  }

  shouldQuoteButtonDisable() {
    const { selectedRows } = this.state.salesOrders;
    if (selectedRows.length !== 1) {
      return true;
    }
    const status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
    const disabled =
      status === "Canceled" ||
      status === "Refunded" ||
      status === "Partially Refunded" ||
      status === "Finalized" ||
      status === "Released" ||
      status === "Packing" ||
      status === "disable";
    return disabled;
  }

  printForm(e) {
    e.preventDefault();
  }

  loadsPost() {
    this.props.loadsPost(this.state.salesOrders.selectedRows[0].SalesOrder_id);
  }

  quoteConversion = () => {
    const route = this.context.router.routes[1].path;
    const status = this.state.salesOrders.selectedRows[0].SaleStatus;
    const id = this.state.salesOrders.selectedRows[0].SalesOrder_id;
    if (status === "Open") {
      this.props.orderToQuote(id).then(() => {
        const seller = this.props.Seller;
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : "1900-01-01";
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : "3000-01-01";
        const days = this.state.days;
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      });
    } else if (status === "Quote") {
      this.props.quoteToOrder(id).then(() => {
        const seller = this.props.Seller;
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : "1900-01-01";
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : "3000-01-01";
        const days = this.state.days;
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      });
    }
  };

  quoteButton = () => (
    <Button
      bsStyle="success"
      type="reset"
      disabled={this.shouldQuoteButtonDisable()}
      onClick={() => {
        this.quoteConversion();
      }}
    >
      <Translate value={this.state.title} />
    </Button>
  );

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    const route = this.context.router.routes[1].path;
    if (this.props.isLoading && !this.props.error) return <Spinner />;
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

    // Parameters of the react-data-grid
    let tableHeight = window.innerHeight < 930 ? 270 : 270;
    if (isABC) {
      tableHeight = window.innerHeight < 930 ? 800 : 800;
    }
    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();

      if (isSnapwise) {
        rows.map((r,i)=>{
          if (!r.Tracking && r.TTracking) {
            rows[i].Tracking = rows[i].TTracking;
          } else if (!r.Tracking && !r.TTracking) {
            rows[i].Tracking = "";
          } else {

          }
        })
      }

      if (isUSPride) {
        rows.map((r,i)=>{
          if (!r.carrierName) {
            rows[i].carrierName = " ";
          }
        })
      }

      if (isAPO) {
        rows.map((r,i)=>{
          if (!r.TrackingNum && r.delivery_tracking_num) {
            rows[i].TrackingNum = rows[i].delivery_tracking_num;
          } else if (!r.TrackingNum && !r.delivery_tracking_num) {
            rows[i].TrackingNum = "";
          } else {

          }
        })
      }

      // if (isAmzey) {
      //   rows.map((r,i)=>{
      //     if (!r.TrackingNum && r.delivery_tracking_num) {
      //       rows[i].TrackingNum = rows[i].delivery_tracking_num;
      //     } else if (!r.Tracking && !r.delivery_tracking_num) {
      //       rows[i].TrackingNum = "";
      //     } else {

      //     }
      //   })
      // }

      this.state.total = 0;
      for (let i = 0; i < rows.length; i++) {
        this.state.total += rows[i].FinalPrice;
      }
      return rows[rowIdx];
    };

    const onTrackingNumRouter = (trackingNum) => {
      const url =
        "https://www.fedex.com/apps/fedextrack/?tracknumbers=" + trackingNum;
      let win = window.open(url);
      if (win != null) {
        win.focus();
      }
    };

    const onTrackingNumRouter2 = (trackingURL) => {
      let url = trackingURL;
      let win = window.open(url);
      if (win != null) {
        win.focus();
      }
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrders = { ...this.state.salesOrders, filters: {} };
      this.setState({ salesOrders });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrders, {
        sortColumn,
        sortDirection,
      });
      if (state.sortColumn === "OrderDateDisplay") {
        state.sortColumn = "OrderDate";
      }

      if (state.sortDirection === "ASC") {
        this.state.pullSheetSort = state.sortColumn;
      } else if (state.sortDirection === "DESC") {
        this.state.pullSheetSort = `-${state.sortColumn}`;
      } else {
        this.state.pullSheetSort = "";
      }
      this.setState({ salesOrders: state });
    };

    const handleFilterChange = debounce(
      (filter) => {
        this.state.total = 0;
        this.state.salesOrders.rows = this.props.salesOrders.Orders;
        this.state.salesOrders.selectedRows = [];
        const newFilters = Object.assign({}, this.state.salesOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesOrders = { ...this.state.salesOrders, filters: newFilters };
        this.setState({ salesOrders });
      },
      500,
      { maxWait: 800 },
    );

    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        /* Multi row select on row click
          let selectedRows = [...this.state.salesOrders.selectedRows];

          let id = rows[rowIdx].SalesOrder_id;
          let idx = selectedRows.indexOf(id);
          if (idx == -1) {
            rows[rowIdx].isSelected = true;
            selectedRows.push(id);
          } else {
            rows[rowIdx].isSelected = false;
            selectedRows.splice(idx, 1);
          }
        */

        /* Single row select on row click */
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;

        const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
        this.setState({ salesOrders });
        if (isKDW) {
          this.props.fetchSalesOrderDetail(row.SalesOrder_id, "salesOrders");
        } else {
          this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
        }
      }
    };


    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      const route = this.context.router.routes[1].path;

      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
      };
      this.setState({ salesOrders });

      // salesOrders: {
      //   rows: [],
      //   selectedRows: [],
      //   filters: {},
      //   sortColumn: null,
      //   sortDirection: null,
      // },

      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.props.Warehouse_id,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;

      const route = this.context.router.routes[1].path;

      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
      };
      this.setState({ salesOrders });

      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.props.Warehouse_id,
      );

      // this.props.fetchSalesOrdersByFilter(
      //   this.state.FromDate,
      //   this.state.ToDate,
      //   this.state.days,
      //   this.state.Status,
      //   seller,
      //   productNum,
      //   route,
      //   this.state.dispatchDateLT,
      //   this.state.dispatchDateGT,
      //   dispatchDays,
      // );

      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const onRowSelect = (rows) => {
      const salesOrders = { ...this.state.salesOrders, selectedRows: rows };
      this.setState({ salesOrders });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      /* Multi row select on cell selected
                  let selectedRows = [...this.state.salesOrders.selectedRows];
                  newRows[coordinates.rowIdx].isSelected = true;
                  let id = newRows[coordinates.rowIdx].SalesOrder_id;
                  if (selectedRows.indexOf(id) == -1) {
                      selectedRows.push(id);
                  }
                */
      /* Single row select on cell selected */
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    };

    const checkLabel = () => {
      const selectedRows = [...this.state.salesOrders.selectedRows];
      if (selectedRows[0].SaleStatus === "Quote") {
        this.setState({
          title: "Open",
        });
      } else if (selectedRows[0].SaleStatus !== "Quote") {
        this.setState({
          title: "Quote",
        });
      }
    };

    const onRowsSelected = (rows) => {
      this.setState({
        scrollTopPositionIndex: rows[0].rowIdx,
      });
      const newRows = getRows();
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders }, () => {
        checkLabel();
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.salesOrders.rows];
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders, title: "Quote" });
    };

    // Custom Formatter component

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const date = new Date(this.props.value);
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const shippingAddressFormatter = React.createClass({
      render() {
        if (this.props.dependentValues) {
          return (
            <span>{`${this.props.dependentValues.Deliver_CustomerAddress} ${this.props.dependentValues.City} ${this.props.dependentValues.State}`}</span>
          );
        }
        return (
          <span></span>
        );
      },
    });

    const SecondsDateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = moment(this.props.value).format("MM-DD-YY HH:mm");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const DateFormatter2 = React.createClass({
      render() {
        if (this.props.value) {
          const date = moment(this.props.value).format("MM-DD-YY");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });


    const YuansferFormatter = React.createClass({
      render() {
        if (this.props.value === "alipay") {
          return <span>Alipay</span>;
        }
        if (this.props.value === "wechatpay") {
          return <span>WeChatPay</span>;
        } else {
          return <span>{this.props.value}</span>;
        }
      },
    });
    // Custom Delivery Time component
    const DeliveryTimeFormatter = React.createClass({
      render() {
        if (this.props.value) {
          let d1 = moment.utc(moment(this.props.value)).local().format("LT");
          let d2 = moment
            .utc(moment(this.props.value))
            .local()
            .subtract(2, "hours")
            .format("MM-DD-YY hh:mm A");
          // This is the old way Julie designed it. Keeping it here in case a new bug is discovered with my alterations.
          // d1 = moment(d1).format("h a");
          // d2 = moment(d2).subtract(2, 'hours').format('MM-DD-YY hh:mm:ss a');
          // d2 = moment(d2).format("h a");

          return <span>{`${d2}-${d1}`}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const InvoiceNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const PromoCodeFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const soNumWidth =
      this.context.router.routes[1].path === "mobileSalesOrders" ? 145 : 100;

    // Column difinition
    let columns = [
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      ...(isEcity && this.context.router.routes[1].path === "mobileSalesOrders") ? [{
        key: "ShippingMethod",
        name: <Translate value="delivery" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }] : [],
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      ...isTQ ? [{
        key: "PONum",
        name: <Translate value="cust_po" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,

      }] : [],
      ...isFIT ? [{
        key: "Quantity",
        name: <Translate value="total_qty" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },{
        key: "SKU",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }] : !isAN && [{
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }],
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      ...!isCalco ? [] : [{
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }],
      ...!isCalco ? [] : [{
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }],
      ...isCalco ? [] : [{
        key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod": "Description",
        name: isTN ? "Client.Cust" : isChinaTown ?  <Translate value="shipping_method" /> : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }],
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      ...isAN ? [] : [{
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      ...isEcity ? [{
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },{
        key: "Creater_Name",
        name: <Translate value="creator" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }] : [],
      ...isAN ? [{
        key: "Creater_Name",
        name: <Translate value="creator" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }] : [{
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }],
      ...isCalco ? [] : [{
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }],
      ...isCalco ? [] : [{
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }],
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
      ...!isCalco ? [] : [{
        key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod": "Description",
        name: isTN ? "Client.Cust" : isChinaTown ?  <Translate value="shipping_method" /> : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }],
      ...!isCalco ? [] : [{
        key: "PromoCode",
        name: <Translate value="promo_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }],
      ...!isCalco ? [] : [{
        key: "discountDisplay",
        name: <Translate value="discount" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }],
    ];

    if (isATL) {
      columns = [
        {
          key: "SONum",
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: soNumWidth,
        },
        {
          key: "CPONum",
          name: <Translate value="cpo_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          key: "InvoiceNum",
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 113,
          formatter: InvoiceNumFormatter,
        },
        ...isTQ ? [{
          key: "PONum",
          name: <Translate value="cust_po" />,
          resizable: true,
          sortable: true,
          width: 95,
          filterable: true,

        }] : [],
        ...isFIT ? [{
          key: "Quantity",
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 95,
          filterable: true,
        },{
          key: "SKU",
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 95,
          filterable: true,
        }] : [{
          key: "Deliver_Customer_num",
          name: <Translate value="cust_no" />,
          resizable: true,
          sortable: true,
          width: 95,
          filterable: true,
        }],
        {
          // key: "Deliver_CustomerName",
          key: "shipToName",
          name: <Translate value="cust_name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 115,
        },
        {
          key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod": "Description",
          name: isTN ? "Client.Cust" : isChinaTown ?  <Translate value="shipping_method" /> : <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 124,
        },
        {
          key: "TrackingNum",
          name: <Translate value="tracking_num" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: "FinalPrice",
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: "Sales_User_Name",
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: "SaleStatus",
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: "PaymentType",
          name: <Translate value="payment" />,
          resizable: true,
          sortable: true,
          width: 95,
          filterable: true,
          formatter: YuansferFormatter,
        },
        {
          key: "OrderDate",
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 95,
          filterable: true,
        },
        {
          key: "DispatchDate",
          name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
          resizable: true,
          sortable: true,
          width: 125,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: "ShipmentDate",
          name: <Translate value="shipped" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          formatter: SecondsDateFormatter,
        },
      ];
    }

    const MAGColumn = [
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "cntrStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "cntrLocation",
        name: <Translate value="cntr_location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      },
      {
        key: "terminal",
        name: <Translate value="terminal" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "delivery_lfd",
        name: <Translate value="lfd" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "size",
        name: <Translate value="size" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "bolNum",
        name: <Translate value="bol_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "delivery_eta",
        name: <Translate value="eta" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "delivery_address",
        name: <Translate value="shipment_address" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "delivery_drayage",
        name: <Translate value="shipment_drayage" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "DeliveryStatus",
        name: <Translate value="hold_select" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 250,
      },
      {
        key: "DeliveryStatusOther",
        name: <Translate value="hold_other" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "mag_note",
        name: <Translate value="note_select" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 250,
      },
      {
        key: "mag_note_other",
        name: <Translate value="note_other" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "shipping_line",
        name: <Translate value="shipping_line" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "cargo_weight",
        name: <Translate value="cargo_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "contact_person",
        name: <Translate value="contact_person" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "contact_email",
        name: <Translate value="contact_email" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
    ];

    // For Ecity, add SalesMargin Column before SaleStatus
    if (isEcity) {
      const indexSalesStatus = _.findIndex(columns, { key: "SaleStatus" });
      const salesMarginColumn = {
        key: "SalesMargin",
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: PercentFormatter,
      };
      columns.splice(indexSalesStatus, 0, salesMarginColumn);
    }

    if (isTN) {
      const indexTN = _.findIndex(columns, { key: "InvoiceNum" });
      const cpoCol = {
        key: "CPONum",
        name: <Translate value="cpo_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }
      const refCol = {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }
      columns.splice(indexTN, 0, cpoCol, refCol);

      const orderCol = _.findIndex(columns, { key: "OrderDate" });
      const typeCol = {
        key: "Type",
        name: <Translate value="type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }
      columns.splice(orderCol, 0, typeCol);
    }

    // if (isAFG) {
    if (true) {
      const indexOrderDate = _.findIndex(columns, { key: "OrderDate" });
      const orderColum = {
        key: "OrderDateDisplay",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      };
      columns.splice(indexOrderDate, 1, orderColum);

      if (this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          row.OrderDateDisplay = moment(row.OrderDate).format("MM-DD-YY HH:mm");
        });
      }

      let jmlTrackingNumColumn = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              this.openDisplayTracking();
            }}
          >
            <Translate value="details" />
          </div>
        ),
      };

      if (isAPO) {
        jmlTrackingNumColumn = {
          key: "TrackingNum",
          name: <Translate value="tracking_num" />,
          resizable: true,
          sortable: true,
          width: 160,
          filterable: true,
          getRowMetaData: (row) => row,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                  this.openChangeTracking(value, dependentValues);
              }}
            >
              {value ? value : "-"}
            </div>
          ),
        }
      }
      if (isJML || isSY) {
        columns.splice(indexOrderDate, 0, jmlTrackingNumColumn);
      }


      const indexSY = _.findIndex(columns, { key: "SaleStatus" });
      const SalesOrderTypeSyColumn = {
        key: "SalesOrderTypeSy",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      };
      if (isSY) {
        columns.splice(indexSY, 0, SalesOrderTypeSyColumn);
      }
    }

    if (isMyuMyu || isAFG || isWecom ) {
      const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
      const estColum = {
        key: "DispatchDateDisplay",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      };
      columns.splice(indexEstDelivery, 1, estColum);
      if (this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          let date1 = moment
            .utc(moment(row.DispatchDate))
            .local()
            .format("HH:mm");
          let date2 = moment
            .utc(moment(row.DispatchDate))
            .local()
            .subtract(2, "hours")
            .format("MM-DD-YY HH:mm");
          row.DispatchDateDisplay = `${date2}-${date1}`;
        });
      }
    } else if (isAFM) {
      const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
      const estColum = {
        key: "TimeRange",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
        getRowMetaData: row => row,
        formatter: (props) => {
          return <span>{props.value}</span>
        }
      };
      const estColum1 = {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      };
      columns.splice(indexEstDelivery, 1, estColum, estColum1);

      const indexFP = _.findIndex(columns, { key: "FinalPrice" });
      if (this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          row.PaymentHoldDisplay = row.PaymentHold ? "true" : "false";
        });
      }
      const paymentHoldCol = {
        key: "PaymentHoldDisplay",
        name: <Translate value="payment_hold" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        // formatter: ({ value }) => (
        //   <div>
        //     { value ? "true" : "false" }
        //   </div>
        // ),
      };
      columns.splice(indexFP, 0, paymentHoldCol);
    }

    if (isGV) {
      columns.splice(5, 0, {
        key: "GvTicketQRCodeUrl",
        name: <Translate value="qr_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: ({ value }) => {
          if (value) {
            return <a href={value}>download</a>
          } else {
            return null;
          }
        },
      });
    };

    if (isAFM) {
      columns.splice(8, 0, {
        key: "ShippingStatus",
        name: <Translate value="shipping_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      });
      columns.splice(9, 0, {
        key: "OrderImage",
        name: <Translate value="order_image" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (value !== '') {
                this.openShowDriverImage();
              }
            }}
          >
            {value !== '' && <Translate value="show" />}
          </div>
        ),
      });
      if (this.state.Status === 'Canceled') {
        columns.splice(7, 0, {
          key: "Settled",
          name: <Translate value="settled" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          formatter: ({ value }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
            >
              {value ? 'yes' : 'no' }
            </div>
          ),
        });
      }
    }

    if (isTN) {
      const indexDispatchPrice = _.findIndex(columns, { key: "ShipmentDate" });
      const shipByColumn = {
        key: "ShipByDate",
        name: <Translate value="ship_by" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      };
      const createTimeColumn = {
        key: "CreateTime",
        name: <Translate value="create_time" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      };
      columns.splice(indexDispatchPrice, 0, shipByColumn, createTimeColumn);
    }

    if (!isTN && !isFIT && !isAN && !isCalco) {
      const indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
      // this.context.router.routes[1].path !== "mobileSalesOrders"
      if (isAFG && this.context.router.routes[1].path === "mobileSalesOrders") {

      } else {
        const discountColumn = {
          key: "discountDisplay",
          name: <Translate value="discount" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        };
        const promoCodeColumn = {
          key: "PromoCode",
          name: <Translate value="promo_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // formatter: PromoCodeFormatter,
        };
        columns.splice(indexFinalPrice, 0, promoCodeColumn);
        if (this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            if (!row.PromoCode) {
              row.PromoCode = "-";
            }
          });
        }
        columns.splice(indexFinalPrice, 0, discountColumn);
        if (this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            if (row.Discount !== 0 && row.Savings) {
              row.discountDisplay =
                row.Discount + "% - $" + row.Savings.toFixed(2);
            } else if (row.Discount === 0 && row.Savings !== 0) {
              row.discountDisplay = "$" + row.Savings.toFixed(2);
            } else {
              row.discountDisplay = "-";
            }
          });
        }
      }




    // For mobile sales order, replace Sales_User_Name with City
    if (this.context.router.routes[1].path === "mobileSalesOrders") {
      const indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
      const groupBuyColumn = {
        key: "IsGroupBuyDisplay",
        name: <Translate value="group_buy" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
            {value}
          </div>
        ),
      };
      if (isWecom) {
        columns.splice(indexFinalPrice, 0, groupBuyColumn);
        if (this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            if (row.IsGroupBuy === true) {
              row.IsGroupBuyDisplay = "yes";
            } else {
              row.IsGroupBuyDisplay = "no";
            }
          });
        }
      }
    }
      if (isAFG && this.context.router.routes[1].path !== "mobileSalesOrders") {
        const alcoholColumn = {
          key: "Alcohol",
          name: <Translate value="alcohol" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        };
        columns.splice(indexFinalPrice, 0, alcoholColumn);
      }
      if (isAFG) {
        const platformColumn = {
          key: "platform",
          name: <Translate value="platform" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        };
        columns.splice(indexFinalPrice, 0, platformColumn);
      }

      // Find item index using _.findIndex
      const indexEstDeliveryName = _.findIndex(columns, {
        key: "DispatchDate",
      });
      const indexSalesUserName = _.findIndex(columns, {
        key: "Sales_User_Name",
      });
      const indexCreateTime = _.findIndex(columns, { key: "CreateTime" });
      const descriptionIndex = _.findIndex(columns, { key: "Description" });

      const salesColumn = {
          key: "Sales_User_Name",
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
      };
      const cityColumn = {
        name: <Translate value="city" />,
        key: "City",
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };
      const stateColumn = {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
      };

      const shippingWeight = {
        key: "FinalShippingWeight",
        name: <Translate value="shipping_weight" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%" }}>
            {value ? value.toFixed(2) : null}
          </div>
        ),
      };

      const shippingmethodColumn = {
        key: "ShippingMethod",
        name: <Translate value="shippingMethod" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };

      const trackingNumColumn = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (value === "split") {
                this.openDisplayTracking();
              } else {
                onTrackingNumRouter(value);
              }
            }}
          >
            {value}
          </div>
        ),
      };

      const trackingNumColumnEZone = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
        getRowMetaData: (row) => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              // if (value === "split") {
              //   this.openDisplayTracking();
              // } else {
                onTrackingNumRouter2(dependentValues.TrackingURL);
              // }
            }}
          >
            {value}
          </div>
        ),
      };

      const isMobileEZ = this.context.router.routes[1].path === "mobileSalesOrders";
      const indexEZ = _.findIndex(columns, { key: "Deliver_CustomerName" });
      if (isEZone && isMobileEZ) {
        columns.splice(indexEZ, 0, trackingNumColumnEZone);
      }

      if (isAFG) {
        columns.splice(indexEstDeliveryName, 1);
        columns.splice(indexEstDeliveryName, 0, trackingNumColumn);
      }

      /*if (!isRivera) {
        columns.splice(indexSalesUserName, 1, shippingWeight, cityColumn, stateColumn,);
      } else {
        columns.splice(indexSalesUserName, 1, cityColumn, stateColumn);
      }
      columns.splice(indexCreateTime, 1, shippingmethodColumn);
      columns.splice(descriptionIndex, 1); // hide desc on mobile order
    } else {
      const yuansferColName = _.findIndex(columns, { key: "PaymentType" });
      columns.splice(yuansferColName, 1); // hide payment on sales order
    }*/

    if (isRivera) {
      columns.splice(indexSalesUserName, 1, salesColumn, cityColumn, stateColumn);
      columns.splice(indexCreateTime, 1, shippingmethodColumn);
      columns.splice(descriptionIndex, 1); // hide desc on mobile order
      const yuansferColName = _.findIndex(columns, { key: "PaymentType" });
      columns.splice(yuansferColName, 1); // hide payment on sales order
    } else if (isHMM) {
      columns.splice(indexSalesUserName, 1, shippingWeight, salesColumn, cityColumn, stateColumn);
    } else {
      columns.splice(indexSalesUserName, 1, shippingWeight, cityColumn, stateColumn,);
    }
  }

    if (isFIT) {
      const trackingNumColumn = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      };
      const index = _.findIndex(columns, { key: "SaleStatus" });
      columns.splice(index+1, 0, trackingNumColumn);
    }

    const ABCColumn = [
      {
        key: "SONum",
        name: <Translate value="so_num" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "CompanyName",
        name: <Translate value="company_name" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "CreateTime",
        name: <Translate value="date" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
        formatter: SecondsDateFormatter,
      },
      {
        key: "FBACode",
        name: <Translate value="FBA" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "CustomerBOLNo",
        name: <Translate value="BOL" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "TotalPalletQuantity",
        name: <Translate value="plt" />,
        resizable: true,
        width: 70,
        filterable: true,
      },
      {
        key: "TotalInboundQuantity",
        name: <Translate value="inbound_plt" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "TotalOutboundQuantity",
        name: <Translate value="outbound_plt" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "ESTInboundDate",
        name: <Translate value="EST_date" />,
        resizable: true,
        width: 150,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsaNo",
        name: <Translate value="ISA" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "Reason",
        name: <Translate value="reason" />,
        resizable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{color: value ? 'red' : ''}}
          >
            { value }
          </div>
        ),
      },
      {
        key: "TotalCartonQuantity",
        name: <Translate value="ctn" />,
        resizable: true,
        width: 70,
        filterable: true,
      },
      {
        key: "ShippingStatus",
        name: <Translate value="shpping_status" />,
        resizable: true,
        width: 70,
        filterable: true,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "PodFileUrl",
        name: <Translate value="pod" />,
        resizable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <a
            style={{color: value ? 'green' : '', cursor: 'pointer'}}
            href={value}
          >
            { value && 'uploaded' }
          </a>
        ),
      },
      {
        key: "ContainerNo",
        name: <Translate value="container" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "PickUpDriverName",
        name: <Translate value="inbound_driver" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "OutboundDriverName",
        name: <Translate value="outbound_driver" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "ShipFrom",
        name: <Translate value="ship_from" />,
        resizable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "ShipTo",
        name: <Translate value="ship_to" />,
        resizable: true,
        width: 200,
        filterable: true,
      },
    ];
    const USPrideColumn = [
      {
        key: "SONum",
        name: <Translate value="SONum" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="store_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      // {
      //   key: "SalesName",
      //   name: <Translate value="sales" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 100,
      //   filterable: true,
      // },
      {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
        getRowMetaData: (row) => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              // uspride lala
              // if (isUSPride) {
              //   this.openChangeTracking(value, dependentValues);
              // }
            }}
          >
            {value}
          </div>
        ),
      },
      {
        key: "WarehouseName",
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "poNum",
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...(this.context.router.routes[1].path === "mobileSalesOrders") ? [      {
        key: "ProductRefNums",
        name: <Translate value="SKUs" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }] : [],
      {
        key: "OrderDate",
        name: <Translate value="po_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "DispatchDate",
        name: <Translate value="must_ship_by" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
      {
        key: "backorderDate",
        name: <Translate value="backorder_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
      {
        key: "ExternalStatus",
        name: <Translate value="order_status" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="sale_status" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ShippingStatus",
        name: <Translate value="shipping_status" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "carrierName",
        name: <Translate value="carrier_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "shipToName",
        name: <Translate value="ship_to_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        name: <Translate value="ship_to_address" />,
        resizable: true,
        sortable: true,
        width: 250,
        filterable: true,
        getRowMetaData: (row) => row,
        formatter: shippingAddressFormatter,
      },
      {
        key: "Deliver_CustomerPhone",
        name: <Translate value="ship_to_phone" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "shipToSpeed",
        name: <Translate value="ship_to_speed" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "SalesName",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
    ];

    let ABCFFColumn = (this.context.router.routes[1].path === 'outboundOrders' || this.context.router.routes[1].path === 'mobileSalesOrders')  ?
    [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      }, {
        key: "CPONum",
        name: <Translate value="cpo" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (!value) {
                this.openTrackingForm();
              }
            }}
          >
            {value ? value : "-"}
          </div>
        ),
      }, {
        key: "Channel",
        name: <Translate value="channel" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },  {
        key: "LoadId",
        name: <Translate value="loadId" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }, {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "AddressName",
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Street",
        name: <Translate value="street" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }, {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }, {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },  {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "IsDirectShip",
        name: <Translate value="direct_ship" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }, {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }, {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      }, {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      }, {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return (
            <div>
             {dependentValues.ContainerNum_lines ? dependentValues.ContainerNum_lines : value}
            </div>
          )
        }
      }, {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }, {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }, {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }, {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const YIColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "QuoteNum",
        name: <Translate value="quote_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "TotalCost",
        name: <Translate value="xpo_price" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "PctMarkup",
        name: <Translate value="percent_markup (%)" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "PctMarkupCost",
        name: <Translate value="percent_markup ($)" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "FlatMarkup",
        name: <Translate value="flat_markup ($)" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "FinalPrice",
        name: <Translate value="cust_price" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "PRONum",
        name: <Translate value="pro_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "PickupRef",
        name: <Translate value="pickup" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "OutboundStatus",
        name: <Translate value="ob_status" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "Warehouse_id",
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "BLNum",
        name: <Translate value="bol_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "SealNum",
        name: <Translate value="seal_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "ProNum",
        name: <Translate value="pro_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "OrderType",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "SSL",
        name: "SSL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "MBL",
        name: "MBL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Pin",
        name: <Translate value="pin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "ChassisType",
        name: <Translate value="chassis_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "PierPass",
        name: <Translate value="pier_pass" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ShipmentDate",
        name: <Translate value="shipment_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }, {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "LooseQty",
        name: <Translate value="loose_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "IsDirectShip",
        name: <Translate value="direct_ship" />,
        resizable: true,
        sortable: true,
        width: 100,
        // filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "LFDate",
        name: <Translate value="last_free_day" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }, {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }, {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "Warehouse_id",
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "BLNum",
        name: <Translate value="bol_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SealNum",
        name: <Translate value="seal_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "ProNum",
        name: <Translate value="pro_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "OrderType",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SSL",
        name: "SSL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "MBL",
        name: "MBL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Pin",
        name: <Translate value="pin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ChassisType",
        name: <Translate value="chassis_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PierPass",
        name: <Translate value="pier_pass" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipment_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="last_free_day" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const KDWColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "OutboundStatus",
        name: <Translate value="ob_status" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      },
      {
        key: "BLNum",
        name: <Translate value="bol_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SealNum",
        name: <Translate value="seal_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "ProNum",
        name: <Translate value="pro_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "OrderType",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SSL",
        name: "SSL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "MBL",
        name: "MBL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Pin",
        name: <Translate value="pin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ChassisType",
        name: <Translate value="chassis_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PierPass",
        name: <Translate value="pier_pass" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsDirectShip",
        name: <Translate value="direct_ship" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="last_free_day" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "BLNum",
        name: <Translate value="bol_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SealNum",
        name: <Translate value="seal_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "ProNum",
        name: <Translate value="pro_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "OrderType",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "SSL",
        name: "SSL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "MBL",
        name: "MBL",
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },

      {
        key: "Pin",
        name: <Translate value="pin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ChassisType",
        name: <Translate value="chassis_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PierPass",
        name: <Translate value="pier_pass" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "B2BName",
        name: <Translate value="cust_name2" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="last_free_day" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const DSQColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "DSQID",
        name: <Translate value="dsq_id" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsDirectShip",
        name: <Translate value="direct_ship" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "DSQID",
        name: <Translate value="dsq_id" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const JTBColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerSize",
        name: <Translate value="container_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderType",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropshipType",
        name: <Translate value="dropship_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "BOL",
        name: <Translate value="BOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "POD",
        name: <Translate value="POD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="appointment" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerSize",
        name: <Translate value="container_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ReceiveType",
        name: <Translate value="receive_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ReceiveUnit",
        name: <Translate value="receive_unit" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "BOL",
        name: <Translate value="BOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "POD",
        name: <Translate value="POD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="appointment" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const WIZColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "OutboundStatus",
        name: <Translate value="outbound_status" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      },
      {
        key: "Trucker",
        name: <Translate value="trucker" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ReleaseDate",
        name: <Translate value="release_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ReadyDate",
        name: <Translate value="ready_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "OutboundDate",
        name: <Translate value="outbound_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Destination",
        name: <Translate value="destination" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Notation",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "EmployeeNote",
        name: <Translate value="employee_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },

      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "ContainerSize",
        name: <Translate value="container_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Notation",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "EmployeeNote",
        name: <Translate value="employee_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="arrived" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const FJCompleteBackground = (props) => {
      const rowBackground = props.dependentValues.IsComplete
        ? "#4caf50"
        : '';
      return (
        <div style={{ backgroundColor: rowBackground }}>
          <span>{ props.value }</span>
        </div>
      );
    };

    const FJColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
        formatter: FJCompleteBackground,
        getRowMetaData: row => row,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Agent",
        name: <Translate value="agent" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverByDate",
        name: <Translate value="deliver_by_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverByTime",
        name: <Translate value="deliver_by_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ExtInvoiceNum",
        name: <Translate value="ext_invoice" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Broker",
        name: <Translate value="broker" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Truckload",
        name: <Translate value="truckload" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckNum",
        name: <Translate value="truck_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDriver",
        name: <Translate value="pickup_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDriver",
        name: <Translate value="dropoff_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupTrailerNum",
        name: <Translate value="pickup_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffTrailerNum",
        name: <Translate value="dropoff_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDate",
        name: <Translate value="pickup_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "PickupTime",
        name: <Translate value="pickup_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDate",
        name: <Translate value="dropoff_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "DropoffTime",
        name: <Translate value="dropoff_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupCity",
        name: <Translate value="pickup_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffCity",
        name: <Translate value="dropoff_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupState",
        name: <Translate value="pickup_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffState",
        name: <Translate value="dropoff_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Dispatch",
        name: <Translate value="dispatch" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DetentionRate",
        name: <Translate value="detention_rate" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LumperFee",
        name: <Translate value="lumper_fee" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
        formatter: FJCompleteBackground,
        getRowMetaData: row => row,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Agent",
        name: <Translate value="agent" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ExtInvoiceNum",
        name: <Translate value="ext_invoice" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Broker",
        name: <Translate value="broker" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Truckload",
        name: <Translate value="truckload" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckNum",
        name: <Translate value="truck_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDriver",
        name: <Translate value="pickup_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDriver",
        name: <Translate value="dropoff_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupTrailerNum",
        name: <Translate value="pickup_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffTrailerNum",
        name: <Translate value="dropoff_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDate",
        name: <Translate value="pickup_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "PickupTime",
        name: <Translate value="pickup_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDate",
        name: <Translate value="dropoff_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "DropoffTime",
        name: <Translate value="dropoff_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupCity",
        name: <Translate value="pickup_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffCity",
        name: <Translate value="dropoff_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupState",
        name: <Translate value="pickup_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffState",
        name: <Translate value="dropoff_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Dispatch",
        name: <Translate value="dispatch" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DetentionRate",
        name: <Translate value="detention_rate" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LumperFee",
        name: <Translate value="lumper_fee" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },

      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const limitSelection = [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: <Translate value="all" />,
        value: 99999,
        name: 'limit',
      },
    ]

    if (isAmzey) {
      // const trackingNum = {
      //   key: "Tracking",
      //   name: <Translate value="tracking_num" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 170,
      //   filterable: true,
      // };
      const trackingNum = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
        getRowMetaData: (row) => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
                this.openChangeTracking(value, dependentValues);
            }}
          >
            {value ? value : "-"}
          </div>
        ),
      }
      const DescriptionIndex = _.findIndex(columns, { key: 'Description' });
      columns.splice(DescriptionIndex + 1, 0, trackingNum);
    }

    const generateColumns = () => {
      if (isABC) {
        return ABCColumn;
      }
      if (isUSPride) {
        return USPrideColumn;
      }
      if (isKDW || isFBD) {
        return KDWColumn;
      }
      if (isYI) {
        return YIColumn;
      }
      if (isABCFF) {
        return ABCFFColumn;
      }
      if (isDSQ) {
        return DSQColumn;
      }
      if (isJTB) {
        return JTBColumn;
      }
      if (isWIZ) {
        return WIZColumn;
      }
      if (isFJ) {
        return FJColumn;
      }
      if (isMAG) {
        return MAGColumn;
      }
      return columns;
    }

    let selectedOrderCount = 0;
    if (this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
      selectedOrderCount = this.state.salesOrders.selectedRows.length;
    }

    return (
      // React Table Sales Order History Table
      <div id={(isTN || isUSPride || isATL || isRS || isDSQ || isWUFS || isEZone || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && "TNMSOTable"}>
        <Row>
          <Col xs={12}>
            <div id="salesOrders-dataGrid1" style={{ marginTop: '26px' }}>
              <ReactDataGrid
                rowKey="SalesOrder_id"
                ref={(g) => {
                  this.grid = g;
                }}
                onGridSort={handleGridSort}
                toolbar={isABC ? null : <Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={generateColumns()}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onClearFilters={onClearFilters}
                minHeight={tableHeight - (isABC ? 100 : 0)} //LALALA
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: "isSelected",
                  },
                }}
                onRowClick={onRowClick}
                onCellSelected={onCellSelected}
              />
            </div>
          </Col>
        </Row>
        {
          (isABC && this.context.router.routes[1].path !== 'salesOrders') &&
          // false &&
          <Row>
            <Col xs={6} style={{display: 'flex'}}>
              <div style={{ width: '600px' }} id="react-pagination">
                <ReactPaginate
                  previousLabel={<Translate value="prev_page" />}
                  nextLabel={<Translate value="next_page" />}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  pageCount={this.props.msoTotalPages}
                  onPageChange={handleOnPageChange}
                  forcePage={this.state.currentPage}
                />
              </div>
              <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.limitDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {limitSelection.map(el => {
                      return (
                        <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
            {/* <Col className="col-sm-3" style={{ width: '90px' }} > */}
            {/*<Col xs={6} >
              <Dropdown>
                <Dropdown.Toggle style={{ width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {this.state.limitDisplay}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {limitSelection.map(el => {
                    return (
                      <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>*/}
          </Row>
        }
        { !isABC &&
          <Row>
            <Col xs={12}>
              <div>
                <Col xs={2}>
                  <label className="row-count">
                    <Translate value="total_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {`${this.state.rowsCount} - ${
                        this.state.canceledOrders
                      } = ${this.state.rowsCount - this.state.canceledOrders}`}
                    </span>
                  </label>

                  <label className="row-count" style={{marginTop: '0px'}}>
                    <Translate value="selected_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {selectedOrderCount}
                    </span>
                  </label>

                </Col>
                <Col xs={6}>
                  <label className="grand-total">
                    <span className="grand-total-label">
                      <Translate value="grand_total" />
                      :&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`$${numberWithCommas(
                        (this.state.total || 0).toFixed(2)
                      )} - $${numberWithCommas(
                        (this.state.canceledTotal || 0).toFixed(2)
                      )} = $${numberWithCommas(
                        (this.state.total - this.state.canceledTotal).toFixed(2)
                      )}`}
                    </span>
                  </label>
                </Col>
                <Col xs={4}>
                  <div className="mso-footnotes">
                    <span>
                      <Translate value="msg_total_orders_equation" />
                    </span>
                    <span>
                      <Translate value="msg_grand_total_equation" />
                    </span>
                  </div>
                </Col>
              </div>
            </Col>
          </Row>
        }
      </div>
    );
  }

  renderDatePickers() {
    if (this.state.days === -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5">
            <Translate value="from" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} />
          </div>
          <label className="col-xs-1 to-label">
            <Translate value="to" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} />
          </div>
        </div>
      );
    }
  }

  renderUsers() {
    if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.
    const Users = this.getUsers();
    return (
      <div style={{ marginRight: "10px" }} className="control-dropdown">
        <Field name="Seller" component={Selection} options={Users} />
      </div>
    );
  }

  renderWarehouse() {
    return (
      <div style={{ marginRight: "10px" }} className="control-dropdown2">
        <Field name="Warehouse_id" component={Selection} options={this.state.warehouseOptions} />
      </div>
    );
  }

  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  renderAddresses() {
    const Addresses = this.getAddress();
    return (
      <div style={{ margin: "10px" }} className="control-dropdown">
        <Field
          name="Warehouse"
          component={SelectionWithProps}
          options={Addresses}
          onChange={this.onChangeBolAddress}
        />
      </div>
    );
  }

  getAddress() {
    const Addresses = [];
    this.props.bolAddress.map((address) => {
      Addresses.push({
        value: address.FBACode,
        label: address.FBACode + " - " + address.Address,
      });
    });
    return Addresses;
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e });
  };

  setFromDate = (e) => {
    if ((this.state.ToDate || !(isATL || isUSPride)) && (e > this.state.ToDate)) {
      return;
    }
    this.setState({ FromDate: e });
  };

  setFromDispatchDate = (e) => {
    if ((this.state.dispatchDateGT || !(isATL || isUSPride)) && (e > this.state.dispatchDateGT)) {
      return;
    }
    this.setState({ dispatchDateLT: e });
  };

  setToDispatchDate = (e) => {
    if (e < this.state.dispatchDateLT) {
      return;
    }
    this.setState({
      dispatchDateGT: e,
    });
  };

  setToRangeSearch = () => {
    if (isATL || isUSPride) {
      this.setState({dispatchDays: null, dispatchDateLT: null, dispatchDateGT: null });
    }
    this.setState({ days: "-1" });
  };

  setToDispatchRangeSearch = () => {
    if (isATL || isUSPride) {
      this.setState({days: null, FromDate: null, ToDate: null });
    }
    this.setState({ dispatchDays: "-1" });
  };

  fetchSalesOrdersByDispatch(dispatchDays) {
    if (isATL || isUSPride) {
    // this.state.FromDate = "1900-01-01";
    // this.state.ToDate = "3000-01-01";
    this.state.FromDate = null;
    this.state.ToDate = null;
    this.state.days = null;
    }
    if (this.state.filteredByItem) {
      this.setState({ dispatchDays }, () => {
        this.fetchSalesOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = this.context.router.routes[1].path;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    if (dispatchDays === "-1" || dispatchDays === -1) {
      this.setState({ dispatchDays }, () => {
        this.props.fetchSalesOrdersByFilter(
          this.state.FromDate,
          this.state.ToDate,
          this.state.days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      });
    } else {
      this.setState(
        { dispatchDays, dispatchDateLT: undefined, dispatchDateGT: undefined },
        () => {
          this.props.fetchSalesOrdersByFilter(
            this.state.FromDate,
            this.state.ToDate,
            this.state.days,
            this.state.Status,
            seller,
            productNum,
            route,
            this.state.dispatchDateLT,
            this.state.dispatchDateGT,
            dispatchDays,
            this.state.limit,
            this.state.currentPage,
            this.state.searchFilter,
            this.props.Warehouse_id,
          );
        },
      );
    }
  }

  fetchSalesOrdersByDetails(days) {
    if (isATL || isUSPride) {
      // this.state.dispatchDateLT = "1900-01-01";
      // this.state.dispatchDateGT = "3000-01-01";
      this.state.dispatchDateLT = null;
      this.state.dispatchDateGT = null;
      this.state.dispatchDays = null;
    }
    this.setState({currentPage: 0});
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
    };
    if (isABC) {
      this.setState({ salesOrders });
    }

    if (this.state.filteredByItem) {
      this.setState({ days }, () => {
        this.fetchSalesOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let FromDate = "1900-01-01";
    let ToDate = "3000-01-01";
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = this.context.router.routes[1].path;
    if (this.state.FromDate != null) {
      FromDate = this.state.FromDate;
    }

    if (this.state.ToDate != null) {
      ToDate = this.state.ToDate;
    }

    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

    if (days === "-1" || days === -1) {
      this.setState({ days }, () => {
        this.props.fetchSalesOrdersByFilter(
          FromDate,
          ToDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      });
    } else {
      this.setState({ days, FromDate: undefined, ToDate: undefined }, () => {
        this.props.fetchSalesOrdersByFilter(
          FromDate,
          ToDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      });
    }
  }

  fetchSalesOrdersByProduct = (productID) => {
    let dateRange = -1;
    let FromDate = "1900-01-01";
    let ToDate = "3000-01-01";
    let seller = this.props.Seller;
    const route = this.context.router.routes[1].path;
    const productNum = productID;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }

    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }

    if (this.state.days != null) {
      dateRange = this.state.days;
    }
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    this.setState({
      filteredByItem: true,
      selectedRows: [{}],
      filterProductID: productID,
    });
    this.props.fetchSalesOrdersByFilter(
      FromDate,
      ToDate,
      dateRange,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      null,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.props.Warehouse_id,
    );
  };

  formatDate(date) {
    if (isATL || isUSPride) {
      if (date === "1900-01-01") {return "1900-01-01"}
      if (date === "3000-01-01") {return "3000-01-01"}
    }
    let formattedDate = `${date.getFullYear()}-`;

    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

  renderProductsTable() {
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
      return <Spinner />;
    else if (this.props.salesOrderError) {
      return (
        <ContentWrapper>
          <div className="alert   alert-danger">
            {JSON.stringify(this.props.salesOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        selectedRows: rows,
      };
      this.setState({ salesOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VitDateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const Vitdate = (this.props.value).split("_")[0] + "  " + ((this.props.value).split("_")[1] + ":00")
          return <span>{Vitdate}</span>;
        }
      },
    });

    // Column definition
    const showProductCost = () => {
      if (isHMM || isJML) {
        return false;
      }
      if ((isJML || isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
        return false;
      }
      if (isTN) {
        return false;
      }
      return true;
    }

    const columns = [
      ...(!isAPO) ? [{
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }] : [{
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return (
            <div
              onDoubleClick={()=>{
                this.state.altonSelectedProd = dependentValues.Product_id;
                this.setAltonChildVisibility(true);
              }}
            >
             {value}
            </div>
          )
      }}],
      ...(isATL || isRS || isCS || isAmzey) ? [{
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return (
            <div
              onDoubleClick={()=>{
                this.state.altonSelectedProd = dependentValues.Product_id;
                this.setAltonChildVisibility(true);
              }}
            >
             {value}
            </div>
          )
        }
      }] : [{
        key: "RefNum",
        name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: (isJML || isLO) ? 200 : 70,
      }],
      ...isAFM ? [{
        key: 'Brand',
        name: <Translate value="brand" />,
        resizable: true,
        sortable: true,
        width: 100,
      }]: [],
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 350,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "jmlBox",
        name: <Translate value="box" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "jmlPackageSize1",
        name: <Translate value="pcs/box" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : isJML ? <Translate value="total_units" /> : isTN ? <Translate value="order_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      ...isTN ? [{
        key: "Pack_Quantity",
        name: <Translate value="pack_quantity" />,
        resizable: true,
        width: 100,
        sortable: true,
      }] : [],
      ...!isTN ? [{
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      }] : [],
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      ...!isTN ? [{
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }] : [],
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      ...!isTN ? [{
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }] : [],
      ...!isTN ? [{
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }] : [],
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    if (isJML) {
      const index1 = _.findIndex(columns, { key: "NetWeight" });
      columns.splice(index1, 1);
      const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
      columns.splice(index2, 1);
    }

    if (!isJML) {
      const index1 = _.findIndex(columns, { key: "jmlPackageSize1" });
      columns.splice(index1, 1);
      const index2 = _.findIndex(columns, { key: "jmlBox" });
      columns.splice(index2, 1);
    }

    if (isABC) {
      const indexABC = _.findIndex(columns, { key: "PickupQuantity" });
      const temp = {
        key: "OriginalQuantity",
        name: <Translate value="original_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(indexABC, 0, temp);
    }

    if (isHMM) {
      const temp = {
        key: "PackageSize",
        name: <Translate value="package_size" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(5, 0, temp);
    }

    if (isTN) {
      const invCol = {
        key: "Inventory",
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const handCol = {
        key: "OnHand",
        name: <Translate value="on_hand" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const convertNumCol = {
        key: "pc_box",
        name: <Translate value="pack" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const totalBoxNumCol = {
        key: "total_box",
        name: <Translate value="carton" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const indexTN = _.findIndex(columns, { key: "Pack_Quantity" });
      columns.splice(indexTN + 1, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
    }

    if (isEcity || isLucky88) {
      const salesMarginColumn = {
        key: "ProductMargin",
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: (props) => {
          if (!props.value) return null
          if (props.value) {
            return <span>{props.value}%</span>
          }
        }
      }
      const salesMarginColumn2 = {
        key: "SalesMargin",
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: (props) => {
          if (!props.value) return null
          if (props.value) {
            return <span>{props.value}%</span>
          }
        }
      }
      const TotalPriceIndex = _.findIndex(columns, { key: "TotalPrice" });
      isMobile && columns.splice(TotalPriceIndex, 0, salesMarginColumn);
      !isMobile && columns.splice(TotalPriceIndex, 0, salesMarginColumn2)
    }

    if (isLO) {
      const refIndex = columns.findIndex(column => column.key === 'RefNum');
      if(refIndex !== -1) {
        columns[refIndex].name = <Translate value="item_num" />;
      }
      const nameIndex = columns.findIndex(column => column.key === 'Name');
      if(nameIndex !== -1) {
        columns[nameIndex].name = <Translate value="description" />;
        columns[nameIndex].width = 426;
      }
      const descriptionIndex = columns.findIndex(column => column.key === 'Description');
      if(descriptionIndex !== -1) {
        columns.splice(descriptionIndex, 1);
      }
    }

    const abcffColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "GTIN",
        name: <Translate value="gtin" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      // {
      //   key: "ReceivedCaseQty", // PerBoxQty * Quantity
      //   name: <Translate value="unit_qty" />,
      //   resizable: true,
      //   width: 80,
      //   sortable: true,
      //   getRowMetaData: row => row,
      //   formatter: ({ value, dependentValues }) => (
      //     <div>
      //       {value ? value*dependentValues.Quantity : ""}
      //     </div>
      //   ),
      // },
      {
        key: "Quantity",
        name: <Translate value="case_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PerBoxQty",
        name: <Translate value="unit_case" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_case_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "InnerLabelQty",
        name: <Translate value="inner_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OuterLabelQty",
        name: <Translate value="outer_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "StoreReady",
        name: <Translate value="store_ready" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Preticketed",
        name: <Translate value="preticketed" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: "CantonNum",
        name: <Translate value="canton" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OriginCountry",
        name: <Translate value="country" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "VendorStyleNum",
        name: <Translate value="vendor_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TJXStyleNum",
        name: <Translate value="tjx_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "UPC",
        name: <Translate value="upc" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Color",
        name: <Translate value="color" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Size",
        name: <Translate value="size_ratio" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "UnitLength",
        name: "Unit L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitWidth",
        name: "Unit W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitHeight",
        name: "Unit H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitVol",
        name: <Translate value="unit_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Remark",
        name: <Translate value="notation" />,
        resizable: true,
        sortable: true,
        width: 160,
      },
      {
        key: "UnitQuantity",
        name: <Translate value="unit_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "Quantity",
        name: <Translate value="case_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: "PerBoxQty",
        name: <Translate value="unit_case" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: "ReceivedCaseQty",
        name: <Translate value="received_case_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        getRowMetaData: (row) => row,
        formatter: ({ value, dependentValues }) => (
          <div>
            {dependentValues.PerBoxQty ? dependentValues.ReceivedQuantity / dependentValues.PerBoxQty : ""}
          </div>
        ),
      }, {
        key: "ReceivedQuantity",
        name: <Translate value="received_unit_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      }, {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "PalletStackable",
        name: <Translate value="stackable" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "StoreReady",
        name: <Translate value="store_ready" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Preticketed",
        name: <Translate value="preticketed" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: "CantonNum",
        name: <Translate value="canton" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OriginCountry",
        name: <Translate value="country" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "VendorStyleNum",
        name: <Translate value="vendor_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TJXStyleNum",
        name: <Translate value="tjx_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "UPC",
        name: <Translate value="upc" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Color",
        name: <Translate value="color" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Size",
        name: <Translate value="size_ratio" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },

      {
        key: "UnitLength",
        name: "Unit L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitWidth",
        name: "Unit W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitHeight",
        name: "Unit H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitVol",
        name: <Translate value="unit_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_case_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign22222" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];


    const kdwColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'ShipmentID',
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'ServiceType',
        name: <Translate value="service_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'ISANum',
        name: <Translate value="isa_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'CustomerRef',
        name: <Translate value="cust_ref#" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'Unloader',
        name: <Translate value="unloader" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'TruckVendor',
        name: <Translate value="truck_vendor" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "InnerLabelQty",
        name: <Translate value="inner_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OuterLabelQty",
        name: <Translate value="outer_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'ShipmentID',
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'ServiceType',
        name: <Translate value="service_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'ISANum',
        name: <Translate value="isa_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'CustomerRef',
        name: <Translate value="cust_ref#" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'Unloader',
        name: <Translate value="unloader" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'TruckVendor',
        name: <Translate value="truck_vendor" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const yiColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "InnerLabelQty",
        name: <Translate value="inner_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OuterLabelQty",
        name: <Translate value="outer_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TotalShippingWeight",
        name: <Translate value="total_ship_wt" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "NMFCClass",
        name: <Translate value="nmfc" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TotalShippingWeight",
        name: <Translate value="total_ship_wt" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "NMFCClass",
        name: <Translate value="nmfc" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const dsqColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "InnerLabelQty",
        name: <Translate value="inner_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OuterLabelQty",
        name: <Translate value="outer_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const DateFormatter2 = React.createClass({
      render() {
        if (this.props.value) {
          const date = moment(this.props.value).format("MM-DD-YY");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const wizColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "FBACode",
        name: <Translate value="fba" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="shipped_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },

      {
        key: "CustomerBoxQty",
        name: <Translate value="customer_box" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "OutsideLabelQty",
        name: <Translate value="outside_label" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "InsideLabelQty",
        name: <Translate value="inside_label" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "SpecialHandling",
        name: <Translate value="special_handling" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      },
      {
        key: "CustomerNote",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      },
      {
        key: "InboundCustomer",
        name: <Translate value="inbound_customer" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: "InboundContainer",
        name: <Translate value="inbound_container" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: "InboundDate",
        name: <Translate value="inbound_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: DateFormatter2,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="customer_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "DispatchType",
        name: <Translate value="dispatch_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "IsOversize",
        name: <Translate value="IsOversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="IsOverweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="rcvd_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="customer_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "IsOversize",
        name: <Translate value="oversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="overweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "DispatchType",
        name: <Translate value="warehouse_note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "DrayageTrucker",
        name: <Translate value="dray_trucker" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const jtbColumnBottom = [
        {
          key: "ProductNum",
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: "RefNum",
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
        },
        {
          key: "Name",
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 350,
        },
        {
          key: "Description",
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: "Quantity",
          name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: "PickupQuantity",
          name: <Translate value="shipped_qty" />,
          resizable: true,
          width: 80,
          sortable: true,
        },
        {
          key: "UnitPrice",
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        ...showProductCost() ? [{
          key: "CostPrice",
          name: <Translate value="cost_price" />,
          resizable: true,
          width: 70,
          sortable: true,
        }] : [],
        {
          key: "TotalPrice",
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: "ProductTax",
          name: <Translate value="tax" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: "TotalNetWeight",
          name: <Translate value="total_weight" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
    ];
    const generateColumnsBottom = () => {
      if (isDSQ || isWUFS || isFBD) {
        return dsqColumnBottom;
      }
      if (isYI) {
        return yiColumnBottom;
      }
      if (isKDW) {
        return kdwColumnBottom;
      }
      if (isABCFF) {
        return abcffColumnBottom;
      }
      if (isWIZ) {
        return wizColumnBottom;
      }
      if (isJTB) {
        return jtbColumnBottom;
      }
      return columns;
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="SalesOrder_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              // columns={columns}
              columns={generateColumnsBottom()}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }


  saveMagStuff() {
    if (!this.state.magSalesOrderDetail) {
      return;
    }

    const {mag1, mag2} = this.state;

    let magNoteTemp = [];
    if (mag1.DRYRUN) { magNoteTemp.push('DRYRUN')}
        if (mag1.OFFHIRE) { magNoteTemp.push('OFFHIRE')}
        if (mag1.PIERPASS) { magNoteTemp.push('PIERPASS')}
        if (mag1.AN_FEE) { magNoteTemp.push('AN_FEE')}
        if (mag1.OTHER) { magNoteTemp.push('OTHER')}
        if (mag1.HANDLING) { magNoteTemp.push('HANDLING')}
        if (mag1.EXTRA_STOP) { magNoteTemp.push('EXTRA_STOP')}
        if (mag1.EXAM) { magNoteTemp.push('EXAM')}
        if (mag1.EXTRA_DELIVERY) { magNoteTemp.push('EXTRA_DELIVERY')}
        if (mag1.STORAGE) { magNoteTemp.push('STORAGE')}
        if (mag1.BOBTAIL_FEE) { magNoteTemp.push('BOBTAIL_FEE')}
        if (mag1.CHASSIS_SPLIT) { magNoteTemp.push('CHASSIS_SPLIT')}
        if (mag1.CTF) { magNoteTemp.push('CTF')}
        if (mag1.FSC) { magNoteTemp.push('FSC')}
        if (mag1.PREPULL) { magNoteTemp.push('PREPULL')}
        if (mag1.CONGESTION) { magNoteTemp.push('CONGESTION')}
        if (mag1.DROPOFF) { magNoteTemp.push('DROPOFF')}
        if (mag1.OVERWEIGHT) { magNoteTemp.push('OVERWEIGHT')}
        this.state.magSalesOrderDetail.mag_note = magNoteTemp.join(',');

        let magDeliveryStatusTemp = [];
        if (mag2.FREIGHT_HOLD) { magDeliveryStatusTemp.push('FREIGHT_HOLD')}
        if (mag2.CUSTOM_HOLD) { magDeliveryStatusTemp.push('CUSTOM_HOLD')}
        if (mag2.PIERPASS_HOLD) { magDeliveryStatusTemp.push('PIERPASS_HOLD')}
        if (mag2.EXAM) { magDeliveryStatusTemp.push('EXAM')}
        if (mag2.CLOSED_AREA) { magDeliveryStatusTemp.push('CLOSED_AREA')}
        this.state.magSalesOrderDetail.DeliveryStatus = magDeliveryStatusTemp.join(',');

    axios.put(
      (SALES_ORDERS_URL + this.state.magSalesOrderDetail.SalesOrder_id),
      this.state.magSalesOrderDetail,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Order Saved");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));

    });
  }

  renderMagContainer() {
    let {magSalesOrderDetail, mag1, mag2} = this.state;

    magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;

    const handleContainerChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerDrop = (e, keyname) => {
      magSalesOrderDetail[keyname] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerCheck1 = (keyname) => {
      mag1[keyname] = !mag1[keyname];
      this.setState( { mag1 });
    }

    const handleContainerCheck2 = (keyname) => {
      mag2[keyname] = !mag2[keyname];
      this.setState( { mag2 });
    }

    const magTerminalOptions = [
      {label: "EVERPORT", value: "EVERPORT"},
      {label: "LBCT", value: "LBCT"},
      {label: "SHIPPERS-CARSON", value: "SHIPPERS-CARSON"},
      {label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA"},
      {label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH"},
      {label: "TRAPAC", value: "TRAPAC"},
      {label: "WBCT", value: "WBCT"},
      {label: 'PCT', value: "PCT"},
      {label: "ITS", value: "ITS"},
      {label: "APM", value: "APM"},
      {label: "C60-MATSON", value: "C60-MATSON"},
      {label: "TTI", value: "TTI"},
      {label: "YUSEN", value: "YUSEN"},
      {label: "FMS", value: "FMS"},
      {label: "PIER-A", value: "PIER-A"},
      {label: "EXAM-SITE", value: "EXAM-SITE"},
      {label: "OTHER", value: "OTHER"},
    ];

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="container_num" /></label>
            <div className="col-xs-8">
              <Input disabled={true} value={magSalesOrderDetail.ContainerNum ? magSalesOrderDetail.ContainerNum : ""} name="ContainerNum" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="bol_num" /></label>
            <div className="col-xs-8">
              <Input disabled={true} value={magSalesOrderDetail.bolNum ? magSalesOrderDetail.bolNum : ""} name="bolNum" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-4" style={{marginBottom: '15px'}}><Translate value="terminal" /></label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
            <Dropdown>
              <Dropdown.Toggle style={{ height: '25px', width: '200px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                {magSalesOrderDetail.terminal ? magSalesOrderDetail.terminal : 'SELECT'}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {magTerminalOptions.map(el => {
                  return (
                    <MenuItem onClick={() => handleContainerDrop(el, 'terminal')}>{el.label}</MenuItem>
                  )
                })}
              </Dropdown.Menu>
            </Dropdown>
            </div>
            <label className="col-xs-4" style={{marginBottom: '15px'}}>LFD</label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleContainerDate(e, 'delivery_lfd')
                }}
                time={false}
                value={magSalesOrderDetail.delivery_lfd}
              />
            </div>
          </Col>
          <Col xs={5}>
            <label className="col-xs-3">HOLD (Select)</label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="FREIGHT_HOLD"
                checked={mag2.FREIGHT_HOLD}
                onClick={() => {
                  handleContainerCheck2('FREIGHT_HOLD');
                }}
              />
              <span>Freight Hold</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="CUSTOM_HOLD"
                checked={mag2.CUSTOM_HOLD}
                onClick={() => {
                  handleContainerCheck2('CUSTOM_HOLD');
                }}
              />
              <span>Custom Hold</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="PIERPASS_HOLD"
                checked={mag2.PIERPASS_HOLD}
                onClick={() => {
                  handleContainerCheck2('PIERPASS_HOLD');
                }}
              />
              <span>Pierpass Hold</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3"></label>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="EXAM"
                checked={mag2.EXAM}
                onClick={() => {
                  handleContainerCheck2('EXAM');
                }}
              />
              <span>Exam</span>
            </div>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="CLOSED_AREA"
                checked={mag2.CLOSED_AREA}
                onClick={() => {
                  handleContainerCheck2('CLOSED_AREA');
                }}
              />
              <span>Closed Area</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>
            <label className="col-xs-3">HOLD (Other)</label>
            <div className="col-xs-9">
              <Input value={magSalesOrderDetail.DeliveryStatusOther ? magSalesOrderDetail.DeliveryStatusOther : ""} name="DeliveryStatusOther" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-3">Note (Select)</label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="DRYRUN"
                checked={mag1.DRYRUN}
                onClick={() => {
                  handleContainerCheck1('DRYRUN');
                }}
              />
              <span>Dryrun</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="OFFHIRE"
                checked={mag1.OFFHIRE}
                onClick={() => {
                  handleContainerCheck1('OFFHIRE');
                }}
              />
              <span>Offhire</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXTRA_STOP"
                checked={mag1.EXTRA_STOP}
                onClick={() => {
                  handleContainerCheck1('EXTRA_STOP');
                }}
              />
              <span>Extra Stop</span>
            </div>
            <label className="col-xs-3"></label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXAM"
                checked={mag1.EXAM}
                onClick={() => {
                  handleContainerCheck1('EXAM');
                }}
              />
              <span>Exam</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXTRA_DELIVERY"
                checked={mag1.EXTRA_DELIVERY}
                onClick={() => {
                  handleContainerCheck1('EXTRA_DELIVERY');
                }}
              />
              <span>Extra Delivery</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="STORAGE"
                checked={mag1.STORAGE}
                onClick={() => {
                  handleContainerCheck1('STORAGE');
                }}
              />
              <span>Storage</span>
            </div>
            <label className="col-xs-3"></label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="OVERWEIGHT"
                checked={mag1.OVERWEIGHT}
                onClick={() => {
                  handleContainerCheck1('OVERWEIGHT');
                }}
              />
              <span>Overweight</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="DROPOFF"
                checked={mag1.DROPOFF}
                onClick={() => {
                  handleContainerCheck1('DROPOFF');
                }}
              />
              <span>Dropoff</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="CONGESTION"
                checked={mag1.CONGESTION}
                onClick={() => {
                  handleContainerCheck1('CONGESTION');
                }}
              />
              <span>Congestion</span>
            </div>
            <label className="col-xs-3"></label>
            <div  className="col-xs-3">
              <input
                type="checkbox"
                name="BOBTAIL_FEE"
                checked={mag1.BOBTAIL_FEE}
                onClick={() => {
                  handleContainerCheck1('BOBTAIL_FEE');
                }}
              />
              <span>Bobtail Fee</span>
            </div>
            <div  className="col-xs-3">
              <input
                type="checkbox"
                name="PREPULL"
                checked={mag1.PREPULL}
                onClick={() => {
                  handleContainerCheck1('PREPULL');
                }}
              />
              <span>Prepull</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="CHASSIS_SPLIT"
                checked={mag1.CHASSIS_SPLIT}
                onClick={() => {
                  handleContainerCheck1('CHASSIS_SPLIT');
                }}
              />
              <span>Chassis Split</span>
            </div>
            <label className="col-xs-3"></label>
            <div  className="col-xs-3">
              <input
                type="checkbox"
                name="HANDLING"
                checked={mag1.HANDLING}
                onClick={() => {
                  handleContainerCheck1('HANDLING');
                }}
              />
              <span>Handling Fee</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="PIERPASS"
                checked={mag1.PIERPASS}
                onClick={() => {
                  handleContainerCheck1('PIERPASS');
                }}
              />
              <span>Pierpass</span>
            </div>
            <div  className="col-xs-3">
              <input
                type="checkbox"
                name="AN_FEE"
                checked={mag1.AN_FEE}
                onClick={() => {
                  handleContainerCheck1('AN_FEE');
                }}
              />
              <span>AN Fee</span>
            </div>
            <label className="col-xs-3"></label>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="CTF"
                checked={mag1.CTF}
                onClick={() => {
                  handleContainerCheck1('CTF');
                }}
              />
              <span>CTF</span>
            </div>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="FSC"
                checked={mag1.FSC}
                onClick={() => {
                  handleContainerCheck1('FSC');
                }}
              />
              <span>FSC</span>
            </div>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="OTHER"
                checked={mag1.OTHER}
                onClick={() => {
                  handleContainerCheck1('OTHER');
                }}
              />
              <span>Other</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>
            {/* <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label> */}
            {/* <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label> */}
            <label className="col-xs-3">Note (Other)</label>
            <div className="col-xs-9">
              <Input value={magSalesOrderDetail.mag_note_other ? magSalesOrderDetail.mag_note_other : ""} name="mag_note_other" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
          </Col>
          <Col xs={3}>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagLoad() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;

    magSalesOrderDetail.pick_appt_date = magSalesOrderDetail.pick_appt_date ? new Date(magSalesOrderDetail.pick_appt_date) : null;
    magSalesOrderDetail.loadout_date = magSalesOrderDetail.loadout_date ? new Date(magSalesOrderDetail.loadout_date) : null;
    magSalesOrderDetail.portwaiting_start_time = magSalesOrderDetail.portwaiting_start_time ? new Date(magSalesOrderDetail.portwaiting_start_time) : null;
    magSalesOrderDetail.portwaiting_finish_time = magSalesOrderDetail.portwaiting_finish_time ? new Date(magSalesOrderDetail.portwaiting_finish_time) : null;

    // if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
    //   return <Spinner />;
    // else if (this.props.salesOrderError) {
    //   return (
    //     <ContentWrapper>
    //       <div className="alert alert-danger">
    //         {JSON.stringify(this.props.salesOrderError)}
    //       </div>
    //     </ContentWrapper>
    //   );
    // }

    // const tableHeight = window.innerHeight < 930 ? 185 : 185;

    // const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);

    // const getSize = () => getRows().length;

    // const rowGetter = (rowIdx) => {
    //   const rows = getRows();
    //   return rows[rowIdx];
    // };

    // const generateColumnsBottom = () => {
    //   if (isWIZ) {
    //     return wizColumnBottom;
    //   }
    //   if (isJTB) {
    //     return jtbColumnBottom;
    //   }
    //   return columns;
    // };
    const handleLoadChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleLoadDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="pickup_appt_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'pick_appt_date')
                }}
                time={true}
                value={magSalesOrderDetail.pick_appt_date}
              />
            </div>
            {/* <label className="col-xs-4"><Translate value="pickup_appt_time" /></label>
              <div className="col-xs-8">
              <Input value={magSalesOrderDetail.pick_appt_time ? magSalesOrderDetail.pick_appt_time : ""} name="pick_appt_time" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div> */}
            <label className="col-xs-4"><Translate value="pickup_appt_#" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.pick_appt_num ? magSalesOrderDetail.pick_appt_num : ""} name="pick_appt_num" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="loadout_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'loadout_date')
                }}
                time={false}
                value={magSalesOrderDetail.loadout_date}
              />
            </div>
            <label className="col-xs-4"><Translate value="chassis_num" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.chassis_num ? magSalesOrderDetail.chassis_num : ""} name="chassis_num" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="loadout_port_waiting" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.LOADOUT_PORT_WAITING ? magSalesOrderDetail.LOADOUT_PORT_WAITING : ""} name="LOADOUT_PORT_WAITING" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="portwaiting_start" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'portwaiting_start_time')
                }}
                time={true}
                value={magSalesOrderDetail.portwaiting_start_time}
              />
            </div>

            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="portwaiting_finish" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'portwaiting_finish_time')
                }}
                time={true}
                value={magSalesOrderDetail.portwaiting_finish_time}
              />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagDelivery() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.SCHEDULED_DELIVERY_DATE = magSalesOrderDetail.SCHEDULED_DELIVERY_DATE ? new Date(magSalesOrderDetail.SCHEDULED_DELIVERY_DATE) : null;
    magSalesOrderDetail.ACTUAL_DELIVERY_DATE = magSalesOrderDetail.ACTUAL_DELIVERY_DATE ? new Date(magSalesOrderDetail.ACTUAL_DELIVERY_DATE) : null;
    magSalesOrderDetail.DETENTION_START_TIME = magSalesOrderDetail.DETENTION_START_TIME ? new Date(magSalesOrderDetail.DETENTION_START_TIME) : null;
    magSalesOrderDetail.DETENTION_FINISH_TIME = magSalesOrderDetail.DETENTION_FINISH_TIME ? new Date(magSalesOrderDetail.DETENTION_FINISH_TIME) : null;

    const handleDeliveryChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleDeliveryDrop = (e, keyname) => {
      magSalesOrderDetail[keyname] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleDeliveryDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    const magDeliveryTypeOptions = [
      {
        label: 'DROP_HOOK',
        value: 'DROP_HOOK',
      },
      {
        label: 'LIVE_UNLOADING',
        value: 'LIVE_UNLOADING',
      },
    ]

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            {/* <label className="col-xs-4"><Translate value="delivery_test" /></label>
              <div className="col-xs-8">
              <Input name="Test2" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
              </div> */}
            <label className="col-xs-4" style={{marginBottom: '15px'}}><Translate value="delivery_type" /></label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '25px', width: '150px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {magSalesOrderDetail.DELIVERY_TYPE ? magSalesOrderDetail.DELIVERY_TYPE : 'SELECT'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {magDeliveryTypeOptions.map(el => {
                    return (
                      <MenuItem onClick={() => handleDeliveryDrop(el, 'DELIVERY_TYPE')}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="scheduled_delivery" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'SCHEDULED_DELIVERY_DATE')
                }}
                time={true}
                value={magSalesOrderDetail.SCHEDULED_DELIVERY_DATE}
              />
            </div>
            <label className="col-xs-4" ><Translate value="appointment_#" /></label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM ? magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM : ""} name="SCHEDULED_DELIVERY_APPT_NUM" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="actual_delivery" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'ACTUAL_DELIVERY_DATE')
                }}
                time={true}
                value={magSalesOrderDetail.ACTUAL_DELIVERY_DATE}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4" ><Translate value="detention_waiting_time" /></label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.DETENTION_WAITING_TIME ? magSalesOrderDetail.DETENTION_WAITING_TIME : ""} name="DETENTION_WAITING_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            {/* <label className="col-xs-4" ><Translate value="detention_start_time" /></label>
            <div className="col-xs-8" >
            <Input name="DETENTION_START_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            <label className="col-xs-4" ><Translate value="detention_finish_time" /></label>
            <div className="col-xs-8" >
            <Input name="DETENTION_FINISH_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div> */}
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="detention_start_time" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'DETENTION_START_TIME')
                }}
                time={true}
                value={magSalesOrderDetail.DETENTION_START_TIME}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="detention_finish_time" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'DETENTION_FINISH_TIME')
                }}
                time={true}
                value={magSalesOrderDetail.DETENTION_FINISH_TIME}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4" >POD</label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.POD ? magSalesOrderDetail.POD : ""} name="POD" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            <Button
              bsStyle="success"
              type="submit"
              onClick={() => {
                // this.refs.msoCreateInputRef4.click();
                this.openWIZPOD();
              }}
              disabled={this.state.salesOrders.selectedRows.length !== 1}
            >
              <em className="fa fa-list" />
              <Translate value="pod" />
            </Button>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagEmpty() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.EMPTY_NOTIFICATION_DATE = magSalesOrderDetail.EMPTY_NOTIFICATION_DATE ? new Date(magSalesOrderDetail.EMPTY_NOTIFICATION_DATE) : null;
    magSalesOrderDetail.EMPTY_PICKUP_DATE = magSalesOrderDetail.EMPTY_PICKUP_DATE ? new Date(magSalesOrderDetail.EMPTY_PICKUP_DATE) : null;
    magSalesOrderDetail.EMPTYIN_APPT_DATETIME = magSalesOrderDetail.EMPTYIN_APPT_DATETIME ? new Date(magSalesOrderDetail.EMPTYIN_APPT_DATETIME) : null;
    magSalesOrderDetail.Empty_Return_FINAL_Date = magSalesOrderDetail.Empty_Return_FINAL_Date ? new Date(magSalesOrderDetail.Empty_Return_FINAL_Date) : null;
    magSalesOrderDetail.empty_back_to_yard_date = magSalesOrderDetail.empty_back_to_yard_date ? new Date(magSalesOrderDetail.empty_back_to_yard_date) : null;


    const handleEmptyChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleEmptyDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }
    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="empty_status" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_STATUS ? magSalesOrderDetail.EMPTY_STATUS : ""} name="EMPTY_STATUS" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_notification" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTY_NOTIFICATION_DATE')
                }}
                time={false}
                value={magSalesOrderDetail.EMPTY_NOTIFICATION_DATE}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_pickup_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTY_PICKUP_DATE')
                }}
                time={false}
                value={magSalesOrderDetail.EMPTY_PICKUP_DATE}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="empty_location" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_LOCATION ? magSalesOrderDetail.EMPTY_LOCATION : ""} name="EMPTY_LOCATION" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="empty-in_terminal" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_IN_TERMINAL ? magSalesOrderDetail.EMPTY_IN_TERMINAL : ""} name="EMPTY_IN_TERMINAL" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_appt" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTYIN_APPT_DATETIME')
                }}
                time={true}
                value={magSalesOrderDetail.EMPTYIN_APPT_DATETIME}
              />
            </div>
            <label className="col-xs-4"><Translate value="empty_appt#" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_APPT_NUM ? magSalesOrderDetail.EMPTY_APPT_NUM : ""} name="EMPTY_APPT_NUM" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="return_final_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'Empty_Return_FINAL_Date')
                }}
                time={false}
                value={magSalesOrderDetail.Empty_Return_FINAL_Date}
              />
            </div>
            <label className="col-xs-4"><Translate value="return_final_terminal" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.Empty_Return_FINAL_TERMINAL ? magSalesOrderDetail.Empty_Return_FINAL_TERMINAL : ""} name="Empty_Return_FINAL_TERMINAL" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="empty_portwaiting" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTYIN_PORTWAITING ? magSalesOrderDetail.EMPTYIN_PORTWAITING : ""} name="EMPTYIN_PORTWAITING" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}>Empty Back to Yard</label>
              <div className="col-xs-7" style={{marginBottom: '15px'}}>
                <DateTimePicker
                  id="all-register-datepicker"
                  format="MM-DD-YY"
                  // max={Today}
                  // step={10}
                  onChange={(e) => {
                    handleEmptyDate(e, 'empty_back_to_yard_date')
                  }}
                  time={false}
                  value={magSalesOrderDetail.empty_back_to_yard_date}
                />
              </div>
            </Col>
        </Col>
      </Row>
    );
  }

  renderProductsTableFJ() {
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
      return <Spinner />;
    else if (this.props.salesOrderError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.salesOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        selectedRows: rows,
      };
      this.setState({ salesOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const showProductCost = () => {
      if (isHMM || isJML) {
        return false;
      }
      if ((isJML || isChinaTown || isRivera) && checkPermissionLocal('no_show_product_cost')) {
        return false;
      }
      return true;
    };

    const columns = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: isJML ? 200 : 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 350,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    if (isJML) {
      const index1 = _.findIndex(columns, { key: "NetWeight" });
      columns.splice(index1, 1);
      const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
      columns.splice(index2, 1);
    }

    if (isABC) {
      const indexABC = _.findIndex(columns, { key: "PickupQuantity" });
      const temp = {
        key: "OriginalQuantity",
        name: <Translate value="original_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(indexABC, 0, temp);
    }

    if (isHMM) {
      const temp = {
        key: "PackageSize",
        name: <Translate value="package_size" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(5, 0, temp);
    }

    if (isTN) {
      const invCol = {
        key: "Inventory",
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const handCol = {
        key: "OnHand",
        name: <Translate value="on_hand" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const convertNumCol = {
        key: "pc_box",
        name: <Translate value="pack" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const totalBoxNumCol = {
        key: "total_box",
        name: <Translate value="carton" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const indexTN = _.findIndex(columns, { key: "PickupQuantity" });
      columns.splice(indexTN, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
    }
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    const jtbColumnBottom = [
        {
          key: "ProductNum",
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: "RefNum",
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
        },
        {
          key: "Name",
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 350,
        },
        {
          key: "Description",
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: "Quantity",
          name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: "PalletQuantity",
          name: <Translate value="pallet_qty" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: "PickupQuantity",
          name: <Translate value="shipped_qty" />,
          resizable: true,
          width: 80,
          sortable: true,
        },
        {
          key: "PackageType",
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 80,
          sortable: true,
        },
        {
          key: "UnitPrice",
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        ...showProductCost() ? [{
          key: "CostPrice",
          name: <Translate value="cost_price" />,
          resizable: true,
          width: 70,
          sortable: true,
        }] : [],
        {
          key: "TotalPrice",
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: "ProductTax",
          name: <Translate value="tax" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: "NetWeight",
          name: <Translate value="net_weight" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: "TotalNetWeight",
          name: <Translate value="total_weight" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
    ];

    const wizColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "DispatchType",
        name: <Translate value="dispatch_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "IsOversize",
        name: <Translate value="IsOversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="IsOverweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const generateColumnsBottom = () => {
      if (isWIZ) {
        return wizColumnBottom;
      }
      if (isJTB) {
        return jtbColumnBottom;
      }
      return columns;
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="SalesOrder_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              // columns={columns}
              columns={generateColumnsBottom()}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  shippingIFrameIsLoaded = () => {
    if (!this.state.shippingPdfFrameLoaded) {
      const pdfFrame = window.frames.shippingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ shippingPdfFrameLoaded: true });
    }
  };

  renderShippingIFrame() {
    if (this.props.shippingListPDF) {
      const file = window.URL.createObjectURL(this.props.shippingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.shippingIFrameIsLoaded}
          id="shippingPdf"
          name="shippingPdf"
          src={file}
        />
      );
    }
  }

  packingIFrameIsLoaded = () => {
    if (!this.state.packingListPdfFrameLoaded) {
      const pdfFrame = window.frames.packingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ packingListPdfFrameLoaded: true });
    }
  };

  renderPackingIFrame() {
    if (this.props.packingListPDF) {
      const file = window.URL.createObjectURL(this.props.packingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.packingIFrameIsLoaded}
          id="packingPdf"
          name="packingPdf"
          src={file}
        />
      );
    }
  }

  pickingIFrameIsLoaded = () => {
    if (!this.state.pickingListPdfFrameLoaded) {
      const pdfFrame = window.frames.pickingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ pickingListPdfFrameLoaded: true });
    }
  };

  renderPickingIFrame() {
    if (this.props.pickingListPDF) {
      const file = window.URL.createObjectURL(this.props.pickingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.pickingIFrameIsLoaded}
          id="pickingPdf"
          name="pickingPdf"
          src={file}
        />
      );
    }
  }

  salesOrderIFrameIsLoaded = () => {
    if (!this.state.salesOrderPdfFrameLoaded) {
      const pdfFrame = window.frames.salesOrderPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ salesOrderPdfFrameLoaded: true });
    }
  };

  renderSalesOrderIFrame() {
    if (this.props.salesOrderPDF) {
      const file = window.URL.createObjectURL(this.props.salesOrderPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.salesOrderIFrameIsLoaded}
          id="salesOrderPdf"
          name="salesOrderPdf"
          src={file}
        />
      );
    }
  }

  bolByIdIFrameIsLoaded = () => {
    if (!this.state.bolIdPdfFrameLoaded) {
      const pdfFrame = window.frames.bolIdPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolIdPdfFrameLoaded: true });
    }
  };
  renderBolByIdIFrame() {
    if (this.props.bolIdPDF) {
      const file = window.URL.createObjectURL(this.props.bolIdPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolByIdIFrameIsLoaded}
          id="bolIdPdf"
          name="bolIdPdf"
          src={file}
        />
      );
    }
  }

  bolWithoutLogIFrameIsLoaded = () => {
    if (!this.state.bolWithoutLogPdfFrameLoaded) {
      const pdfFrame = window.frames.bolWithoutLogPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolWithoutLogPdfFrameLoaded: true });
    }
  };

  renderBolWithoutLogIFrame() {
    if (this.props.bolWithoutLogPDF) {
      const file = window.URL.createObjectURL(this.props.bolWithoutLogPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolWithoutLogIFrameIsLoaded}
          id="bolWithoutLogPdf"
          name="bolWithoutLogPdf"
          src={file}
        />
      );
    }
  }

  bolLabelIFrameIsLoaded = () => {
    if (!this.state.bolLabelFrameLoaded) {
      const pdfFrame = window.frames.bolLabel;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolLabelFrameLoaded: true });
    }
  };

  renderBolLabelIFrame() {
    if (this.props.bolLabel) {
      const file = window.URL.createObjectURL(this.props.bolLabel);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolLabelIFrameIsLoaded}
          id="bolLabel"
          name="bolLabel"
          src={file}
        />
      );
    }
  }

  bolByFbaIFrameIsLoaded = () => {
    if (!this.state.bolFbaPdfFrameLoaded) {
      const pdfFrame = window.frames.bolFbaPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolFbaPdfFrameLoaded: true });
    }
  };

  PODIframLoaded = () => {
    if (!this.state.PODIframeLoaded) {
      const pdfFrame = window.frames.podPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PODIframeLoaded: true });
    }
  }
  renderBolByFbaIFrame() {
    if (this.props.bolFbaPDF) {
      const file = window.URL.createObjectURL(this.props.bolFbaPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolByFbaIFrameIsLoaded}
          id="bolFbaPdf"
          name="bolFbaPdf"
          src={file}
        />
      );
    }
  }

  // renderPODIFrame() {
  //   if (this.state.selectedPODFile) {
  //     const file = window.URL.createObjectURL(this.state.selectedPODFile);
  //     return (
  //       <iframe
  //         style={{ display: "none" }}
  //         onLoad={this.PODIframLoaded}
  //         id="podPdf"
  //         name="podPdf"
  //         src={file}
  //       />
  //     );
  //   }
  // }

  renderPrint() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    // if(!salesOrder_id)
    //   return;
    const url = `${ROOT_URL}v1/sale/printorder/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const picking_url = `${ROOT_URL}v1/sale/printpickinglist/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const shipping_url = `${ROOT_URL}v1/sale/printshippinglist/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const packing_url = `${ROOT_URL}v1/sale/printpackinglist/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    return (
      <div className="padLeft" id={isABC && "buttonsContainer-padLeft"}>
        { !isABCFF &&
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrder_id || !checkPermission("print_sales_order")}
            type="button"
            onClick={() => {
              this.props.printSalesOrder(salesOrder_id);
            }}
          >
            <em className="fa fa-print" />
            <Translate value="print_so" />
          </Button>
        }
        { (!isABC && !isSW && !isABCFF) && this.renderPickingListPrint() }
        { (!isABC && !isSW && !isABCFF) && this.renderPackingListPrint() }
        { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderPackingListPrint() }
        { (!isABC && !isSW && !isABCFF) && this.renderShippingListPrint() }
        { isUSPride && this.renderExportSelectedButton() }

        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderPickingListPrint() }
        { (isABCFF && this.context.router.routes[1].path !== "outboundOrders") && this.renderReceivingReportPrint() }
        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderDscoShipmentButton() }
        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderWalmartShipmentButton() }

        { isSW && this.renderPickingListPrintSW()}
        { isSW && this.renderPackingListPrintSW()}
        { isSW && this.renderShippingListPrintSW()}

        { isTN && this.renderSetSOOpen() }
        {/* { (isCO || isABC || isTN) && this.renderSubmitBolImageButton() } */}
        {/* { (isTN) && this.renderSubmitBolImageButtonTN() } */}
        {/* { (isABC || isTN) && this.renderUploadPODButton() } */}
        {/* { isABC && this.renderLocatioinChangeButton() } */}
        { isABC && this.renderInboundDateEditButton() }
        { isABC &&
          <Button
            style={{ float: 'right' }}
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.setState({
                abcDatePickerShow: !this.state.abcDatePickerShow,
              });
            }}
          >
            <Translate value="advanced_search" />
          </Button>
        }
      </div>
    );
  }

  setLabelPrintModalVisibility = (isLabelPrintModalVisible = false) => this.setState({ isLabelPrintModalVisible });

  renderPickingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    if (salesOrders.selectedRows.length <= 1 && !isATL) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id || !checkPermission("print_sales_order")}
          type="button"
          onClick={() => {
            if (isJML) {
              this.setLabelPrintModalVisibility(true);
              return;
            }
            this.props.printPickingList(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate
            value={isMyuMyu || isAFG || isWecom ? "pull_sheet" : "picking_list"}
          />
        </Button>
      );
    } else if (isATL) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={salesOrderIds.length === 0}
          type="button"
          onClick={() => {
            this.props.printPickingListATL(salesOrderIds.join(','));
          }}
        >
          <em className="fa fa-print" />
          <Translate
            value={"driver_list"}
          />
        </Button>
      );
    }
    if (isAFG || isMyuMyu || isWecom) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          disabled={!checkPermission("print_sales_order")}
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openChangePullSheet();
          }}
        >
          <em className="fa fa-print" />
          <Translate value="pull_sheet" />
        </Button>
      );
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={!checkPermission("print_sales_order")}
        onClick={() => {
          this.props.printPickingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value="picking_list" />
      </Button>
    );
  }

  renderPickingListPrintSW() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    if (salesOrders.selectedRows.length <= 1) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id || !checkPermission("print_sales_order")}
          type="button"
          onClick={() => {
            this.props.printPickingList(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />

          <Translate
            value={isMyuMyu || isAFG || isWecom ? "pull_sheet" : "picking_list"}
          />

        </Button>
      );
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={!checkPermission("print_sales_order")}
        onClick={() => {
          this.props.printPickingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value="picking_list" />
      </Button>
    );
  }

  renderPackingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;

    let allHaveInvoiceNum = true;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
        if (!salesOrder.InvoiceNum && isHMM) {
          allHaveInvoiceNum = false;
        }
      });
    }

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 ||
          !checkPermission("print_sales_order") ||
          !allHaveInvoiceNum
        }
        type="button"
        onClick={() => {
          if (isATL) {
            this.props.printPackingListATL(salesOrderIds.join(","));
          } else {
          this.props.printPackingList(salesOrderIds.join(","));
          }
        }}
      >
        <em className="fa fa-print" />
        {
          !isATL &&
          <Translate
            value={
              isMyuMyu || isAFG || isWecom ? "picking_sheet" : "packing_list"
            }
          />
        }
        { isATL && <Translate value={"order_details"} /> }
      </Button>
    );
  }

  renderPackingListPrintSW() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;

    let allHaveInvoiceNum = true;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
        if (!salesOrder.InvoiceNum && isHMM) {
          allHaveInvoiceNum = false;
        }
      });
    }

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 ||
          !checkPermission("print_sales_order") ||
          !allHaveInvoiceNum
        }
        type="button"
        onClick={() => {
          this.props.printPackingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate
          value={
            isMyuMyu || isAFG || isWecom ? "picking_sheet" : "packing_list"
          }
        />
      </Button>
    );
  }

  renderReceivingReportPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || !checkPermission("print_sales_order")
        }
        type="button"
        onClick={() => {
          this.props.printPackingList(salesOrderIds.join(","));
          // this.props.printReceivingReport(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value={"receiving_report"} />
      </Button>
    );
  }

  renderShippingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || !checkPermission("print_sales_order")
        }
        type="button"
        onClick={() => {
          if (isATL) {
            this.props.printShippingListATL(salesOrderIds.join(","));
          } else {
          this.props.printShippingList(salesOrderIds.join(","));
          }
        }}
      >
        <em className="fa fa-print" />
        <Translate value={isATL ? "shipping_request" : "shipping_list"} />
      </Button>
    );
  }

  renderShippingListPrintSW() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || !checkPermission("print_sales_order")
        }
        type="button"
        onClick={() => {
          this.props.printShippingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value={"shipping_list"} />
      </Button>
    );
  }

  renderDscoShipmentButton() {
    return (
      <Button
        style={{ marginLeft: '5px' }}
        bsStyle="success"
        type="button"
        onClick={() => { this.refs.dsco_ref.click(); }}
        disabled={false}
      >
        <em className="fa fa-upload" /><Translate value="dsco_shipment" />
      </Button>
    );
  }

  renderWalmartShipmentButton() {
    return (
      <Button
        style={{ marginLeft: '5px' }}
        bsStyle="success"
        type="button"
        onClick={() => { this.refs.walmartb2b_ref.click(); }}
        disabled={false}
      >
        <em className="fa fa-upload" /><Translate value="walmart_shipment" />
      </Button>
    );
  }


  renderYingBOLPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || !checkPermission("print_sales_order")
        }
        type="button"
        onClick={() => {
          this.props.printYingBOL(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        &nbsp;BOL
      </Button>
    );
  }


  // renderYingPrintFile() {
  //   const salesOrderIds = [];
  //   const { salesOrders } = this.state;
  //   if (salesOrders && salesOrders.selectedRows) {
  //     salesOrders.selectedRows.forEach((salesOrder) => {
  //       salesOrderIds.push(salesOrder.SalesOrder_id);
  //     });
  //   }
  //   return (
  //     <Button
  //       bsStyle="primary"
  //       className="print-btn"
  //       disabled={
  //         salesOrderIds.length === 0 || !checkPermission("print_sales_order")
  //       }
  //       type="button"
  //       onClick={() => {
  //         this.props.printYingCustomerFile(salesOrderIds.join(","));
  //       }}
  //     >
  //       <em className="fa fa-print" />
  //       <Translate value="customer_label" />
  //     </Button>
  //   );
  // }

  renderYingPrintFile() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v2/sales/order-file-upload/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="primary"
        type="button"
        className="print-btn"
        // href={exportUrl}
        onClick={() => {
          this.yingPrintFile();
        }}
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
      >
        <em className="fa fa-download" />
        <Translate value="customer_label" />
      </Button>
    );
  }

  yingPrintFile() {
    let salesOrderIds = [];
    let { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
      salesOrderIds = salesOrderIds.join(",");
    }

    axios.get(
      YING_CUSTOMER_FILE + salesOrderIds + '/',
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response.data && response.data[0]) {
        window.open(response.data[0].url, '_blank')
      }
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }


  renderSetSOOpen = () => {
    const salesOrderIds = [];
    const { salesOrders: { selectedRows } } = this.state;
    const success = () => {
      alert('success');
      this.refreshSOList();
    };
    const failed = () => {
      alert('failed');
    };
    const handleSetOpenClick = () => {
      const SalesOrderids = selectedRows.map(so => so.SalesOrder_id);
      this.props.setOrdersToOpen(SalesOrderids.join(','), success, failed);
    };
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={false}
        type="button"
        onClick={() => {
          handleSetOpenClick();
        }}
      >
        <em className="fa fa-print" />
        <Translate value="set_open" />
      </Button>
    );
  }

  renderSubmitBolImageButton() {
    const { selectedRows } = this.state.salesOrders;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.openSubmitImage();
        }}
      >
        <em className="fa fa-upload" />
        <Translate value="upload_image" />
      </Button>
    );
  }

  renderUploadPODButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <div>
        <input
          type='file'
          ref='uploadPODRef'
          onChange={(e) => {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('PODFile', file);
            const succes = () => {
              alert('success');
              this.fetchSalesOrdersByDetails(this.state.days);
            };
            if(isTN) {
              podUPloadSCM(selectedRows[0].SalesOrder_id, formData, succes)
            } else {
              podUpload(selectedRows[0].SalesOrder_id, formData, succes);
            }
          }}
          style={{ display: 'none' }}
        />
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={selectedRows.length !== 1}
          onClick={() => {
            this.refs.uploadPODRef.click();
          }}
        >
          <em className="fa fa-upload" />
          <Translate value="POD_upload" />
        </Button>
      </div>
    );
  }

  renderUploadMSOButton = () => {
    if (!isAmzey) return null;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        // disabled={selectedRows.length !== 1}
        onClick={() => {
          this.refs.uploadMSORef.click();
        }}
      >
        <input
          type='file'
          ref='uploadMSORef'
          onChange={(e) => {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('FILE', file);
            const succes = () => {
              alert('success');
              this.refreshSOList();
              // this.fetchSalesOrdersByDetails(this.state.days);
            };
            uploadMSO(formData, succes);
            this.refs.uploadMSORef.value = "";
          }}
          style={{ display: 'none' }}
        />
        <em className="fa fa-upload" />
        <Translate value="mso_upload" />
      </Button>
    );
  }

  renderSetOpen = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          const status = selectedRows[0].SaleStatus;
          if (status !== 'Released') {
            this.props.setOrderToOpen(selectedRows[0].SalesOrder_id, this.refreshSOList);
          } else {
            alert('can not set order to open after Released')
          }
        }}
      >
        <Translate value="set_open" />
      </Button>
    )
  }

  setLocationChangeModalVisibility = (isLocationChangeModalVisible = false) => this.setState({ isLocationChangeModalVisible });
  setInboundDateChangeModalVisibility = (isInboundDateChangeModalVisibile = false) => this.setState({ isInboundDateChangeModalVisibile });

  handleLocationChangeSuccess = () => {
    this.refreshSOList();
    this.setLocationChangeModalVisibility();
    this.setInboundDateChangeModalVisibility();
  }
  renderLocatioinChangeButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.setLocationChangeModalVisibility(true);
        }}
      >
        <em className="fa fa-pencil" />
        <Translate value="location_edit" />
      </Button>
    );
  }
  renderInboundDateEditButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
      bsStyle="primary"
      className="print-btn"
      type="button"
      disabled={selectedRows.length !== 1}
      onClick={() => {
        this.setInboundDateChangeModalVisibility(true);
      }}
    >
      <em className="fa fa-pencil" />
      <Translate value="other_info_edit" />
    </Button>
    )
  }

  swShippingLabel() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.props.printShippigLabel(salesOrder_id);
        }}
      >
        <em className="fa fa-print" />
      <Translate value="shipping_label" />
      </Button>
    );
  }

  swResync() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.resyncOrder(salesOrder_id);
        }}
      >
        {/* <em className="fa fa-print" /> */}
      <Translate value="resync" />
      </Button>
    );
  }

  renderPrintLabelButton() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        // href={exportUrl}
        disabled={!checkPermission("print_sales_order")}
        onClick={() => {
          this.props.printSalesOrderLabel(salesOrder_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_label" />
      </Button>
    );
  }

  estDeliveryTimeEditButton = () => {
  const salesOrder_id = this.state.salesOrders.selectedRows.length === 1 &&
  this.state.salesOrders.selectedRows[0].SalesOrder_id;
  return (
    <Button
      bsStyle="success"
      className="print-btn"
      type="button"
      disabled={this.state.salesOrders.selectedRows.length !== 1}
      onClick={() => {
        const ShippingMethod = this.state.salesOrders.selectedRows[0].ShippingMethod;
        if (ShippingMethod === 'Delivery') {
          this.setDeliveryTimeSelectModalVisibility(true)
        } else {
          this.setPickupTimeSelectModalVisibility(true)
        }
      }}
    >
      <em className="fa fa-pen" />
      <Translate value="delivery_date" />
    </Button>
  );
  }
  renderPrintLabelButtonDSQ() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={!checkPermission("print_sales_order") || this.state.salesOrders.selectedRows.length !== 1}
        onClick={() => {
          this.openDSQPrint();
          // this.props.printSalesOrderLabel(salesOrder_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value={isABCFF ? "shipping_label" : "print_label"} />
      </Button>
    );
  }

  renderPrintBolKDW = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    if (!this.props.requestingSalesOrderPDF) {
      return (
        <Button
          bsStyle="success"
          type="button"
          className="print-btn"
          disabled={selectedRows.length < 1}
          onClick={() => {
            const salesOrder_id = [];
            selectedRows.forEach(({ SalesOrder_id }) => {
              salesOrder_id.push(SalesOrder_id)
            });
            let ids = salesOrder_id.join(',');
            this.props.printSalesOrderLabelUSPride( ids );
          }}
        >
          <em className="fa fa-print" />
          <Translate value="bol" />
        </Button>
      );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          disabled={true}
          icon="fa-print"
          translation={<Translate value="bol" />}
          loading={true}
          onClick={() => {
            console.log('loading');
          }}
        />
      )
    }
  }

  renderPrintLabelUSPride = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    let hasTracking = false;
    selectedRows.map(r=> {
      if (r.TrackingNum) {
        hasTracking = true;
      }
    });

    if (!this.props.requestingSalesOrderPDF) {
      return (
        <Button
          bsStyle="success"
          type="button"
          className="print-btn"
          disabled={selectedRows.length < 1}
          onClick={() => {
            const salesOrder_id = [];
            selectedRows.forEach(({ SalesOrder_id }) => {
              salesOrder_id.push(SalesOrder_id)
            });
            if (hasTracking) {
              this.openPridePrint();
            } else {
              this.props.printSalesOrderLabelUSPride({ salesOrder_id });
            }
          }}
        >
          <em className="fa fa-print" />
          <Translate value="new_shipping" />
        </Button>
      );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          disabled={true}
          icon="fa-print"
          translation={<Translate value="new_shipping" />}
          loading={true}
          onClick={() => {
            console.log('loading');
          }}
        />
      )
    }
  }

  renderReprintLabelUSPride = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;
    let missingTracking = false;
    selectedRows.map(r=> {
      if (!r.TrackingNum) {
        missingTracking = true;
      }
    });

    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        disabled={selectedRows.length < 1 || missingTracking}
        onClick={() => {
          const salesOrder_id = [];
          selectedRows.forEach(({ SalesOrder_id }) => {
            salesOrder_id.push(SalesOrder_id);
          });
          this.props.reprintSalesOrderLabelUSPride({ salesOrder_id });
        }}
      >
        <em className="fa fa-print" />
        <Translate value="reprint_shipping" />
      </Button>
    );
  }

  renderPrintLabelButtonAFG() {
    const SalesOrder_id = [];
    const SalesOrder_trackingNum = [];
    let hasInvoice = true;
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.map((r) => {
        if ((r.InvoiceNum === "" || !r.InvoiceNum) && isAFG === true) {
          hasInvoice = false;
        }
        SalesOrder_id.push(r.SalesOrder_id);
        if (r.TrackingNum) {
          SalesOrder_trackingNum.push(r.TrackingNum);
        }
      });
    }
    this.state.trackingNumberSelected = SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        // href={exportUrl}
        disabled={
          hasInvoice === false ||
          SalesOrder_id.length === 0 ||
          !checkPermission("print_sales_order")
        }
        onClick={() => {
          if (
            SalesOrder_trackingNum[0] &&
            SalesOrder_trackingNum[0].length > 0 &&
            (isAFG || isNBT || isKM)
          ) {
            this.openPrintTrackingConfirm();
          } else {
            this.props.printSalesOrderLabelBatch(SalesOrder_id);
          }
        }}
      >
        <em className="fa fa-print" />
        <Translate value={isAPO ? "shipstation" : "print_label"} />
      </Button>
    );
  }

  renderSendEmailButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.props.emailSO(salesOrder_id);
        }}
      >
        <em className="fa fa-email" />
        <Translate value="email_so" />
      </Button>
    );
  }

  genSubjectTemplate = () => {
    if(isCalco) {
      const row = this.state.salesOrders.selectedRows[0];
      if(row) {
        const soNum = row.SONum;
        return `Sales Order ${soNum}`
      }
    }
    return ''
  }

  genContentTemplate = () => {
    return `Dear Customer:

Your sales order is attached. Please review the list of items on order.
Thank you for your business - we appreciate it very much

Sincerely.`
  }

  handleEmailContentConfirm = (subject, content, email, phone, sendEmail, source) => {
    const row = this.state.salesOrders.selectedRows[0];
    this.props.emailSOCalco(row.SalesOrder_id);
    // if(row) {
    //   this.props.emailSOCalco(row.SalesOrder_id, subject, content, email, phone, sendEmail, source);
    //   this.handleEmailContentClose();
    // }
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

  renderSendSO = () => {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.handleEmailContentConfirm();
          return;
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true,
            source: "SO",
          })
        }}
      >
        <Translate value={"send_so"} />
      </Button>
    );
  }

  renderAssignDriverButton = () => {
    const {
      salesOrders: { selectedRows },
    } = this.state;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value=" Assign_to_driver" />
          </span>
        }
        className='assign_to_driver_dropdown'
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setState({
              assigningInboundDriver: true,
              assigningOutboundDriver: false,
            }, () => this.setDriverListModalVisibility(true));
          }}
        >
          <em className="fa fa-car" />
          <Translate value="Assign_inbound_driver" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setState({
              assigningInboundDriver: false,
              assigningOutboundDriver: true,
            }, () => this.setDriverListModalVisibility(true))
          }}
        >
          <em className="fa fa-car" />
          <Translate value="Assign_outbound_driver" />
        </Button>
      </DropdownButton>
    );
  };

  renderUpdateNumberButton() {
    const {
      salesOrders: { selectedRows },
    } = this.state;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value="update_no" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setISAEditModalVisibility(true);
          }}
        >
          <em className="fa fa-pencil" />
          <Translate value="update_customer_bol" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setCTNEditModalVisibility(true);
          }}
        >
          <em className="fa fa-pencil" />
          <Translate value="update_ctn_no" />
        </Button>
      </DropdownButton>
    );
  }

  renderExportButton(qb = undefined) {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const route = this.props.route.path;
    const orderType =
      route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    let salesOrderIds = "";
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds += `${row.SalesOrder_id},`;
      });
    }
    salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);

    const lalaIDS = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        lalaIDS.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}&Bearer=${localStorage.getItem(
      "token"
    )}`;

    const exportUrl1 = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/${salesOrderIds}?Bearer=${localStorage.getItem("token")}`;

    const exportUrl2 = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }`;
    if (isAmzey) {
      return (<DropdownButton
        bsStyle="success"
        disabled={!checkPermission("print_sales_order")}
        title={
          <span>
            {/* <i className="fa fa-print" /> */}
            <Translate value="excel" />
          </span>
        }
        style={{ marginLeft: '5px' }}
      >
        <Button
          bsStyle="success"
          type="button"
          href={salesOrderIds === "" ? exportUrl : exportUrl1}
        >
          <em className="fa fa-download" />
          <Translate value={"excel"} />
        </Button>
        {/* <Button
          bsStyle="success"
          type="button"
          href={salesOrderIds === "" ? exportUrl : exportUrl1}
        >
          <em className="fa fa-download" />
          <Translate value={"excel_details"} />
        </Button> */}
        </DropdownButton>)
    }
    if (!isATL) {
      return (
        <Button
          bsStyle="success"
          type="button"
          href={salesOrderIds === "" ? exportUrl : exportUrl1}
          disabled={!checkPermission("print_sales_order")}
        >
          <em className="fa fa-download" />
          <Translate value={qb ? "excel_qb" : "excel"} />
        </Button>
      );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          type="button"
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openDownloadModal(lalaIDS, exportUrl2);
          }}
          loading={this.state.openDownloadModalLoading}
          // href={salesOrderIds === "" ? exportUrl : exportUrl1}
          disabled={salesOrders.selectedRows.length < 1 || this.state.openDownloadModalLoading}
          icon="fa-download"
          translation={<Translate value={qb ? "excel_qb" : "excel"} />}
        >
          {/* <em className="fa fa-download" /> */}
          {/* <Translate value={qb ? "excel_qb" : "excel"} /> */}
        </SpinnerButton>
      );
    }
  }
  renderExportDetailButton(qb = undefined) {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const route = this.props.route.path;
    const orderType =
      route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    let salesOrderIds = "";
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds += `${row.SalesOrder_id},`;
      });
    }
    salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);

    const lalaIDS = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        lalaIDS.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}&Bearer=${localStorage.getItem(
      "token"
    )}`;

    const exportUrl1 = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/${salesOrderIds}?Bearer=${localStorage.getItem("token")}`;

    const exportUrl2 = `${ROOT_URL}v1/sale/${orderType}/search/orderdetailexport_new`;

    if (!isATL) {
      return (
        <Button
          bsStyle="success"
          type="button"
          href={salesOrderIds === "" ? exportUrl : exportUrl1}
          disabled={!checkPermission("print_sales_order")}
        >
          <em className="fa fa-download" />
          <Translate value={qb ? "excel_qb" : "excel"} />
        </Button>
      );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          type="button"
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openDownloadModal2(lalaIDS, exportUrl2);
          }}
          loading={this.state.openDownloadModalLoading}
          // href={salesOrderIds === "" ? exportUrl : exportUrl1}
          disabled={this.state.openDownloadModalLoading}
          icon="fa-download"
          translation={<Translate value="order_detail" />}
        >
          {/* <em className="fa fa-download" /> */}
          {/* <Translate value={qb ? "excel_qb" : "excel"} /> */}
        </SpinnerButton>
      );
    }
  }

  openDownloadModal = (ids, url) => {
    let data = {pk: ids};
    this.setState({openDownloadModalLoading: true});
    axios.post(
      url,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response.data) {
      this.setState({openDownloadModalUrl: response.data.url, openDownloadModalVisibility: true, openDownloadModalLoading: false});
      }
    }, (err) => {
      // this.setState({openDownloadModalUrl: 'https://www.google.com/search?q=google&oq=google&aqs=chrome..69i57j46i131i199i433i465i512j0i433i512l2j69i60l4.687j0j7&sourceid=chrome&ie=UTF-8', openDownloadModalVisibility: true});
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
      this.setState({openDownloadModalLoading: false});
    });
    // this.setState({openDownloadModalVisibility: true});
  }
  openDownloadModal2 = (ids, url) => {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);

    let data = {
      // pk: ids,
      date_1: fromDate,
      date_2: toDate
    };


    this.setState({openDownloadModalLoading: true});
    axios.post(
      url,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response.data) {
      this.setState({openDownloadModalUrl: response.data.url, openDownloadModalVisibility: true, openDownloadModalLoading: false});
      }
    }, (err) => {
      // this.setState({openDownloadModalUrl: 'https://www.google.com/search?q=google&oq=google&aqs=chrome..69i57j46i131i199i433i465i512j0i433i512l2j69i60l4.687j0j7&sourceid=chrome&ie=UTF-8', openDownloadModalVisibility: true});
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
      this.setState({openDownloadModalLoading: false});
    });
    // this.setState({openDownloadModalVisibility: true});
  }

  closeDownloadModal = () => {
    this.setState({openDownloadModalVisibility: false, openDownloadModalUrl: null});
  }


  openXPOModal = () => {
    this.setState({xpoQuoteVisibility: true});
  }
  closeXPOModal = () => {
    this.setState({xpoQuoteVisibility: false});
  }

  openPickupModal = () => {
    this.setState({pickupVisibility: true});
  }
  closePickupModal = () => {
    this.setState({pickupVisibility: false});
  }

  openPickupSelectionModal = () => {
    this.setState({pickupSelectionVisibility: true, xpoPickupDate: null, xpoReadyDate: null, xpoCloseDate: null});
  }
  closePickupSelectionModal = () => {
    this.setState({pickupSelectionVisibility: false});
  }

  renderExportSelectedButton() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v2/so-line-export/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
      >
        <em className="fa fa-print" />
        <Translate value="export_line_details" />
      </Button>
    );
  }

  renderExportButtonATL() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v1/sale/sales_mobile_order/search/shipmentexport/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`
    const exportUrl2 = `${ROOT_URL}v1/sale/sales_mobile_order/search/shipmentexport`

    if (!isATL) {
    return (
      <Button
        bsStyle="success"
        type="button"
        style={{marginBottom: '5px'}}
        href={exportUrl}
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
      >
        <em className="fa fa-download" />
        <Translate value="shipment_export" />
      </Button>
    );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          type="button"
          style={{marginBottom: '5px'}}
          loading={this.state.openDownloadModalLoading}
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openDownloadModal(salesOrderIds, exportUrl2);
          }}
          // href={exportUrl}
          disabled={(!salesOrderIds || salesOrderIds.length < 1 || this.state.openDownloadModalLoading)}
          icon="fa-download"
          translation={<Translate value="shipment_export" />}
          >
          {/* <em className="fa fa-download" />
          <Translate value="shipment_export" /> */}
        </SpinnerButton>
      );
    }
  }

  renderOrderExportButtonATL() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v1/sale/sales_mobile_order/search/orderdetailexport/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`
    const exportUrl2 = `${ROOT_URL}v1/sale/sales_mobile_order/search/orderdetailexport`

    if (!isATL){
    return (
      <Button
        bsStyle="success"
        type="button"
        style={{marginBottom: '5px'}}
        href={exportUrl}
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
      >
        <em className="fa fa-download" />
        <Translate value="order_export" />
      </Button>
    );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          type="button"
          style={{marginBottom: '5px'}}
          // href={exportUrl}
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openDownloadModal(salesOrderIds, exportUrl2);
          }}
          loading={this.state.openDownloadModalLoading}
          disabled={(!salesOrderIds || salesOrderIds.length < 1 || this.state.openDownloadModalLoading)}
          icon="fa-download"
          translation={<Translate value="order_export" />}
        >
          <em className="fa fa-download" />
          <Translate value="order_export" />
        </SpinnerButton>
      );
    }
  }

  dsqExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  abcffMsoTemplate() {
    const exportUrl = `${ROOT_URL}v2/customer-so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        MSO Template
      </Button>
    );
  }

  dsqExcelTemplateOb() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    const exportUrl = `${ROOT_URL}v2/rebuild/prefilled-ob-template/${salesOrder_id}?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={this.state.salesOrders.selectedRows.length !== 1}
      >
        <em className="fa fa-download" />
        <Translate value="prefilled_ob_template" />
      </Button>
    );
  }

  renderCalculateFees() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    // const exportUrl = `${ROOT_URL}v2/rebuild/prefilled-ob-template/${salesOrder_id}?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        onClick={() => this.calculateFees()}
        disabled={this.state.salesOrders.selectedRows.length !== 1}
      >
        {/* <em className="fa fa-download" /> */}
        <Translate value="calculate_fees" />
      </Button>
    );
  }

  calculateFees() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

      let data = null;
    axios.post(
      `${ROOT_URL}v1/sale/calculate-order-fees/` + salesOrder_id,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Fees Calculated.");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data.message));
    });
  }

  dsqOutboundTemplate() {
    const exportUrl = `${ROOT_URL}v2/ob-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        OB Template
      </Button>
    );
  }

  magExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="excel_template" />
      </Button>
    );
  }

  jtbExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  wizExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  bolList() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openbolListModal();
        }}
        disabled={false}
        >
        <em className="fa fa-list" />
        <Translate value="bol_list" />
      </Button>
    );
  }

  generateBOL() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openGenerateBOLModal();
        }}
        disabled={selectedRows.length < 1}
        >
        <em className="fa fa-plus" />
        <Translate value="bol" />
      </Button>
    );
  }

  fjExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  renderCreateTaskButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.props.createMobileTask(salesOrder_id);
        }}
      >
        <Translate value="on_fleet" />
      </Button>
    );
  }

  renderChangeWeightButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.openChangeWeight();
        }}
      >
        <Translate value="change_weight_button" />
      </Button>
    );
  }

  renderAddTracking() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let val = null;
    let dep = null;
    if (selectedRows && selectedRows.length === 1) {
    val = selectedRows[0].TrackingNum;
    dep = selectedRows[0];
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          // this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows &&
          selectedRows.length !== 1
        }
        onClick={() => {
          // this.openAddTracking();
          this.openChangeTracking(val, dep);
        }}
      >
        <em className="fa fa-plus" />
        <Translate value="tracking" />
      </Button>
    );
  }

  renderChowbusImportButton() {
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openChowbusModal();
        }}
      >
        <Translate value="chowbus" />
      </Button>
    );
  }

  renderPaymentMethodChangeButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          // this.openChangeWeight();
          this.openChangePaymentMethodModal();
        }}
      >
        <Translate value="change_payment_method" />
      </Button>
    );
  }

  renderEmailPackingButton() {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={selectedRows.length<1}
        onClick={() => {
          const salesOrder_id = [];
          selectedRows.forEach(({ SalesOrder_id }) => {
            salesOrder_id.push(SalesOrder_id)
          });
          let ids = salesOrder_id.join(',');
          this.props.sendPacking( ids );
        }}
      >
        <Translate value="email_packing" />
      </Button>
    );
  }

  renderReshipButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let hasInvoice = true;
    if (
      selectedRows[0] &&
      (!selectedRows[0].InvoiceNum || selectedRows[0].InvoiceNum === "")
    ) {
      hasInvoice = false;
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          hasInvoice === false ||
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.openConfirmReship();
        }}
      >
        <Translate value="reship" />
      </Button>
    );
  }

  renderQuoteButton() {
    const { selectedRows } = this.state.salesOrders;
    let onlyQuote = true;
    selectedRows.map((r) => {
      if (r.SaleStatus !== "Quote") {
        onlyQuote = false;
      }
    });

    if (isABCFF) {
      return (
        <Button
          bsStyle="success"
          type="button"
          disabled={ !onlyQuote }
          onClick={() => { this.quoteConversion(); }}
        >
          <Translate value="set_order" />
        </Button>
      );
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          !onlyQuote ||
          this.context.router.routes[1].path !== "salesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => { this.openConfirmQuote(); }}
      >
        <Translate value="set_order" />
      </Button>
    );
  }

  postPickupButton()  {
    const { selectedRows } = this.state.salesOrders;
    // let onlyQuote = true;
    // selectedRows.map((r) => {
    //   if (r.SaleStatus !== "Quote") {
    //     onlyQuote = false;
    //   }
    // });
    return (
      <SpinnerButton
        bsStyle="success"
        type="button"
        className="print-btn"
        loading={this.state.xpoLoading}
        disabled={
          // this.context.router.routes[1].path !== "salesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          // this.confirmPostPickup();
          this.openPickupSelectionModal();
        }}
        translation={<Translate value="create_pickup" />}

      >
      </SpinnerButton>
    );
  }

  postQuoteButton()  {
    const { selectedRows } = this.state.salesOrders;
    // let onlyQuote = true;
    // selectedRows.map((r) => {
    //   if (r.SaleStatus !== "Quote") {
    //     onlyQuote = false;
    //   }
    // });
    return (
      <SpinnerButton
        bsStyle="success"
        type="button"
        className="print-btn"
        loading={this.state.xpoLoading}
        disabled={
          // this.context.router.routes[1].path !== "salesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => { this.confirmPostQuote(); }}
        translation={<Translate value="create_quote" />}
      >
      </SpinnerButton>
    );
  }

  getQuoteButton()  {
    const { selectedRows } = this.state.salesOrders;
    // let onlyQuote = true;
    // selectedRows.map((r) => {
    //   if (r.SaleStatus !== "Quote") {
    //     onlyQuote = false;
    //   }
    // });
    return (
      <SpinnerButton
        bsStyle="success"
        type="button"
        className="print-btn"
        loading={this.state.xpoLoading}
        disabled={
          // this.context.router.routes[1].path !== "salesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.confirmGetQuote();
        }}
        translation={<Translate value="get_quote" />}
      >
      </SpinnerButton>
    );
  }

  getPickupButton()  {
    const { selectedRows } = this.state.salesOrders;
    // let onlyQuote = true;
    // selectedRows.map((r) => {
    //   if (r.SaleStatus !== "Quote") {
    //     onlyQuote = false;
    //   }
    // });
    return (
      <SpinnerButton
        bsStyle="success"
        type="button"
        className="print-btn"
        loading={this.state.xpoLoading}
        disabled={
          // this.context.router.routes[1].path !== "salesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.confirmGetPickup();
        }}
        translation={<Translate value="get_pickup" />}

      >
      </SpinnerButton>
    );
  }

  createBOLButton()  {
    const { selectedRows } = this.state.salesOrders;
    // let onlyQuote = true;
    // selectedRows.map((r) => {
    //   if (r.SaleStatus !== "Quote") {
    //     onlyQuote = false;
    //   }
    // });
    return (
      <SpinnerButton
        bsStyle="success"
        type="button"
        className="print-btn"
        loading={this.state.xpoLoading}
        disabled={
          // this.context.router.routes[1].path !== "salesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.confirmCreateBOL();
        }}
        translation={<Translate value="create_bol" />}

      >
      </SpinnerButton>
    );
  }

  renderEmailUpdateButton() {
    const { salesOrders } = this.state;
    const salesOrderIds = [];

    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          salesOrderIds.length < 1
        }
        onClick={() => {
          this.sendEmailUpdate(salesOrderIds);
        }}
      >
        <Translate value="email_update" />
      </Button>
    );
  }

  renderEmailPodButton() {
    const { salesOrders } = this.state;
    const salesOrderIds = [];

    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          salesOrderIds.length < 1
        }
        onClick={() => {
          this.sendEmailPod(salesOrderIds);
        }}
      >
        <Translate value="email_pod" />
      </Button>
    );
  }

  renderCompleteOutboundButton() {
    const { salesOrders } = this.state;
    const salesOrderIds = [];

    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          salesOrderIds.length < 1
        }
        onClick={() => {
          this.completeOB(salesOrderIds);
        }}
      >
        Complete OB
      </Button>
    );
  }

  renderDavisPO() {
    const { selectedRows } = this.state.salesOrders;
    let onlyOpen = true;
    // selectedRows.map(r=> {
    //   if (r.SaleStatus !== 'Open') {
    //     onlyOpen = false;
    //   }
    // });
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!onlyOpen || selectedRows.length !== 1}
        onClick={() => {
          this.openDavisPO();
        }}
      >
        <Translate value="davis_po" />
      </Button>
    );
  }

  renderDriverImageButton() {
    const { selectedRows } = this.state.salesOrders;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.openShowDriverImage();
        }}
      >
        <em className="fa fa-print" />
        <Translate value="show_image" />
      </Button>
    );
  }

  outboundStatusButton() {
    // const salesOrder_id =
    //   this.state.salesOrders.selectedRows.length === 1 &&
    //   this.state.salesOrders.selectedRows[0].SalesOrder_id;
    const { salesOrders } = this.state;
    const salesOrderIds = [];

    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    return (
      <DropdownButton
        bsStyle="primary"
        disabled={salesOrderIds.length < 1}
        title={
          <span>
            {/* <i className="fa fa-print" /> */}
            <Translate value="ob_status" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={salesOrderIds.length < 1}
          type="button"
          onClick={() => {
            this.changeOutboundStatus(salesOrderIds, 'preparing');
          }}
        >
          <em className="fa fa-edit" />
          <Translate value="preparing" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={salesOrderIds.length < 1}
          type="button"
          onClick={() => {
            this.changeOutboundStatus(salesOrderIds, 'ready_to_ship');
          }}
        >
          <em className="fa fa-edit" />
          <Translate value="ready_to_ship" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={salesOrderIds.length < 1}
          type="button"
          onClick={() => {
            this.changeOutboundStatus(salesOrderIds, 'en_route');
          }}
        >
          <em className="fa fa-edit" />
          <Translate value="en_route" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={salesOrderIds.length < 1}
          type="button"
          onClick={() => {
            this.changeOutboundStatus(salesOrderIds, 'delivered');
          }}
        >
          <em className="fa fa-edit" />
          <Translate value="delivered" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={salesOrderIds.length < 1}
          type="button"
          onClick={() => {
            this.changeOutboundStatus(salesOrderIds, 'trouble');
          }}
        >
          <em className="fa fa-edit" />
          <Translate value="trouble" />
        </Button>
      </DropdownButton>
    );
  }



  renderTNOriginal() {
    return (
    <DropdownButton
      bsStyle="success"
      type="submit"
      title={
        <span>
          <em className="fa fa-plus" />
          <Translate value="excel_create" />
        </span>
      }
    >
      <Button
        bsStyle="success"
        // className="print-btn"
        // type="button"
        onClick={() => {
          this.refs.msoCreateInputRef.click();
        }}
        disabled={!checkPermission("add_sales_order")}
      >
        {/* <em className="fa fa-print" /> */}
        Excel (New)
      </Button>
      <Button
        bsStyle="success"
        // className="print-btn"
        // type="button"
        onClick={() => {
          this.refs.msoCreateInputRefOriginal.click();
        }}
        disabled={!checkPermission("add_sales_order")}
      >
        {/* <em className="fa fa-plus" /> */}
        Excel (Original)
      </Button>
    </DropdownButton>
    );
  }


  renderPrintBolButton() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value=" print_bol" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.props.printBolById(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_by_id" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.openPrintBol();
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_by_address" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.props.printBolWithoutLog(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_without_log" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.props.printBolLabel(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_label" />
        </Button>
      </DropdownButton>
    );
  }

  renderDriverImage() {
    let imageFile = "/img/dummy.png";
    if (this.state.salesOrders.selectedRows[0]) {
      imageFile = this.state.salesOrders.selectedRows[0].OrderImage;
    }
    return (
      <div style={{ position: "relative" }}>
        <img
          style={{ width: "200px", height: "200px" }}
          src={imageFile}
          onClick={() => window.open(imageFile, "_blank")}
        />
      </div>
    );
  }

  onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = this.state.salesOrders.selectedRows;
      newRows[index].BolImageUrl = reader.result;
      this.setState({ rows: newRows, file: files[0] });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  onRowValueChange = (event, rowValues, type) => {
    // merge updated row with current row and rerender by setting state
    this.setState({ sortColumn: null, sortDirection: null });
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    const editedRows = this.state.editedRows.slice(0);
    rows[rowValues.Index][type] = event.target.value;
    editedRows.forEach((element, idx) => {
      if (element.Index === rows[rowValues.Index].Index) {
        editedRows.splice(idx, 1);
      }
    }, this);
    // push the row into the editedRows array
    editedRows.push(rows[rowValues.Index]);
    this.setState({
      rows,
      editedRows,
    });
  };

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => {
              this.setState({ suggestValue: newValue });
            }}
            SearchType={this.state.searchType}
            fetchOrdersByProduct={this.fetchSalesOrdersByProduct}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            this.setState(
              {
                filteredByItem: false,
                suggestValue: "",
                filterProductID: null,
              },
              () => {
                this.fetchSalesOrdersByDetails(this.state.days);
              },
            );
          }}
        />
      </div>
    );
  }

  renderInvoiceNoSearchInput = () => {
    return (
      <input
        value={this.state.invoiceNoSearchTerm}
        onChange={(e) =>
          this.setState({
            invoiceNoSearchTerm: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (this.state.invoiceNoSearchTerm) {
              const pathname = this.context.router.location.pathname;
              this.props.searchInvoicesByInvoiceNo(
                this.state.searchType,
                this.state.invoiceNoSearchTerm,
                pathname
              );
            } else {
              this.fetchSalesOrdersByDetails(this.state.days);
            }
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderTrackingNoSearchInput = () => {
    return (
      <input
        placeholder="Tracking No."
        value={this.state.trackingNoSearchTerm}
        onChange={(e) =>
          this.setState({
            trackingNoSearchTerm: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (this.state.trackingNoSearchTerm) {
              const pathname = this.context.router.location.pathname;
              this.props.searchInvoicesByTrackingNo(
                this.state.trackingNoSearchTerm,
                pathname,
              );
            } else {
              this.fetchSalesOrdersByDetails(this.state.days);
            }
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  handleStatusFilterChange = (status) => {
    this.setState({currentPage: 0});
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
    };
    if (isABC) {
      this.setState({ salesOrders });
    }

    const salesOrdersFilter = this.props.salesOrdersFilter;
    if (!salesOrdersFilter) {
      const route = this.context.router.routes[1].path;
      let seller = this.props.Seller;
      if (this.props.Seller) {
        seller = this.props.Seller.value;
      }
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : "1900-01-01";
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : "3000-01-01";
      let days = this.state.days;
      if (days == null && !(isATL || isUSPride)) {
        days = 7;
      }
      const productNum = this.props.ProductNum;
      this.setState({ Status: status }, () => {
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          (isATL || isUSPride) ? this.state.dispatchDateLT : null,
          (isATL || isUSPride) ? this.state.dispatchDateGT : null,
          (isATL || isUSPride) ? this.state.dispatchDays : null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.props.Warehouse_id,
        );
      });
    } else {
      this.setState({ Status: status });
    }
  };

  refreshSOList = () => {
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : "1900-01-01";
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : "3000-01-01";
    let days = this.state.days;
    let seller = this.props.Seller;
    const route = this.context.router.routes[1].path;
    const productNum = this.props.ProductNum;
    this.props.fetchSalesOrdersByFilter(
      fromDate,
      toDate,
      days,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      null,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.props.Warehouse_id,
    );
  }

  handleBreadCrumbTitle = () => {
    if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
      if (this.context.router.routes[1].path === "salesOrders") {
        this.setState(() => ({ breadcrumbTitle: "inbound_order" }));
      } else if (this.context.router.routes[1].path === "outboundOrders") {
        this.setState(() => ({ breadcrumbTitle: "outbound_order" }));
      } else if (this.context.router.routes[1].path === "mobileSalesOrders") {
        this.setState(() => ({ breadcrumbTitle: "mobile_sales_order" }));
      }
    } else {
      if (this.context.router.routes[1].path === "salesOrders") {
        this.setState(() => ({ breadcrumbTitle: "sales_orders" }));
      } else if (this.context.router.routes[1].path === "mobileSalesOrders") {
        this.setState(() => ({ breadcrumbTitle: "mobile_sales_order" }));
      }
    }
  };

  onDropImage = (files) => {
    const formData = new FormData();
    formData.append('FILE', files[0]);
    const success = () => {
      alert('success');
      this.refreshSOList();
    }
    const failed = () => {
      alert('failed');
    }
    this.props.uploadSOImage(formData, success, failed)
  }

  onDropPOD = (files) => {
    // const formData = new FormData();
    // formData.append('FILE', files[0]);
    // const success = () => {
    //   alert('success');
    //   this.refreshSOList();
    // }
    // const failed = () => {
    //   alert('failed');
    // }
    // this.props.uploadSOPOD(formData, success, failed)
  }

  setTNExcelOptionModalVisibility = (isExcelUploadOptionVisible = false) => this.setState({ isExcelUploadOptionVisible });

  setShippingRateVisibility = (isShipingRateVisible = false) => this.setState({ isShipingRateVisible });

  handleTeapplixPrintClick = (row) => {
    const { salesOrders } = this.state;
    this.props.selectTeapplixShipping(row.Code, salesOrders.selectedRows[0].SalesOrder_id);
    this.setShippingRateVisibility();
  }

  renderTeapplixButton  = () => {
    const { salesOrders } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const salesOrderIdsString = salesOrderIds.join(',');

    const successDelete = () => {
      alert('Success on delete teapplix label');
      this.refreshSOList();
    }
    const success = () => {
      // this.refreshSOList();
    }

    if (isABCFF) {
      return <div>
        <DropdownButton
          bsStyle="success"
          disabled={!salesOrders.selectedRows.length}
          title={
            <span>
              {/* <i className="fa fa-print" /> */}
              <Translate value="teapplix" />
            </span>
          }
          style={{ marginLeft: '5px' }}
        >
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => {
              if (salesOrders.selectedRows[0].Channel === "amazon-US" && salesOrders.selectedRows.length === 1) {
                this.setShippingRateVisibility(true);
              } else {
                this.props.selectTeapplixShipping('', salesOrderIdsString);
              }
            }}
          >
            <i className="fa fa-print" />
            <Translate value="print_label" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length|| this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => { this.props.printTeapplixLabel(salesOrderIdsString); }}
          >
            <i className="fa fa-print" />
            <Translate value="reprint_label" />
          </Button>
          <Button
            bsStyle="danger"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length}
            type="button"
            onClick={() => { this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete); }}
          >
            <em className="fa fa-trash" />
            <Translate value="cancel_label" />
          </Button>
        </DropdownButton>
      </div>
    }

    return (
      <div>
        <DropdownButton
          bsStyle="success"
          disabled={!salesOrders.selectedRows.length}
          title={
            <span>
              <Translate value="teapplix" />
            </span>
          }
          style={{ marginLeft: '5px' }}
        >
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length|| this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => { this.props.printTeapplixLabel(salesOrderIdsString); }}
          >
            <i className="fa fa-print" />
            <Translate value="reprint_label" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length|| this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => { this.props.selectTeapplixShipping(isATL ? "UPS_GROUND" : 'USPS_FIRST_PACKAGE', salesOrderIdsString, success);}}
          >
            <i className="fa fa-print" />
            <Translate value={isATL ? "ups_ground" : "USPS_first"} />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => { this.props.selectTeapplixShipping(isATL ? "FEDEX_GROUND" : 'USPS_PRIORITY_PACKAGE', salesOrderIdsString, success); }}
          >
            <i className="fa fa-print" />
            <Translate value={isATL ? "fedex_ground" : "usps_priority"} />
          </Button>
          <Button
            bsStyle="danger"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length}
            type="button"
            onClick={() => { this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete); }}
          >
            <em className="fa fa-trash" />
            <Translate value="cancel_label" />
          </Button>

        </DropdownButton>
      </div>
    )
    return <span />
  }

  render() {

    // const handleFilterChangePage = (event) => {
    //   // this.setState({currentPage: 0});
    //   this.state.currentPage = 0;
    //   let salesOrders = {
    //     ...this.state.salesOrders,
    //     selectedRows: [],
    //   };
    //   this.setState({ salesOrders });
    //   const route = this.context.router.routes[1].path;

    //   let keys = Object.keys(this.state.searchFilter);
    //   for (let i = 0; i < keys.length; i++) {
    //     if (event.target.name === keys[i]) {
    //       this.state.searchFilter[keys[i]] = event.target.value;
    //     }
    //   }

    //   this.props.fetchSalesOrdersByFilter(
    //     this.state.FromDate,
    //     this.state.ToDate,
    //     this.state.days,
    //     this.state.Status,
    //     null,
    //     null,
    //     route,
    //     this.state.dispatchDateLT,
    //     this.state.dispatchDateGT,
    //     null,
    //     this.state.limit,
    //     this.state.currentPage,
    //     this.state.searchFilter,
    //   );
    //   // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    // }

    const handleFilterChangePage = debounce(
      (event) => {
        // this.setState({currentPage: 0});
        this.state.currentPage = 0;
        let salesOrders = {
          ...this.state.salesOrders,
          selectedRows: [],
        };
        this.setState({ salesOrders });
        const route = this.context.router.routes[1].path;

        let keys = Object.keys(this.state.searchFilter);
        for (let i = 0; i < keys.length; i++) {
          if (event.name === keys[i]) {
            this.state.searchFilter[keys[i]] = event.value;
          }
        }

      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.props.Warehouse_id,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    },
    200,
    { maxWait: 300 },
  );

    const singleSalesOrderId =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    const singleSalesOrderNum =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SONum;

    let multiSalesOrderId = [];
    let multiSalesOrderNum = [];
    let salesOrderIdString = "";
    let salesOrderNumString = "";
      if (this.state.salesOrders && this.state.salesOrders.selectedRows.length >= 1) {
        this.state.salesOrders.selectedRows.map((row) => {
          multiSalesOrderId.push(row.SalesOrder_id);
          multiSalesOrderNum.push(row.SONum);
        });
        salesOrderIdString = multiSalesOrderId.join(",");
        salesOrderNumString = multiSalesOrderNum.join(",");
      }

    // let dsqTempOrder = [];
    // if (this.state.salesOrders && this.state.salesOrders.selectedRows) {
    //   dsqTempOrder = this.state.salesOrders.selectedRows[0];
    // }

    const DriverListModalStyle = {
      width: "550px",
      height: "200px",
      marginLeft: "-15%",
    };
    const createDialogStyle = {
      width: "550px",
      height: "300px",
      marginLeft: "-15%",
    };
    const dlMODAL = {
      width: "550px",
      height: "300px",
      marginLeft: "-15%",
    }
    const xpoMODAL = {
      width: "1000px",
      height: "500px",
      marginLeft: "-25%",
      marginTop: "-310px",
    }
    const pickupMODAL = {
      width: "700px",
      height: "620px",
      marginLeft: "-15%",
      marginTop: "-310px",
    }
    const pickupSelectionMODAL = {
      width: "350px",
      height: "320px",
      marginLeft: "-5%",
      marginTop: "-200px",
    }
    const bolImageDialogue = {
      width: "700px",
      height: "600px",
      marginLeft: "-15%",
    };
    const createWeightDialogStyle = {
      width: "600px",
      height: "360px",
      marginLeft: "-10%",
    };
    const altonChildDialogStyle = {
      width: "600px",
      height: "450px",
      marginLeft: "-10%",
    };
    const bolListDialogStyle = {
      width: "1050px",
      height: "635px",
      marginLeft: "-27%",
      marginTop: "-310px",
    };
    const generateBOLStyle = {
      width: '500px',
      height: '515px',
      marginLeft: '-10%'
    };
    const dsqPrintDialogStyle = {
      width: "1050px",
      height: "550px",
      marginLeft: "-27%",
      marginTop: "-310px",
    };
    const wizPODDialogStyle = {
      width: "690px",
      height: "550px",
      marginLeft: "-10%",
      marginTop: "-310px",
    };
    const createTrackingDialogStyle = {
      width: "700px",
      height: "290px",
      marginLeft: "-10%",
    };
    const changeTrackingDialogStyle = {
      width: "500px",
      height: "200px",
      marginLeft: "-10%",
    };
    const changeShipDateDialogue = {
      width: "450px",
      height: "200px",
      marginLeft: "-10%",
    };
    const changeBOLDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const createPullSheetDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const voidNoteDialogStyle = {
      width: "550px",
      height: "330px",
      marginLeft: "-10%",
    };
    const chowbusDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const voidReasonSelection = [
      {
        value: "Items Out of Stock",
        label: "Items Out of Stock",
      },
      {
        value: "Customer Request",
        label: "Customer Request",
      },
      {
        value: "Items Damaged",
        label: "Items Damaged",
      },
      {
        value: "Duplicated Order",
        label: "Duplicated Order",
      },
      {
        value: "Invalid Shipping Address",
        label: "Invalid Shipping Address",
      },
      {
        value: "Other",
        label: "Other",
      },
    ];
    let USPridePlatformOptions = [
      {label: '123 Store', value: '123store',},
      {label: 'Amazon', value: 'amazon',},
      {label: 'TikTok', value: 'tiktok',},
      {label: 'Gigacloud', value: 'gigacloud',},
      {label: 'shein', value: 'shein',},
      {label: 'Home Depot', value: 'homedepot',},
      // {label: 'Houzz', value: 'houzz',},
      {label: 'Overstock', value: 'overstock',},
      {label: 'Walmart', value: 'walmart',},
      {label: 'Wayfair', value: 'wayfair',},
      {label: 'Cymax', value: 'cymax',},
      {label: 'BBB', value: 'bbb',},
    ];
    if (isABCFF) {
      USPridePlatformOptions = [
        // {label: 'Other', value: 'other',},
        {label: 'SILB2C', value: 'SILB2C',},
        {label: 'Amazon', value: 'amazon',},
        {label: 'Home Depot', value: 'homedepot',},
        {label: 'Costco', value: 'costco',},
        {label: 'Overstock', value: 'overstock',},
        {label: 'Walmart', value: 'walmart',},
        {label: 'Wayfair', value: 'wayfair',},
        {label: 'Cymax', value: 'cymax',},
        {label: 'BBB', value: 'bbb',},
      ];
    }
    if (isATL) {
      USPridePlatformOptions = [
        // {label: 'Amazon Seller', value: 'amazon_seller',},
        {label: 'Amazon Seller Mulhouse', value: 'amazon_seller_mulhouse',},
        {label: 'Amazon Seller Rosevera', value: 'amazon_seller_rosevera',},
        {label: 'Amazon Rosevera', value: 'amazon_rosevera',},
        {label: 'Home Depot', value: 'homedepot',},
        // {label: 'Houzz', value: 'houzz',},
        {label: 'Houzz Mulhouse', value: 'houzz_mulhouse',},
        {label: 'Houzz Rosevera', value: 'houzz_resevera',},
        {label: 'Overstock', value: 'overstock',},
        {label: 'Walmart', value: 'walmart',},
        {label: 'Wayfair', value: 'wayfair',},
        {label: 'Cymax', value: 'cymax',},
        {label: 'Hayneedle', value: 'hayneedle',},
      ];

    }
    const { USPridePlatform } = this.state;
    const { USPrideCustomer } = this.state;
    const changeWeight = <Translate value="change_ship_weight" />;
    const changePaymentMethod = <Translate value="payment_method_change" />;
    const altonChildTitle = <Translate value="child_sku" />;
    const displayTrackingTitle = <Translate value="split_tracking_numbers" />;
    const displayTrackingTitle2 = <Translate value="tracking_nums" />;
    const changePullSheet = <Translate value="pull_sheet_format" />;
    const reshipTitle = <Translate value="reship" />;
    const quoteTitle = <Translate value="set_order" />;
    const davisPOTitle = <Translate value="so_to_po" />;
    const pridePrintTitle = <Translate value="pride_print" />;
    const dlTITLE = <Translate value="file_ready" />;
    const showImageTitle = <Translate value="show_image" />;
    const submitImageTitle = <Translate value="submit_image" />;
    const printBolTitle = <Translate value="print_bol" />;
    const voidNoteTitle = <Translate value="void_note" />;
    const chowbusImportTitle = <Translate value="chowbus_import" />;
    let salesOrder_id =
      this.state.salesOrders &&
      this.state.salesOrders.selectedRows[0] &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    salesOrder_id = salesOrder_id || "";
    const height = ((this.state.tableHeight / 3) * 2 + 70).toString();
    const tableCollapseFix = { height };
    const detailsTableHeight = (this.state.tableHeight / 2.5 + 45).toString();
    const detailsTableCollapseFix = { height: detailsTableHeight };
    const listPurchasers = [{ value: "", label: "" }];
    const inputFieldKey = Math.random();

    const handleDrayageChange = (el) => {
      let drayageSelected = el.value;
      let drayageListDisplay = el.label;

      this.setState({ drayageSelected, drayageListDisplay });
  }


    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={this.state.breadcrumbTitle} />
          </Breadcrumb.Item>
        </Breadcrumb>{" "}
        {/* End Nav Trail */}
        <Grid id="sales-orders-list" style={isABC ? { width: '100%' } : {}}>
          {/* Date Range Picker */}
          { (!isABC || this.state.abcDatePickerShow === true) && <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_status" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {/* <Field name='Status' component={ renderStatusRadios }  /> */}
                      {genericRadioFilter({
                        content: [
                          {
                            option: "all",
                            id: "all-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "all",
                          },
                          {
                            option: "open",
                            id: "open-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "open",
                          },
                          {
                            option: "packing",
                            id: "packing-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "packing",
                          },
                          ...isTN ? [{
                            option: "ready",
                            id: "ready-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "ready",
                          }] : [],
                          {
                            option: "Released",
                            id: "released-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "released",
                          },
                          {
                            option: "Canceled",
                            id: "canceled-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "canceled",
                          },
                          ...!isTN ? [{
                            option: "Quote",
                            id: "quote-radio-filter",
                            name: "statusFilterRadios",
                            labelName: "quote",
                          }] : [],
                        ],
                        value: this.state.Status,
                        handleOnClick: this.handleStatusFilterChange,
                        type: "buttons",
                      })}
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    {dateFilterRadios({
                      handleOnClick: this.fetchSalesOrdersByDetails,
                      setFromDate: this.setFromDate,
                      setToDate: this.setToDate,
                      setToRangeSearch: this.setToRangeSearch,
                      FromDate: this.state.FromDate,
                      ToDate: this.state.ToDate,
                      Days: this.state.days,
                    })}
                  </Col>
                  {/* </Row> */}
                </Row>
                { (isCalco || isATL || isUSPride) && (
                  <Row>
                    <Col xs={2}>
                      <h3 className="filter-title">
                        <Translate value={(isATL || isUSPride) ? "import_date" : "order_delivered"} />
                        <span className="colon">:</span>
                      </h3>
                    </Col>
                    <Col xs={10}>
                      {dispatchFilterRadios({
                        handleOnClick: this.fetchSalesOrdersByDispatch,
                        setFromDate: this.setFromDispatchDate,
                        setToDate: this.setToDispatchDate,
                        setToRangeSearch: this.setToDispatchRangeSearch,
                        FromDate: this.state.dispatchDateLT,
                        ToDate: this.state.dispatchDateGT,
                        Days: this.state.dispatchDays,
                      })}
                    </Col>
                  </Row>
                )}
              </Panel>
            </Col>
          </Row>}
          {" "}
          {/* End Date Range Picker */}
          {/* Sales Order Full Table  */}
          <Row>
            <Col xs={12}>
              <Panel
                className="position-relative table-collapse-fix"
                id={
                  (isTN || isUSPride || isATL || isRS || isDSQ || isWUFS || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB)
                  ? "table-collapse-fix-450"
                  : (isABC) && "table-collapse-fix-940"
                }
                style={{marginBottom: isABC ? '80px': '0px'}}
              >
                <div style={{ position: "relative" }}>
                  <ButtonToolbar className="table-buttons">
                    {!isABCFF &&
                    <Button
                      bsStyle="success"
                      type="submit"
                      onClick={(event) => {
                        this.clickNew(event);
                      }}
                      disabled={
                        this.context.router.routes[1].path ===
                          "mobileSalesOrders" ||
                        !checkPermission("add_sales_order")
                      }
                    >
                      <em className="fa fa-plus" />
                      <Translate value="create" />
                    </Button>
                    }
                    {
                      ((isUSPride || isATL || isRS || (isABCFF && this.context.router.routes[1].path === "mobileSalesOrders")) && !this.state.USPrideCreateLoading) &&
                      <div style={{ marginLeft: '89px' }}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {this.openUSPrideCreate(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="excel_create" />
                        </Button>
                      </div>
                    }
                    {
                      ((isUSPride || isATL || isRS || (isABCFF && this.context.router.routes[1].path === "mobileSalesOrders")) && this.state.USPrideCreateLoading) &&
                      <div style={{ marginLeft: '89px' }}>
                      <SpinnerButton
                        bsStyle="success"
                        disabled={true}
                        icon="fa-plus"
                        translation={<Translate value="creating_orders" />}
                        loading={true}
                        onClick={() => {
                          console.log('loading');
                        }}
                      />
                    </div>
                    }
                    {(isDSQ || isWUFS || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) &&
                      (this.context.router.routes[1].path === "salesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="inbound_with_excel" />
                        </Button>
                      )
                      }
                      {(isEZone) && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="excel_creat" />
                        </Button>
                      )}
                      {(isDSQ || isWUFS || isKDW || isYI || isFBD) &&
                        (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef3.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="outbound_with_excel" />
                        </Button>
                      )
                      }
                      { isABCFF && (this.context.router.routes[1].path === "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("File", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/sales/upload_dsco_shipment?platform=dsco`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => { alert('success'); },
                                  (err) => {
                                    alert(JSON.stringify(err.data));
                                  }
                                );
                            }
                          }}
                          ref="dsco_ref"
                        />
                      )
                    }
                    { isABCFF && (this.context.router.routes[1].path === "outboundOrders") && (
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onClick={(e)=> { e.target.value = null; }}
                        onChange={(e) => {
                          const formData = new FormData();
                          formData.append("File", e.target.files[0]);
                          if (e.target.files[0]) {
                            axios
                              .post(
                                `${ROOT_URL}v2/sales/upload_dsco_shipment?platform=walmartb2b`,
                                formData,
                                {
                                  headers: {
                                    Authorization: `Bearer ${localStorage.getItem(
                                      "token"
                                    )}`,
                                  },
                                },
                              )
                              .then(
                                (res) => { alert('success'); },
                                (err) => {
                                  alert(JSON.stringify(err.data));
                                }
                              );
                          }
                        }}
                        ref="walmartb2b_ref"
                      />
                    )
                  }
                  {
                    (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG || isEZone) &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> {
                            e.target.value = null;
                              }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-so-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Inbound Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef2"
                        />
                      )}
                      {(isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> {
                            e.target.value = null;
                              }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-outbound-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Outbound Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef3"
                        />
                      )}
                      {(isWIZ) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> {
                            e.target.value = null;
                              }}
                          onChange={(e) => {
                            let wURL = `${ROOT_URL}v2/sales/pod/` + this.state.salesOrders.selectedRows[0].SalesOrder_id + `/`;
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  wURL,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("POD uploaded successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef4"
                        />
                      )}
                      {isTN &&
                        (this.context.router.routes[1].path ===
                          "salesOrders") && (
                            // this.renderTNOriginal()
                          <Button
                            bsStyle="success"
                            type="submit"
                            onClick={() => {
                              // this.refs.msoCreateInputRef.click();
                              this.setTNExcelOptionModalVisibility(true);
                            }}
                            disabled={!checkPermission("add_sales_order")}
                          >
                            <em className="fa fa-plus" />
                            <Translate value="excel_create" />
                          </Button>
                        )
                      }
                    {/* {isTN &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef.click();
                          }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="excel" /> (New)
                        </Button>
                      )}
                      {isTN &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRefOriginal.click();
                          }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="excel" /> (Original)
                        </Button>
                      )} */}

                      {/* {(true && isTN && (this.context.router.routes[1].path ===
                        "salesOrders")) &&
                        this.renderTNOriginal()}  */}

                      {(isYI) &&
                      (this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRefabcff.click();
                          }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="excel_create" />
                        </Button>
                      )}

                      {(isYI) &&
                      (this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  // `${ROOT_URL}v2/import_orders_xls`,
                                  `${ROOT_URL}v2/import_orders_abcff`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  }
                                )
                                .then(
                                  (res) => {
                                    alert("MSO Imported Successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days,
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRefabcff"
                        />
                      )}
                      {isTN &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  // `${ROOT_URL}v2/import_orders_xls`,
                                  `${ROOT_URL}v2/tn_order_import_original`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  }
                                )
                                .then(
                                  (res) => {
                                    alert("SO Imported Successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days,
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRefOriginal"
                        />
                      )}

                      { !(isABCFF && this.context.router.routes[1].path === 'outboundOrders') &&
                        <Button
                          bsStyle="warning"
                          type="button"
                          disabled={
                            this.state.salesOrders.selectedRows.length !== 1 ||
                            !checkPermission("change_sales_order")
                          }
                          onClick={(event) => {
                            this.setCurrentSalesOrder(event);
                          }}
                        >
                          <em className="fa fa-pencil" />
                          <Translate value="edit" />
                        </Button>
                      }
                      { !isABCFF &&
                      <Button
                        bsStyle="danger"
                        type="reset"
                        disabled={
                          this.shouldVoidButtonDisable() ||
                          !checkPermission("delete_sales_order")
                        }
                        onClick={() => {
                          this.openCheckAuthorize("void");
                        }}
                      >
                        <em className="fa fa-trash" />
                        <Translate value="void" />
                      </Button>
                    }
                    {
                      ((isDSQ || isWUFS || isATL || isUSPride || isKDW || isYI || isFBD || isWIZ ||
                        (isABCFF && this.context.router.routes[1].path === 'outboundOrders') ||
                        (isFJ && this.context.router.routes[1].path !== 'outboundOrders') || isJTB || isMAG) && !isSW) &&
                      <Button
                        bsStyle="primary"
                        // type="reset"
                        disabled={!this.state.salesOrders.selectedRows.length}
                        onClick={() => {
                          const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesOrder_id);
                          const success = () => {
                            this.refreshSOList();
                          }
                          expressMultipleSOInvoices(soPKs, success);
                        }}
                      >
                        <em className="fa fa-file" />
                        <Translate value="express_invoice" />
                      </Button>
                    }
                    {
                      (isTN) && <Button
                        bsStyle="primary"
                        // type="reset"
                        disabled={!this.state.salesOrders.selectedRows.length}
                        onClick={() => {
                          this.openExpressShipVisibility();
                          // this.confirmExpressShip();
                        }}
                      >
                        <em className="fa fa-file" />
                        <Translate value="express_invoice" />
                      </Button>
                    }

                    {/* padLeft */}
                    {this.renderPrint()}
                    {this.renderShippingIFrame()}
                    {this.renderPackingIFrame()}
                    {this.renderPickingIFrame()}
                    {this.renderSalesOrderIFrame()}
                    {this.renderBolByIdIFrame()}
                    {this.renderBolWithoutLogIFrame()}
                    {this.renderBolLabelIFrame()}
                    {this.renderBolByFbaIFrame()}
                  </ButtonToolbar>
                  <div className="table-filters" style={{ zIndex: 1 }}>
                    {
                      !(isWIZ || isATL || isKDW || isABCFF) &&
                      <label
                        style={{ marginRight: "0px" }}
                        className="control-label"
                      >
                        <Translate value="select_seller" />
                      </label>
                    }
                    {!(isWIZ || isATL || isKDW) && this.renderUsers()}
                    {
                      (isUSPride) &&
                      <label
                        style={{ marginRight: "3px" }}
                        className="control-label"
                      >
                        <Translate value="warehouse" />
                      </label>
                    }
                    {(isUSPride) && this.renderWarehouse()}
                    <ButtonToolbar className="table-buttons">
                      {/* <Button bsStyle='primary' disabled={this.state.salesOrders.selectedRows.length != 1} onClick={this.loadsPost}>
                                  <Translate value="loads_post" />
                                </Button> */}
                      {/* { this.quoteButton() } */}
                      { !(isABCFF && this.context.router.routes[1].path === 'salesOrders') && this.renderExportButton() }
                      { isATL && this.renderExportButtonATL()}
                      { isATL && this.renderExportDetailButton()}
                      { isATL && this.renderOrderExportButtonATL() }
                      { isTN && this.renderExportSelectedButton() }
                      { isCalco && this.renderExportButton("qb") }
                      { isCalco && this.renderEmailPackingButton() }
                      { isMyuMyu && this.renderCreateTaskButton() }
                      { isAFG && this.renderChangeWeightButton() }
                      { isRivera && this.renderPaymentMethodChangeButton() }
                      { !(isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isATL) && this.renderReshipButton() }
                      { !(isDSQ || isWUFS || isKDW || isYI || isFBD || isMAG || isATL || isUSPride || isABCFF ) && this.renderQuoteButton() }
                      { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderQuoteButton() }

                      { isUSPride && this.renderAddTracking() }
                      {/* { isABC && this.renderAssignDriverButton() } */}
                      {/* { isABC && this.renderUpdateNumberButton() } */}
                      { (isCO || isABC) && this.renderPrintBolButton() }
                      { (isCalco || isEcity) && this.renderDriverImageButton() }
                      { isMyuMyu && this.renderChowbusImportButton() }
                      { (isMyuMyu || isAFG) && this.renderDavisPO() }
                      { !(isCalco || isAFG || isABC || isFIT || isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isNBT || isKM || isATL || isSW) && this.renderPrintLabelButton() }

                      { isAPO && this.renderPrintLabelButtonAFG()}

                      { ((isAmzey || isATL) && this.context.router.routes[1].path === 'mobileSalesOrders') && this.renderTeapplixButton()}
                      { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderTeapplixButton()}

                      { this.renderUploadMSOButton() }
                      { isAFM && this.estDeliveryTimeEditButton()}
                      { (isAFG || isFIT || isNBT || isKM) && this.renderPrintLabelButtonAFG() }
                      { (isDSQ || isWUFS || isKDW || isYI || isFBD) && this.renderPrintLabelButtonDSQ()}

                      {/* { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderPrintLabelButtonDSQ()} */}

                      { (isUSPride || isRS) && this.renderPrintLabelUSPride() }
                      { (isUSPride || isRS) && this.renderReprintLabelUSPride() }
                      { ((isDSQ || isWUFS || isKDW || isYI || isFBD) && this.context.router.routes[1].path === 'salesOrders') && this.dsqExcelTemplate() }
                      { ((isDSQ || isWUFS || isKDW || isFBD) && this.context.router.routes[1].path === 'salesOrders') && this.dsqExcelTemplateOb() }

                      { ((isDSQ || isWUFS || isKDW || isYI || isFBD) && this.context.router.routes[1].path === 'outboundOrders') && this.dsqOutboundTemplate()}
                      { ((isABCFF || isYI) && this.context.router.routes[1].path === 'mobileSalesOrders') && this.abcffMsoTemplate()}
                      { (isSW && this.context.router.routes[1].path === 'mobileSalesOrders') && this.swShippingLabel()}
                      { (isSW && this.context.router.routes[1].path === 'mobileSalesOrders') && this.swResync()}
                      { (isJTB && this.context.router.routes[1].path === 'salesOrders') && this.jtbExcelTemplate() }
                      { (isWIZ && this.context.router.routes[1].path === 'salesOrders') && this.wizExcelTemplate() }
                      { (isFJ && this.context.router.routes[1].path === 'salesOrders') && this.fjExcelTemplate() }
                      { (isMAG && this.context.router.routes[1].path === 'salesOrders') && this.magExcelTemplate() }
                      { isEZone && this.magExcelTemplate() }
                      { isWIZ && this.bolList()}
                      { isWIZ && this.generateBOL()}
                      { isMAG && this.renderEmailUpdateButton() }
                      { ((isKDW) && this.context.router.routes[1].path === 'outboundOrders') && this.outboundStatusButton()}

                      {(isWIZ || isKDW) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            // this.refs.msoCreateInputRef4.click();
                            this.openWIZPOD();
                          }}
                          disabled={this.state.salesOrders.selectedRows.length !== 1}
                        >
                          <em className="fa fa-list" />
                          <Translate value="pod" />
                        </Button>
                      )
                      }
                      {(isKDW) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && this.renderEmailPodButton()
                      }

                      {(isKDW) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            // this.refs.msoCreateInputRef4.click();
                            this.openAssignBol();
                          }}
                          disabled={this.state.salesOrders.selectedRows.length < 1}
                        >
                          {/* <em className="fa fa-list" /> */}
                          Assign BOL
                        </Button>
                      )
                      }

                      {(isKDW && (this.context.router.routes[1].path ===
                        "outboundOrders")) &&
                        this.renderPrintBolKDW()
                      }

                      {/* {(isKDW) &&
                             (this.context.router.routes[1].path ===
                              "outboundOrders") && this.renderCompleteOutboundButton()
                      } */}


                      { isOCM && this.renderSendEmailButton()}
                      { (isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.postQuoteButton() }
                      { (isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.getQuoteButton() }
                    </ButtonToolbar>
                  </div>
                  <div className="table-filters-thirdrow" style={{ zIndex: 1, left: isYI ? "0px": "177px" }}>
                    <ButtonToolbar style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                      {/* { isYI && this.postQuoteButton() }
                      { isYI && this.getQuoteButton() } */}
                      { isCalco && this.renderSendSO()}
                      { (isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.createBOLButton() }
                      {(isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.renderYingBOLPrint()}
                      {(isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.postPickupButton()}
                      {(isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.getPickupButton()}

                      {isYI && this.renderCalculateFees()}
                      {(isYI && (this.context.router.routes[1].path ===
                        "outboundOrders")) && this.renderYingPrintFile()}

                      {/* <Dropzone onDrop={this.onDropImage} style={{ 'padding-left': '5px' }} className="upload-button">
                        <Button
                          bsStyle="success"
                          type="submit"
                          disabled={this.state.salesOrders.selectedRows.length !== 1}
                        >
                          <em className="fa fa-file" />
                          <Translate value="upload_image" />
                        </Button>
                      </Dropzone> */}
                      { (isCO || isABC || isTN) && this.renderSubmitBolImageButton() }
                      {  (isABC || isTN) && this.renderUploadPODButton()}
                      {isTN && this.renderSetOpen()}
                      {/* <Dropzone onDrop={this.onDropPOD} style={{ 'padding-left': '5px' }} className="upload-button">
                        <Button
                          bsStyle="success"
                          type="submit"
                          disabled={this.state.salesOrders.selectedRows.length !== 1}
                        >
                          <em className="fa fa-file" />
                          <Translate value="upload_pod" />
                        </Button>
                      </Dropzone> */}
                    </ButtonToolbar>
                  </div>

                  {
                    (isABC && this.context.router.routes[1].path !== 'salesOrders') &&
                    <Row style={{marginTop: '40px'}}>
                      <Col>
                        <label className="col-sm-3" style={{ width: '120px' }}><Translate value="so_num" /></label>
                        <label className="col-sm-3" style={{ width: '120px' }}><Translate value="company" /></label>
                        <label className="col-sm-3" style={{ width: '120px' }}>FBA</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>BOL</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>ISA</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>Ship Status</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>Container</label>
                      </Col>
                    </Row>
                  }
                  {
                    (isABC && this.context.router.routes[1].path !== 'salesOrders') &&
                    <Row>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="SONum" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="CompanyName" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="FBACode" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>

                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="CustomerBOLNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="IsaNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="ShippingStatus" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="ContainerNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                    </Row>
                  }
                  {
                    (isABC && this.context.router.routes[1].path === 'salesOrders') &&
                    <div style={{height: "90px"}}></div>
                  }
                  {
                    ((!isABC || this.context.router.routes[1].path === 'salesOrders')) &&
                    <div
                      id="autosuggest-div"
                      className={(isTN || isABC || isUSPride || isATL || isRS || isDSQ || isWUFS || isEZone || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB || isMAG) && "TNAutosuggest-div"}
                    >
                      <Row style={{ height: "30px" }}>
                        <Col xs={7}>
                          <TypeRadios
                            InvoiceNoSearch
                            TrackingNoSearch={isAFG ? true : null}
                            CPONumSearch={isTN ? true : null}
                            value={this.state.searchType}
                            handleOptionChange={this.handleOptionChange}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <Row>
                            <Col xs={12}>
                              {(this.state.searchType === "invoiceNo"||
                                this.state.searchType === "CPONum" ||
                                this.state.searchType === "Type") &&
                                this.renderInvoiceNoSearchInput()}
                              {isAFG &&
                                this.state.searchType === "trackingNo" &&
                                this.renderTrackingNoSearchInput()}
                              {this.state.searchType !== "invoiceNo" &&
                                this.state.searchType !== "trackingNo" &&
                                this.state.searchType !== "CPONum" &&
                                this.state.searchType !== "Type" &&
                                this.renderAutoSuggest()}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  }
                </div>
                {/* Sales Order Full Table */}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>{" "}
          {/* End Sales Order Full Table  */}
          {/* Sale Order Details */}
          <Row>
            <Col xs={12}>
              { (!isABC && !isFJ && !isDSQ && !isWUFS && !isABCFF && !isKDW && !isYI && !isFBD && !isWIZ && !isJTB && !isMAG) &&
                <h2>
                  <Translate value="sale_order_details" />
                </h2>
              }
              {
                (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isJTB || isFJ) &&
                <h2>
                <Translate value="order_details" />
                </h2>
              }
              {
                (!isABC && !isFJ && !isMAG) &&
                <Panel className="details-table-collapse-fix">
                  {this.renderProductsTable()}
                </Panel>
              }
              { isFJ &&
                <Panel className="details-table-collapse-fix">
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderProductsTable()}
                </Panel>
              }

              { (isMAG || isKDW) &&
                <h2>
                  <Translate value="container_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                  {/* <div style={{marginLeft: '100px'}}>                   */}
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{marginLeft: '50px'}}
                    disabled={!this.state.magSalesOrderDetail.SalesOrder_id}
                    onClick={(event) => {
                      this.saveMagStuff(event);
                    }}
                  >
                    <em className="fa fa-save" />
                    <Translate value="save_order_info" />
                  </Button>
                  {/* </div> */}
                </h2>
              }
              { (isMAG || isKDW) &&
                <Panel className="details-table-collapse-fix">
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagContainer()}
                </Panel>
              }
              { (isMAG || isKDW) &&
                <h2>
                  <Translate value="load_pickup_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                </h2>
              }
              { (isMAG || isKDW) &&
                // <Panel className="details-table-collapse-fix">
                  <Panel>
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagLoad()}
                </Panel>
              }
              { (isMAG || isKDW) &&
                <h2>
                  <Translate value="delivery_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                </h2>
              }
              { (isMAG || isKDW) &&
                // <Panel className="details-table-collapse-fix">
                <Panel>
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagDelivery()}
                </Panel>
              }
              { (isMAG || isKDW) &&
                <h2>
                  <Translate value="empty_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                </h2>
              }
              { (isMAG || isKDW) &&
              // <Panel style={{marginBottom: '200px'}} className="details-table-collapse-fix">
                <Panel style={{marginBottom: '200px'}}>
                {/* {this.renderProductsTableFJ()} */}
                {this.renderMagEmpty()}
              </Panel>
              }
            </Col>
          </Row>{" "}
          {/* Sale Order Details */}
        </Grid>
        <LocationChange
          setModalVisibility={this.setLocationChangeModalVisibility}
          isVisible={this.state.isLocationChangeModalVisible}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={this.handleLocationChangeSuccess}
        />
        <InboundDateChange
          setModalVisibility={this.setInboundDateChangeModalVisibility}
          isVisible={this.state.isInboundDateChangeModalVisibile}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={this.handleLocationChangeSuccess}
        />
        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.changeWeightOpen}
          onCloseClicked={() => {
            this.closeChangeWeight();
          }}
          title={changeWeight}
        >
          <WeightChangeModalMulti
            salesOrderId={singleSalesOrderId}
            fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
            finalShippingWeight={this.state.finalShippingWeight}
            onSave={this.onChangeWeightSubmit}
            onSavePrint={this.onChangeWeightSubmitPrint}
            onChange={this.onShippingWeightChange}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={bolListDialogStyle}
          isVisible={this.state.bolListModalVisibility}
          onCloseClicked={() => {
            this.closebolListModal();
          }}
          title={"BOL List"}
        >
          <BOLListModal
            // salesOrderId={singleSalesOrderId}
            salesOrderNum={singleSalesOrderNum}
            closebolListModal={this.closebolListModal}
            printSalesOrderLabelBOL={this.props.printSalesOrderLabelBOL}
            testHAHA={this.props.printSalesOrderLabel}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={generateBOLStyle}
          isVisible={this.state.generateBOLModalVisibility}
          onCloseClicked={() => {
            this.closeGenerateBOLModal();
          }}
          title={"Generate BOL"}
        >
          <GenerateBOLModal
            salesOrderIdString={salesOrderIdString}
            salesOrderNumString={salesOrderNumString}
            closeGenerateBOLModal={this.closeGenerateBOLModal}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={dsqPrintDialogStyle}
          isVisible={this.state.dsqPrintVisibility}
          onCloseClicked={() => {
            this.closeDSQPrint();
          }}
          title={"Select Products"}
        >
          <DSQPrintModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            singleSalesOrderId={singleSalesOrderId}
            closebolListModal={this.closeDSQPrint}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={wizPODDialogStyle}
          isVisible={this.state.wizPODVisibility}
          onCloseClicked={() => {
            this.closeWIZPOD();
          }}
          title={"POD (" + singleSalesOrderNum + ")"}
        >
          <WIZPODModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            // printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            singleSalesOrderId={singleSalesOrderId}
            closeWIZPOD={this.closeWIZPOD}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.USPrideCreateOpen}
          onCloseClicked={() => {
            this.closeUSPrideCreate();
          }}
          title={<Translate value="create_with_excel" />}
        >
          <div className="centerStyle">
          {isABCFF &&
          <div>
            <Row className="centerStyle">
              <h4>
                Select Customer:
              </h4>
            </Row>
            <Row className="centerStyle">
              <div style={{ width: "250px" }}>
                <Field
                  name="excelCustomer"
                  placeholder={
                    <span style={{ fontStyle: "normal" }}>
                      Select
                    </span>
                  }
                  component={SelectionWithProps}
                  options={this.state.excelCustomerOptions}
                  onSelect={(value) => {
                    this.onUSPrideCustomerChange(value);
                  }}
                />
              </div>
            </Row>
            <br />
            <Row className="centerStyle">
              <h4>
                Select Market:
              </h4>
            </Row>
            <Row className="centerStyle">
              <div style={{ width: "250px" }}>
                <Field
                  name="excelPlatform"
                  placeholder={
                    <span style={{ fontStyle: "normal" }}>
                      Select
                    </span>
                  }
                  component={SelectionWithProps}
                  options={USPridePlatformOptions}
                  onSelect={(value) => {
                    this.onUSPridePlatformChange(value);
                  }}
                />
              </div>
            </Row>
            </div>
          }
          {
            !isABCFF &&
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "154px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                  marginTop: "10px",
                }}
              >
                {this.state.USPridePlatform && this.state.USPridePlatform}
                {!this.state.USPridePlatform && "Select"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {USPridePlatformOptions.map((el) => {
                  return (
                    <MenuItem onClick={() => this.onUSPridePlatformChange(el)}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          }
            <div style={{ marginTop: "10px" }}>
              <Button
                bsStyle="success"
                type="submit"
                onClick={(event) => {
                  this.refs.createSORef.click();
                }}
                disabled={
                  (!checkPermission("add_sales_order")
                  || (USPridePlatform==='') ) && (!isABCFF)
                }
              >
                <em className="fa fa-plus" />
                <Translate value="import_and_submit" />
              </Button>
              <input
                type='file'
                ref='createSORef'
                key={inputFieldKey}
                onClick={(e) => {
                  e.target.value = null;
                }}
                onChange={(e) => {
                  this.setState({ USPrideCreateOpen: false, USPrideCreateLoading: true});
                  const formData = new FormData();
                  const file = e.target.files[0];
                  formData.append('FILE', file);
                  generateSOWithExcelUSPride(formData, USPridePlatform, USPrideCustomer, () => {
                    alert('success, reloading the page');
                    this.refreshSOList();
                    this.onUSPridePlatformChange('');
                    this.onUSPrideCustomerChange('');
                    this.setState({ USPrideCreateLoading: false});
                  }, () => {
                    this.setState({USPrideCreateLoading: false});
                  });
                }}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.paymentMethodModalVisibility}
          onCloseClicked={() => {
            this.closePaymentMethodModal();
          }}
          title={changePaymentMethod}
        >
          <PaymentMethodModal
            salesOrder={this.state.salesOrders.selectedRows}
            successSaved={this.handleSOPaymentMethodSaved}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={altonChildDialogStyle}
          isVisible={this.state.isAltonChildVisible}
          onCloseClicked={() => {
            this.setAltonChildVisibility(false);
          }}
          title={altonChildTitle}
        >
          <AltonChildModal
            altonSelectedProd = {this.state.altonSelectedProd}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createTrackingDialogStyle}
          isVisible={this.state.displayTrackingOpen}
          onCloseClicked={() => {
            this.closeDisplayTracking();
          }}
          title={isAFG ? displayTrackingTitle : displayTrackingTitle2}
        >
          <SplitTrackingNumberModal
            salesOrderId={singleSalesOrderId}
            jmlPrintLabel={this.props.printShippigLabel}
            fetchJmlTracking={this.props.fetchJmlTracking}
            fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={changeTrackingDialogStyle}
          isVisible={this.state.changeTrackingOpen}
          onCloseClicked={() => {
            this.closeChangeTracking();
          }}
          title={"Change Tracking Number"}
        >
           {/* <Row className="centerStyle">
            <h4>
              Change
            </h4>
          </Row>
          <br /> */}
          <Row className="centerStyle">
            <div style={{width: '350px'}}>
              <Input type="text" value={this.state.newTrackingNum} onChange={this.onChangeTrackingNum} />
            </div>
          </Row>
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.changeTrackingConfirm}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
            <Button
              bsStyle="danger"
              onClick={this.closeChangeTracking}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={changeBOLDialogStyle}
          isVisible={this.state.trackingFormOpen}
          onCloseClicked={() => {
            this.closeTrackingForm();
          }}
          title={"Add Tracking Info"}
        >
          <Row>
            <Col sm={4}>
              <label><Translate value="tracking_num" /></label>
            </Col>
            <Col sm={4}>
              <label><Translate value="carrier" /></label>
            </Col>
            <Col sm={4}>
              <label><Translate value="ship_method" /></label>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <Input type="text" value={this.state.trackingformNum} onChange={this.onChangeFormNum} />
            </Col>
            <Col sm={4}>
              <Input type="text" value={this.state.trackingformCarrier} onChange={this.onChangeFormCarrier} />
            </Col>
            <Col sm={4}>
              <Input type="text" value={this.state.trackingformMethod} onChange={this.onChangeFormMethod} />
            </Col>
          </Row>
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.confirmTrackingForm}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={changeShipDateDialogue}
          isVisible={this.state.isExpressShipVisibility}
          onCloseClicked={() => {
            this.closeExpressShipVisibility();
          }}
          title={"Set Ship Date"}
        >
           {/* <Row className="centerStyle">
            <h4>
              Ship Date:
            </h4>
          </Row> */}
          <Row className="centerStyle">
            <label>
              <Translate value="ship_date" />:
            </label>
            <div style={{width: '350px'}}>
            {/* <Input type="text" value={this.state.newTrackingNum} onChange={this.onChangeTrackingNum} /> */}
              {
                GenericDatePicker({
                  setDate: this.setExpressShipDate,
                  selectedDate: this.state.expressShipDate,
                  onChange: (e) => {
                    this.setExpressShipDate(e);
                  },
                })
              }
            </div>
          </Row>
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.confirmExpressShip}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
            <Button
              bsStyle="danger"
              onClick={this.closeExpressShipVisibility}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={changeBOLDialogStyle}
          isVisible={this.state.openAssignBolVisibility}
          onCloseClicked={() => {
            this.closeAssignBol();
          }}
          title={"Assign BOL Number"}
        >
           {/* <Row className="centerStyle">
            <h4>
              Change
            </h4>
          </Row>
          <br /> */}

          <Row>
            <Col sm={6}>
              <label>
                <Translate value="bol_num" />:
              </label>
            </Col>
            <Col sm={6}>
              <label>
                <Translate value="seal_num" />:
              </label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Input type="text" value={this.state.BLNum} onChange={this.onChangeBolNumber} />
            </Col>
            <Col sm={6}>
              <Input type="text" value={this.state.SealNum} onChange={this.onChangeSealNumber} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <label>
                <Translate value="pro_num" />:
              </label>
            </Col>
            <Col sm={6}>
              <label>
                <Translate value="carrier" />:
              </label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Input type="text" value={this.state.ProNum} onChange={this.onChangeProNumber} />
            </Col>
            <Col sm={6}>
              <Input type="text" value={this.state.Carrier} onChange={this.onChangeCarrierNumber} />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <label>
                <Translate value="ship_to_address" />:
              </label>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div  style={{ width: '100px', marginTop: '6px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '350px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.drayageListDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {this.state.drayageListOptions.map(el => {
                      return (
                        <MenuItem onClick={() => handleDrayageChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>

          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.confirmChangeBolNumber}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
            <Button
              bsStyle="danger"
              onClick={this.closeAssignBol}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.printTrackingConfirmOpen}
          onCloseClicked={this.closePrintTrackingConfirm}
          title={<Translate value="confirm_print_tracking" />}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_print_tracking" />
            </h4>
          </Row>
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closePrintTrackingConfirm}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={this.printTrackingConfirm}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createPullSheetDialogStyle}
          isVisible={this.state.changePullSheetOpen}
          onCloseClicked={() => {
            this.closeChangePullSheet();
          }}
          title={changePullSheet}
        >
          <div>
            <Row>
              <Col sm={4}>
                <label>
                  <Translate value="order_amount" />
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Input type="number" onChange={this.onPullSheetChange} />
              </Col>
              <Col sm={3}>
                <ButtonToolbar>
                  <Button
                    bsStyle="primary"
                    onClick={() => {
                      this.onChangePullSheetSubmit();
                    }}
                  >
                    <Translate value="submit" />
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case="confirmPassword"
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={voidNoteDialogStyle}
          isVisible={this.state.voidNoteModalVisibility}
          onCloseClicked={this.closeVoidNote}
          title={voidNoteTitle}
        >
          <Row className="centerStyle">
            <div style={{ width: "250px", marginTop: "10px" }}>
              <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                <Translate value="void_reason" />:
              </p>
              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    width: "250px",
                    backgroundColor: "white",
                    border: "1px solid #555555",
                    color: "black",
                    fontWeight: "400",
                  }}
                >
                  {this.state.voidReason && this.state.voidReason}
                  {!this.state.voidReason && "Select"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {voidReasonSelection.map((el) => {
                    return (
                      <MenuItem onClick={() => this.onVoidReasonChange(el)}>
                        {el.label}
                      </MenuItem>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div
              style={{
                width: "350px",
                marginTop: "20px",
                marginBottom: "35px",
              }}
            >
              <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                <Translate value="void_note" />:
              </p>
              <Input
                type="textarea"
                rows={3}
                onChange={this.onVoidNoteChange}
              />
            </div>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button bsStyle="danger" onClick={this.closeVoidNote} type="button">
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmVoidNote();
              }}
              type="button"
            >
              <Translate value="confirm_void" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={chowbusDialogStyle}
          isVisible={this.state.chowbusModalVisibility}
          onCloseClicked={this.closeChowbusModal}
          title={chowbusImportTitle}
        >
          <Row className="centerStyle" style={{ marginBottom: "20px" }}>
            <label>
              <Translate value="spreadsheet" />
            </label>
            <input
              style={{ border: "1px solid #aaa" }}
              type="file"
              name="file"
              onChange={this.onChangeChowbusImport}
            />
          </Row>

          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeChowbusModal}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmChowbusImport();
              }}
              type="button"
            >
              <Translate value="import" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmReshipOpen}
          onCloseClicked={() => {
            this.closeConfirmReship();
          }}
          title={reshipTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_reship" />
            </h4>
          </Row>
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeConfirmReship}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmReship();
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showDriverImageOpen}
          onCloseClicked={() => {
            this.closeShowDriverImage();
          }}
          title={showImageTitle}
        >
          {this.renderDriverImage()}
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={bolImageDialogue}
          isVisible={this.state.submitImageOpen}
          onCloseClicked={() => { this.closeSubmitImage(); }}
          title={submitImageTitle}
        >
          <BolImagesTable
            salesOrder_id={this.state.salesOrders.selectedRows.length === 1 &&
              this.state.salesOrders.selectedRows[0].SalesOrder_id}
            handleImageClosed={() => { this.closeSubmitImage(); }}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.printBolOpen}
          onCloseClicked={() => {
            this.closePrintBol();
          }}
          title={printBolTitle}
        >
          <Row className="centerStyle">{this.renderAddresses()}</Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={() => {
                this.props.printBolByFba(this.state.bolAddressFBA);
              }}
              type="button"
            >
              <Translate value="Print" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmQuoteOpen}
          onCloseClicked={() => {
            this.closeConfirmQuote();
          }}
          title={quoteTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_assign_customer" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <div style={{ width: "350px" }}>
              <Field
                name="hmmCustomer"
                placeholder={
                  <span style={{ fontStyle: "normal" }}>
                    {this.state.quoteSelectedCustomerPlaceholder}
                  </span>
                }
                component={SelectionWithProps}
                options={this.state.quoteCustomerOptions}
                onSelect={(value) => {
                  this.onQuoteCustomerChange(value);
                }}
              />
            </div>
          </Row>
          <br />
          <br />
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_quote" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeConfirmQuote}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmQuote();
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.davisPOVisibility}
          onCloseClicked={() => {
            this.closeDavisPO();
          }}
          title={davisPOTitle}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_po_to_so_dropship" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closeDavisPO()}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmDavisPO()}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.pridePrintVisibility}
          onCloseClicked={() => {
            this.closePridePrint();
          }}
          title={pridePrintTitle}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4 style={{paddingLeft: '15px', paddingRight: '15px'}}>
              <Translate value="pride_msg_print_shipping" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closePridePrint()}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmPridePrint()}
              type="button"
            >
              <Translate value="continue" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>


        <SkyLightStateless
          dialogStyles={dlMODAL}
          isVisible={this.state.openDownloadModalVisibility}
          onCloseClicked={() => {
            this.closeDownloadModal();
          }}
          title={dlTITLE}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4 style={{paddingLeft: '15px', paddingRight: '15px'}}>
              <Translate value="file_is_ready_to_download" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              href={this.state.openDownloadModalUrl}
              type="button"
            >
              <Translate value="download" />
            </Button>
            <Button
              bsStyle="danger"
              onClick={() => this.closeDownloadModal()}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={xpoMODAL}
          isVisible={this.state.xpoQuoteVisibility}
          onCloseClicked={() => {
            this.closeXPOModal();
          }}
          title={"XPO Logistics Quote"}
        >
        {/* <div>
          <pre style={{width: "650px", overflowY: "scroll", height: "500px"}}>{this.state.xpoString}</pre>
          </div> */}

          <Row>
            <Col xs={12}>
              <label style={{color: 'gray', fontSize: '14px'}}>Pricing Breakdown</label>
              <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && 'Standard Quote for ' + this.state.xpoString.rateQuote.shipmentInfo.bill2Party.address.name}</div>
            </Col>
          </Row>

          <Row>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>Quote Created</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && moment(this.state.xpoString.rateQuote.quoteCreateDate).format('MMM D, YYYY h:mm A') + ' PDT'}</div>
            </Col>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>Quote Confirmation #</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.confirmationNbr}</div>
            </Col>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>Payment Terms</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.paymentTermCd}</div>
            </Col>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>Transit Days</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.transitTime && this.state.xpoString.transitTime.transitDays}</div>
            </Col>
          </Row>

          <Row>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>From</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote &&  this.state.xpoString.rateQuote.shipmentInfo.shipper.address.postalCd + ' ' + this.state.xpoString.rateQuote.shipmentInfo.shipper.address.stateCd + ' (' + this.state.xpoString.rateQuote.shipmentInfo.shipper.address.countryCd + ')'}</div>
            </Col>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>To</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote &&  this.state.xpoString.rateQuote.shipmentInfo.consignee.address.postalCd + ' ' + this.state.xpoString.rateQuote.shipmentInfo.consignee.address.stateCd + ' (' + this.state.xpoString.rateQuote.shipmentInfo.consignee.address.countryCd + ')'}</div>
            </Col>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>Shipping Date</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && moment(this.state.xpoString.rateQuote.shipmentInfo.shipmentDate).format('MMM Do, YYYY')}</div>
            </Col>
            <Col xs={3}>
            <label style={{color: 'gray', fontSize: '14px'}}>Estimated Delivery</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.transitTime && moment(this.state.xpoString.transitTime.estdDlvrDate).format('MMM Do, YYYY')}</div>
            </Col>
          </Row>

          <Row>
            <Col xs={2}>
            <label style={{color: 'gray', fontSize: '14px'}}>Class</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].nmfcClass}</div>
            </Col>
            <Col xs={1}>
            <label style={{color: 'gray', fontSize: '14px'}}>Units</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].pieceCnt}</div>
            </Col>
            <Col xs={2}>
            <label style={{color: 'gray', fontSize: '14px'}}>Length(in)</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.length}</div>
            </Col>
            <Col xs={2}>
            <label style={{color: 'gray', fontSize: '14px'}}>Width(in)</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.width}</div>
            </Col>
            <Col xs={2}>
            <label style={{color: 'gray', fontSize: '14px'}}>Height(in)</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.height}</div>
            </Col>
            <Col xs={2}>
            <label style={{color: 'gray', fontSize: '14px'}}>Weight(lbs)</label>
            <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.commodity[0].grossWeight.weight}</div>
            </Col>
            <Col xs={1}>
            {/* <label style={{color: 'gray', fontSize: '14px'}}>Rate/CWT</label> */}
            {/* <div style={{fontSize: '14px', marginBottom: '15px'}}>{this.state.xpoString.transitTime && moment(this.state.xpoString.transitTime.estdDlvrDate).format('MMM Do, YYYY')}</div> */}
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
            <div style={{fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', marginTop: '10px'}}>Total Net Charge:  ${this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.totCharge[0].amt}</div>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
            <div style={{fontSize: '12px', marginBottom: '15px', color: 'gray'}}>{this.state.xpoString.rateQuote && this.state.xpoString.rateQuote.shipmentInfo.comment}</div>
            </Col>
          </Row>

          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closeXPOModal()}
              type="button"
            >
              <Translate value="close" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={pickupMODAL}
          isVisible={this.state.pickupVisibility}
          onCloseClicked={() => {
            this.closePickupModal();
          }}
          title={"Pickup Info"}
        >
              <div>
                <pre style={{width: "650px", overflowY: "scroll", height: "500px"}}>{this.state.pickupString}</pre>
                </div>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closePickupModal()}
              type="button"
            >
              <Translate value="close" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={pickupSelectionMODAL}
          isVisible={this.state.pickupSelectionVisibility}
          onCloseClicked={() => {
            this.closePickupSelectionModal();
          }}
          title={"Pickup Dates"}
        >
          <div className="centerStyle">
            <Row style={{marginBottom: '10px'}}>
              <Col xs={6}>
                <label>
                  <Translate value="pickup_date" />
                </label>
              </Col>
              {
                GenericDatePicker({
                  setDate: this.setPickupDate,
                  selectedDate: this.state.xpoPickupDate,
                  onChange: (e) => {
                    this.setPickupDate(e);
                  },
                })
              }
            </Row>
            <Row style={{marginBottom: '10px'}}>
              <Col xs={6}>
                <label>
                  <Translate value="ready_date" />
                </label>
              </Col>
              {
                GenericDatePicker({
                  setDate: this.setReadyDate,
                  selectedDate: this.state.xpoReadyDate,
                  onChange: (e) => {
                    this.setReadyDate(e);
                  },
                })
              }
            </Row>
            <Row style={{marginBottom: '10px'}}>
              <Col xs={6}>
                <label>
                  <Translate value="close_date" />
                </label>
              </Col>
              {
                GenericDatePicker({
                  setDate: this.setCloseDate,
                  selectedDate: this.state.xpoCloseDate,
                  onChange: (e) => {
                    this.setCloseDate(e);
                  },
                })
              }
            </Row>
          </div>
          <ButtonToolbar className="button-toolbar-center" style={{marginTop: '20px'}}>
          {/* <Button
              bsStyle="success"
              onClick={() => this.confirmPostPickup()}
              type="button"
            >
              <Translate value="submit" />
            </Button> */}

            <SpinnerButton
              bsStyle="success"
              type="button"
              className="print-btn"
              loading={this.state.pickupLoading}
              // disabled={
              //   selectedRows.length !== 1
              // }
              onClick={() => {
                this.confirmPostPickup();
              }}
              translation={<Translate value="submit" />}
            >
            </SpinnerButton>
            <Button
              bsStyle="danger"
              onClick={() => this.closePickupSelectionModal()}
              type="button"
            >
              <Translate value="close" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.driverListModalVisibility}
          onCloseClicked={this.setDriverListModalVisibility}
          title={"Assign MSOs to Driver"}
        >
          <DriverListModal
            assigningInboundDriver={this.state.assigningInboundDriver}
            assigningOutboundDriver={this.state.assigningOutboundDriver}
            selectedOrders={this.state.salesOrders.selectedRows || []}
            handleSuccess={this.handleAssignSOToDriverSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.isaEditModalVisibility}
          onCloseClicked={this.setISAEditModalVisibility}
          title={"isa number update"}
        >
          <ISAEditModal
            selectedSalesOrder={this.state.salesOrders.selectedRows[0]}
            handleISANoUpdateSuccess={this.handleISANoUpdateSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.ctnEditModalVisibility}
          onCloseClicked={this.setCTNEditModalVisibility}
          title={"ctn number update"}
        >
          <CTNEditModal
            selectedSalesOrder={this.state.salesOrders.selectedRows[0]}
            handleCTNNoUpdateSuccess={this.handleCTNNoUpdateSuccess}
          />
        </SkyLightStateless>
        <DeliveryTimeChange
          isVisible={this.state.deliveryTimeSelectVisible}
          setModalVisibility={this.setDeliveryTimeSelectModalVisibility}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={() => {
            this.setDeliveryTimeSelectModalVisibility();
            this.refreshSOList();
          }}
        />
        <PickupTimeChange
          isVisible={this.state.pickupTimeSelectVisible}
          setModalVisibility={this.setPickupTimeSelectModalVisibility}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={() => {
            this.setPickupTimeSelectModalVisibility();
            this.refreshSOList();
          }}
        />
        <ExcelUploadOption
          isVisible={this.state.isExcelUploadOptionVisible}
          setModalVisibility={this.setTNExcelOptionModalVisibility}
          onSuccess={() => {
            this.refreshSOList();
            this.setTNExcelOptionModalVisibility();
          }}
        />
        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          selectedRows={this.state.salesOrders ? this.state.salesOrders.selectedRows : []}
          source={"SO"}
        />
        <LabelPrintModal
          isVisible={this.state.isLabelPrintModalVisible}
          salesOrders={this.state.salesOrders}
          setModalVisibility={this.setLabelPrintModalVisibility}
          printPickingListPartial={this.props.printPickingListPartial}
        />
        <ShippingRateModal
          isVisible={this.state.isShipingRateVisible}
          setModalVisibility={this.setShippingRateVisibility}
          salesOrders={this.state.salesOrders}
          handleTeapplixPrintClick={this.handleTeapplixPrintClick}
        />
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default SalesOrder;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesOrders.jsx